
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("hU34N", function(module, exports) {
/* AISmartButtonWrapper.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $cozmU = parcelRequire("cozmU");


var $3ricL = parcelRequire("3ricL");


var $9DHhW = parcelRequire("9DHhW");


var $iMnC5 = parcelRequire("iMnC5");


var $hdBxM = parcelRequire("hdBxM");

/* index.tsx generated by @compiled/babel-plugin v2.0.0 */ 



var $cbY7C = parcelRequire("cbY7C");


var $w6R6I = parcelRequire("w6R6I");


var $cXtTj = parcelRequire("cXtTj");


var $iDrrr = parcelRequire("iDrrr");











var $9aRNV = parcelRequire("9aRNV");


var $bXh4X = parcelRequire("bXh4X");

const $922055794f511dc6$export$cb9c0d3b5896f957 = ()=>{
    const { setButtonClickedTimestamp: setButtonClickedTimestamp } = (0, $bXh4X.useAISmartButtonActions)();
    const conversationActionsStoreActions = (0, $9aRNV.useConversationActionsStoreActions)();
    return (0, $cozmU.useMemo)(()=>({
            /**
     * Set the button clicked timestamp for the source.
     */ setButtonClickedTimestamp: (buttonClickedTimestamp)=>{
                setButtonClickedTimestamp(buttonClickedTimestamp);
                conversationActionsStoreActions.setButtonClickedTimestamp(buttonClickedTimestamp);
            }
        }), [
        setButtonClickedTimestamp,
        conversationActionsStoreActions
    ]);
};



var $k9SyR = parcelRequire("k9SyR");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");











var $8lt5O = parcelRequire("8lt5O");


var $bGNkz = parcelRequire("bGNkz");


var $csz0J = parcelRequire("csz0J");


var $6iWVH = parcelRequire("6iWVH");

/**
 * Isomorphic SSR-safe check if code is run in the browser environment
 * so we can use globals like window safely.
 */ const $2b1a131a50aab70e$export$4e09c449d6c407f7 = ()=>{
    try {
        return typeof window !== 'undefined';
    } catch  {
        // Catch possible error that might occur and just return false
        return false;
    }
};



var $7dBf8 = parcelRequire("7dBf8");


var $9O4fI = parcelRequire("9O4fI");


var $aWbI3 = parcelRequire("aWbI3");

function $1fe0fab264b71edc$export$89871c89a47e5ed3() {
    try {
        const raw = (0, $7dBf8.AtlBrowserStorageLocal).getItem((0, $9O4fI.LS_ONBOARDING_HOLDOUT_KEY));
        if (raw === null) return true;
        const state = (0, $aWbI3.parseState)(raw);
        if (state === null) return false;
        if (state.onboardingCompleted || state.exposureCount >= (0, $9O4fI.MAX_ONBOARDING_EXPOSURES)) return false;
        return Date.now() - state.lastSeenAt >= (0, $9O4fI.HOLDOUT_MS);
    } catch  {
        return false;
    }
}






var $gxmD5 = parcelRequire("gxmD5");


var $advdT = parcelRequire("advdT");


var $3LpEG = parcelRequire("3LpEG");

function $21b32c35b15f1d5c$export$47e4355399c5e75() {
    const state = (0, $advdT.getOnboardingHoldoutState)() ?? (0, $gxmD5.DEFAULT_HOLDOUT_STATE);
    if (state.onboardingCompleted || state.exposureCount >= (0, $9O4fI.MAX_ONBOARDING_EXPOSURES)) return;
    (0, $3LpEG.persistState)({
        ...state,
        lastSeenAt: Date.now(),
        exposureCount: state.exposureCount + 1
    });
}


// If productionized - will consider relocating logic to conversion-assistant-onboarding -- tracking ticket: https://hello.jira.atlassian.cloud/browse/MOOG-146
const $6f3dd9bd3fd569ef$var$ELIGIBLE_PAGES = [
    (0, $6iWVH.PageContextType).JIRA_FOR_YOU,
    (0, $6iWVH.PageContextType).JIRA_ISSUE_VIEW,
    (0, $6iWVH.PageContextType).JIRA_PROJECT,
    (0, $6iWVH.PageContextType).CONFLUENCE_PAGE_VIEW,
    (0, $6iWVH.PageContextType).CONFLUENCE_BLOG_VIEW
];
const $6f3dd9bd3fd569ef$var$ELIGIBLE_PRODUCTS = [
    'jira',
    'confluence'
];
const $6f3dd9bd3fd569ef$var$DWELL_TIME_MS = 5000;
const $6f3dd9bd3fd569ef$export$20c376cddbc7272c = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(2);
    const { product: product } = t0;
    if ((0, $2b1a131a50aab70e$export$4e09c449d6c407f7)() && ((0, $iDrrr.fg)("rovo_onboarding_modal_jira_chat_filter_fg") || (0, $iDrrr.fg)("rovo_onboarding_modal_confluence_chat_fg"))) {
        let t1;
        if ($[0] !== product) {
            t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($6f3dd9bd3fd569ef$var$OnboardingEnablementInner, {
                product: product
            });
            $[0] = product;
            $[1] = t1;
        } else t1 = $[1];
        return t1;
    }
    return null;
} : ({ product: product })=>{
    if ((0, $2b1a131a50aab70e$export$4e09c449d6c407f7)() && ((0, $iDrrr.fg)('rovo_onboarding_modal_jira_chat_filter_fg') || (0, $iDrrr.fg)('rovo_onboarding_modal_confluence_chat_fg'))) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($6f3dd9bd3fd569ef$var$OnboardingEnablementInner, {
        product: product
    });
    return null;
};
const $6f3dd9bd3fd569ef$var$OnboardingEnablementInner = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(2);
    const { product: product } = t0;
    let t1;
    if ($[0] !== product) {
        t1 = {
            product: product
        };
        $[0] = product;
        $[1] = t1;
    } else t1 = $[1];
    $6f3dd9bd3fd569ef$var$useOnboardingEnablement(t1);
    return null;
} : ({ product: product })=>{
    $6f3dd9bd3fd569ef$var$useOnboardingEnablement({
        product: product
    });
    return null;
};
const $6f3dd9bd3fd569ef$var$useOnboardingEnablement = (0, $gtMdU.isReactCompilerActivePlatform)() ? function useOnboardingEnablement(t0) {
    const $ = (0, $bDgLe.c)(28);
    const { product: product } = t0;
    const pageContextType = (0, $csz0J.usePageContextType)();
    const { isRovoEnabled: isRovoEnabled } = (0, $8lt5O.useRovoEntitlement)();
    const { mounted: isChatOpen, setIsChatOnboardingMiniModalOpen: setIsChatOnboardingMiniModalOpen } = (0, $bGNkz.useUIStore)();
    const publish = (0, $hdBxM.usePublish)("ai-mate");
    const hasOpenedChatRef = (0, $cozmU.useRef)(false);
    const routeDwellTimerRef = (0, $cozmU.useRef)(null);
    const [hasDwelled, setHasDwelled] = (0, $cozmU.useState)(false);
    const [passesHoldout] = (0, $cozmU.useState)((0, $1fe0fab264b71edc$export$89871c89a47e5ed3));
    let t1;
    bb0: {
        if (product === "jira") {
            let t2;
            if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
                t2 = (0, $iDrrr.fg)("rovo_onboarding_modal_jira_chat_filter_fg");
                $[0] = t2;
            } else t2 = $[0];
            t1 = t2;
            break bb0;
        } else if (product === "confluence") {
            let t2;
            if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
                t2 = (0, $iDrrr.fg)("rovo_onboarding_modal_confluence_chat_fg");
                $[1] = t2;
            } else t2 = $[1];
            t1 = t2;
            break bb0;
        }
        t1 = false;
    }
    const isFeatureGateEnabled = t1;
    let t2;
    if ($[2] !== pageContextType) {
        t2 = $6f3dd9bd3fd569ef$var$ELIGIBLE_PAGES.includes(pageContextType);
        $[2] = pageContextType;
        $[3] = t2;
    } else t2 = $[3];
    const isEligiblePage = t2;
    let t3;
    if ($[4] !== product) {
        t3 = $6f3dd9bd3fd569ef$var$ELIGIBLE_PRODUCTS.includes(product);
        $[4] = product;
        $[5] = t3;
    } else t3 = $[5];
    const isEligibleProduct = t3;
    let t4;
    let t5;
    if ($[6] !== isChatOpen) {
        t4 = ()=>{
            if (isChatOpen && !hasOpenedChatRef.current) hasOpenedChatRef.current = true;
        };
        t5 = [
            isChatOpen
        ];
        $[6] = isChatOpen;
        $[7] = t4;
        $[8] = t5;
    } else {
        t4 = $[7];
        t5 = $[8];
    }
    (0, $cozmU.useEffect)(t4, t5);
    let t6;
    if ($[9] !== isEligiblePage || $[10] !== isEligibleProduct || $[11] !== isFeatureGateEnabled || $[12] !== isRovoEnabled || $[13] !== passesHoldout) {
        t6 = ()=>{
            const shouldSkipTimer = hasOpenedChatRef.current || !isEligiblePage || !isEligibleProduct || !passesHoldout || !isFeatureGateEnabled || !isRovoEnabled;
            if (shouldSkipTimer) return;
            setHasDwelled(false);
            if (routeDwellTimerRef.current) {
                clearTimeout(routeDwellTimerRef.current);
                routeDwellTimerRef.current = null;
            }
            routeDwellTimerRef.current = setTimeout(()=>{
                setHasDwelled(true);
                routeDwellTimerRef.current = null;
            }, $6f3dd9bd3fd569ef$var$DWELL_TIME_MS);
            return ()=>{
                if (routeDwellTimerRef.current) {
                    clearTimeout(routeDwellTimerRef.current);
                    routeDwellTimerRef.current = null;
                }
            };
        };
        $[9] = isEligiblePage;
        $[10] = isEligibleProduct;
        $[11] = isFeatureGateEnabled;
        $[12] = isRovoEnabled;
        $[13] = passesHoldout;
        $[14] = t6;
    } else t6 = $[14];
    let t7;
    if ($[15] !== isEligiblePage || $[16] !== isEligibleProduct || $[17] !== isFeatureGateEnabled || $[18] !== isRovoEnabled || $[19] !== pageContextType || $[20] !== passesHoldout) {
        t7 = [
            pageContextType,
            isRovoEnabled,
            isFeatureGateEnabled,
            isEligiblePage,
            isEligibleProduct,
            passesHoldout
        ];
        $[15] = isEligiblePage;
        $[16] = isEligibleProduct;
        $[17] = isFeatureGateEnabled;
        $[18] = isRovoEnabled;
        $[19] = pageContextType;
        $[20] = passesHoldout;
        $[21] = t7;
    } else t7 = $[21];
    (0, $cozmU.useEffect)(t6, t7);
    const isEligible = isRovoEnabled && isEligiblePage && isEligibleProduct && isFeatureGateEnabled && hasDwelled && !isChatOpen && passesHoldout;
    let t8;
    let t9;
    if ($[22] !== isEligible || $[23] !== product || $[24] !== publish || $[25] !== setIsChatOnboardingMiniModalOpen) {
        t8 = ()=>{
            if (isEligible && !hasOpenedChatRef.current) {
                hasOpenedChatRef.current = true;
                publish({
                    type: "chat-draft",
                    product: product,
                    source: "ai-mate-onboarding",
                    openChat: true,
                    openChatMode: "mini-modal"
                });
                (0, $21b32c35b15f1d5c$export$47e4355399c5e75)();
                setIsChatOnboardingMiniModalOpen(true);
            }
        };
        t9 = [
            isEligible,
            product,
            setIsChatOnboardingMiniModalOpen,
            publish
        ];
        $[22] = isEligible;
        $[23] = product;
        $[24] = publish;
        $[25] = setIsChatOnboardingMiniModalOpen;
        $[26] = t8;
        $[27] = t9;
    } else {
        t8 = $[26];
        t9 = $[27];
    }
    (0, $cozmU.useEffect)(t8, t9);
} : function useOnboardingEnablement({ product: product }) {
    const pageContextType = (0, $csz0J.usePageContextType)();
    const { isRovoEnabled: isRovoEnabled } = (0, $8lt5O.useRovoEntitlement)();
    const { mounted: isChatOpen, setIsChatOnboardingMiniModalOpen: setIsChatOnboardingMiniModalOpen } = (0, $bGNkz.useUIStore)();
    const publish = (0, $hdBxM.usePublish)('ai-mate');
    const hasOpenedChatRef = (0, $cozmU.useRef)(false);
    const routeDwellTimerRef = (0, $cozmU.useRef)(null);
    const [hasDwelled, setHasDwelled] = (0, $cozmU.useState)(false);
    const [passesHoldout] = (0, $cozmU.useState)((0, $1fe0fab264b71edc$export$89871c89a47e5ed3));
    const isFeatureGateEnabled = (0, $cozmU.useMemo)(()=>{
        if (product === 'jira') return (0, $iDrrr.fg)('rovo_onboarding_modal_jira_chat_filter_fg');
        else if (product === 'confluence') return (0, $iDrrr.fg)('rovo_onboarding_modal_confluence_chat_fg');
        return false; // default case, shouldn't ever be reached
    }, [
        product
    ]);
    const isEligiblePage = $6f3dd9bd3fd569ef$var$ELIGIBLE_PAGES.includes(pageContextType);
    const isEligibleProduct = $6f3dd9bd3fd569ef$var$ELIGIBLE_PRODUCTS.includes(product);
    // Track if chat has been opened
    (0, $cozmU.useEffect)(()=>{
        if (isChatOpen && !hasOpenedChatRef.current) hasOpenedChatRef.current = true;
    }, [
        isChatOpen
    ]);
    // Dwell timer effect - only runs when basic eligibility is met
    (0, $cozmU.useEffect)(()=>{
        const shouldSkipTimer = hasOpenedChatRef.current || !isEligiblePage || !isEligibleProduct || !passesHoldout || !isFeatureGateEnabled || !isRovoEnabled;
        if (shouldSkipTimer) return;
        // Reset dwell status when route changes
        setHasDwelled(false);
        // Clear any existing timer
        if (routeDwellTimerRef.current) {
            clearTimeout(routeDwellTimerRef.current);
            routeDwellTimerRef.current = null;
        }
        // Start new timer for current route
        routeDwellTimerRef.current = setTimeout(()=>{
            setHasDwelled(true);
            routeDwellTimerRef.current = null;
        }, $6f3dd9bd3fd569ef$var$DWELL_TIME_MS);
        // Cleanup on unmount or route change
        return ()=>{
            if (routeDwellTimerRef.current) {
                clearTimeout(routeDwellTimerRef.current);
                routeDwellTimerRef.current = null;
            }
        };
    }, [
        pageContextType,
        isRovoEnabled,
        isFeatureGateEnabled,
        isEligiblePage,
        isEligibleProduct,
        passesHoldout
    ]);
    const isEligible = (0, $cozmU.useMemo)(()=>isRovoEnabled && isEligiblePage && isEligibleProduct && isFeatureGateEnabled && hasDwelled && !isChatOpen && passesHoldout, [
        isRovoEnabled,
        isFeatureGateEnabled,
        isEligiblePage,
        isEligibleProduct,
        hasDwelled,
        isChatOpen,
        passesHoldout
    ]);
    (0, $cozmU.useEffect)(()=>{
        if (isEligible && !hasOpenedChatRef.current) {
            hasOpenedChatRef.current = true;
            publish({
                type: 'chat-draft',
                product: product,
                source: 'ai-mate-onboarding',
                openChat: true,
                openChatMode: 'mini-modal'
            });
            (0, $21b32c35b15f1d5c$export$47e4355399c5e75)();
            setIsChatOnboardingMiniModalOpen(true);
        }
    }, [
        isEligible,
        product,
        setIsChatOnboardingMiniModalOpen,
        publish
    ]);
};



var $dPoYT = parcelRequire("dPoYT");


var $93Gae = parcelRequire("93Gae");


var $61R7O = parcelRequire("61R7O");




/**
 * Isomorphic SSR-safe check if code is run in the browser environment
 * so we can use globals like window safely.
 */ const $aff3dfb467c885fa$export$4e09c449d6c407f7 = ()=>{
    try {
        return typeof window !== 'undefined';
    } catch  {
        // Catch possible error that might occur and just return false
        return false;
    }
};


class $6e2bac923eae5182$export$f4380d3820d95f34 {
    get hasTriggers() {
        return Boolean(this.triggerQueue.length);
    }
    addTrigger(featureId, featureName, featureDescription) {
        this.triggerQueue.push({
            nudge_id: crypto.randomUUID(),
            feature_details: {
                feature_id: featureId,
                feature_name: featureName || 'Debug Nudge',
                feature_description: featureDescription || 'A nudge added for debugging'
            },
            cta: {
                cta_action: 'ACTION'
            }
        });
    }
    addConvoStarter(convoStarterLabel) {
        this.triggerQueue.push({
            cta: {
                cta_action: 'CHAT',
                cta_label: convoStarterLabel || 'Debug Convo Starter'
            },
            nudge_id: crypto.randomUUID(),
            feature_details: {
                feature_id: 'convo-starter',
                feature_name: 'Debug Convo Starter',
                feature_description: 'A conversation starter for debugging'
            }
        });
    }
    clear() {
        this.triggerQueue = [];
    }
    useNextTrigger() {
        return this.triggerQueue.shift();
    }
    constructor(){
        this.triggerQueue = [];
    }
}


const $8f0437d4d92bed1c$export$a8ab20a5170c41b3 = ()=>{
    (0, $cozmU.useEffect)(()=>{
        if (!(0, $aff3dfb467c885fa$export$4e09c449d6c407f7)()) return;
        if (!window?.AIX_DEBUG_NUDGE_TRIGGERS) window.AIX_DEBUG_NUDGE_TRIGGERS = new (0, $6e2bac923eae5182$export$f4380d3820d95f34)();
        return ()=>{
            if (window.AIX_DEBUG_NUDGE_TRIGGERS) delete window.AIX_DEBUG_NUDGE_TRIGGERS;
        };
    }, []);
};












var $lJ6db = parcelRequire("lJ6db");





/**
 * Schedules a callback to run after the browser has painted and is idle.
 *
 * Prefers `requestIdleCallback` when available (all modern browsers except Safari < 16.4),
 * which fires during genuine browser idle time — safe for work that must not impact vc90.
 *
 * Falls back to `requestAnimationFrame` which fires after the next paint — still non-blocking
 * and render-safe, just without the "idle" guarantee.
 *
 * Returns a cleanup function that cancels the scheduled callback, suitable for use as a
 * `useEffect` return value to prevent work firing after component unmount.
 *
 * NOTE: `react-ufo` has an internal `scheduleIdleCallback` utility but it is not a public
 * export and is not intended for reuse outside the UFO package. This utility follows the same
 * pattern already used in `platform/packages/navigation/global-side-navigation`.
 */ function $ac1f16b2d505946e$export$9c28ad8c8fd2ff2f(callback) {
    if (typeof requestIdleCallback !== 'undefined') {
        const id = requestIdleCallback(callback);
        return ()=>cancelIdleCallback(id);
    }
    const id = requestAnimationFrame(callback);
    return ()=>cancelAnimationFrame(id);
}


/**
 * Task states where the agent is blocked waiting on user input (plan,
 * disambiguation, or action confirmation). Mirrors the mode-agnostic
 * `isTaskStatusAwaitingUserResponse` helper in
 * `@atlassian/conversation-assistant-ui-components` — inlined here to avoid
 * pulling the UI-components package into the smart-button dependency graph for
 * a single pure predicate. Status alone is sufficient: the AWAITING_* codes are
 * only produced by max-mode conversations, so no mode check is required.
 * (TREX-1890 / TREX-1892)
 */ function $957d07ec48bc7f6c$var$isTaskStatusAwaitingUserResponse(taskStatus) {
    return taskStatus === 'AWAITING_DISAMBIGUATION' || taskStatus === 'AWAITING_PLAN_CONFIRMATION' || taskStatus === 'AWAITING_ACTION_CONFIRMATION';
}
/** A conversation is "awaiting input" when any of its tasks is blocked on the user. */ function $957d07ec48bc7f6c$var$isChannelAwaitingInput(channel) {
    return !!channel.tasks?.some((task)=>$957d07ec48bc7f6c$var$isTaskStatusAwaitingUserResponse(task.status));
}
const $957d07ec48bc7f6c$var$LOOK_BACK_PERIOD_MS = 129600000;
const $957d07ec48bc7f6c$var$CACHE_TTL_MS = 300000;
const $957d07ec48bc7f6c$var$IN_PROGRESS_POLL_BASE_INTERVAL_MS = 60000;
const $957d07ec48bc7f6c$var$IN_PROGRESS_POLL_BACKOFF_STEP_MS = 30000;
const $957d07ec48bc7f6c$var$IN_PROGRESS_POLL_ATTEMPTS_PER_STEP = 5;
const $957d07ec48bc7f6c$var$IN_PROGRESS_POLL_MAX_INTERVAL_MS = $957d07ec48bc7f6c$var$CACHE_TTL_MS;
const $957d07ec48bc7f6c$var$CACHE_KEY = 'rovo-button-unread-status-v1';
// The cache key is shared across hook instances, so network writes need a shared ordering guard.
let $957d07ec48bc7f6c$var$nextFetchSequence = 0;
let $957d07ec48bc7f6c$var$latestWrittenFetchSequence = 0;
function $957d07ec48bc7f6c$var$normalizeCachedResult(result) {
    const unreadCount = result.unreadCount ?? (result.hasUnread ? 1 : 0);
    return {
        hasUnread: unreadCount > 0,
        unreadCount: unreadCount,
        inProgressCount: result.inProgressCount ?? 0,
        awaitingInputCount: result.awaitingInputCount ?? 0,
        mostRecentAwaitingInput: result.mostRecentAwaitingInput ?? null,
        mostRecentInProgress: result.mostRecentInProgress ?? null,
        mostRecentUnread: result.mostRecentUnread ?? null,
        isStatusReady: true
    };
}
function $957d07ec48bc7f6c$var$hasConversationStatus(result) {
    return result.unreadCount > 0 || result.inProgressCount > 0 || result.awaitingInputCount > 0;
}
function $957d07ec48bc7f6c$var$areConversationStatusesEqual(a, b) {
    if (a === b) return true;
    if (!a || !b) return false;
    return a.id === b.id && a.name === b.name && ('completedAt' in a ? a.completedAt : null) === ('completedAt' in b ? b.completedAt : null);
}
function $957d07ec48bc7f6c$var$areSummariesEqual(a, b) {
    return a.hasUnread === b.hasUnread && a.unreadCount === b.unreadCount && a.inProgressCount === b.inProgressCount && a.awaitingInputCount === b.awaitingInputCount && $957d07ec48bc7f6c$var$areConversationStatusesEqual(a.mostRecentUnread, b.mostRecentUnread) && $957d07ec48bc7f6c$var$areConversationStatusesEqual(a.mostRecentInProgress, b.mostRecentInProgress) && $957d07ec48bc7f6c$var$areConversationStatusesEqual(a.mostRecentAwaitingInput, b.mostRecentAwaitingInput) && a.isStatusReady === b.isStatusReady;
}
function $957d07ec48bc7f6c$var$readCache() {
    if (!(0, $aff3dfb467c885fa$export$4e09c449d6c407f7)()) return null;
    try {
        // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
        const raw = sessionStorage.getItem($957d07ec48bc7f6c$var$CACHE_KEY);
        if (!raw) return null;
        const parsed = JSON.parse(raw);
        const { cachedAt: cachedAt = 0, stale: stale, ...result } = parsed;
        const isExpired = !cachedAt || Date.now() - cachedAt >= $957d07ec48bc7f6c$var$CACHE_TTL_MS;
        const isStale = stale === true || isExpired;
        const normalizedResult = $957d07ec48bc7f6c$var$normalizeCachedResult(result);
        const data = {
            ...normalizedResult,
            // A stale empty cache may have become outdated while chat was open. Keep
            // empty-state UI hidden until revalidation confirms there is still no status.
            // A cached status remains immediately useful and can stay visible while stale.
            isStatusReady: !isStale || $957d07ec48bc7f6c$var$hasConversationStatus(normalizedResult)
        };
        return {
            data: data,
            isStale: isStale
        };
    } catch  {
        return null;
    }
}
function $957d07ec48bc7f6c$var$writeCache(result, cachedAt = Date.now()) {
    const { isStatusReady: _isStatusReady, ...cacheableResult } = result;
    const toStore = {
        ...cacheableResult,
        cachedAt: cachedAt
    };
    if (!(0, $aff3dfb467c885fa$export$4e09c449d6c407f7)()) return;
    try {
        // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
        sessionStorage.setItem($957d07ec48bc7f6c$var$CACHE_KEY, JSON.stringify(toStore));
    } catch  {
    // sessionStorage may be unavailable (private browsing quota, etc.) — fail silently
    }
}
function $957d07ec48bc7f6c$export$5ea316be7514c402() {
    if (!(0, $aff3dfb467c885fa$export$4e09c449d6c407f7)()) return;
    try {
        // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
        const raw = sessionStorage.getItem($957d07ec48bc7f6c$var$CACHE_KEY);
        if (!raw) return;
        const parsed = JSON.parse(raw);
        const { isStatusReady: _isStatusReady, ...cacheableResult } = $957d07ec48bc7f6c$var$normalizeCachedResult(parsed);
        const cachedAt = parsed.cachedAt ?? Date.now();
        const toStore = {
            ...cacheableResult,
            cachedAt: cachedAt,
            stale: true
        };
        // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
        sessionStorage.setItem($957d07ec48bc7f6c$var$CACHE_KEY, JSON.stringify(toStore));
    } catch  {
    // sessionStorage may be unavailable — fail silently
    }
}
const $957d07ec48bc7f6c$var$NO_UNREAD = {
    hasUnread: false,
    unreadCount: 0,
    inProgressCount: 0,
    awaitingInputCount: 0,
    mostRecentAwaitingInput: null,
    mostRecentInProgress: null,
    mostRecentUnread: null,
    isStatusReady: false
};
function $957d07ec48bc7f6c$export$e34a0a17cdc941c7({ enabled: enabled, mode: mode }) {
    const initialCacheRef = (0, $cozmU.useRef)(enabled ? $957d07ec48bc7f6c$var$readCache() : null);
    const [status, setStatus] = (0, $cozmU.useState)(()=>enabled ? initialCacheRef.current?.data ?? $957d07ec48bc7f6c$var$NO_UNREAD : $957d07ec48bc7f6c$var$NO_UNREAD);
    const { conversationAssistantConfig: conversationAssistantConfig, product: product } = (0, $61R7O.useAISmartButtonContext)();
    const baseUrl = conversationAssistantConfig?.assistanceServiceConfig?.baseUrl;
    const headers = conversationAssistantConfig?.assistanceServiceConfig?.headers;
    const headersKey = headers ? JSON.stringify(headers) : '';
    const assistanceService = (0, $cozmU.useMemo)(()=>new (0, $lJ6db.AssistanceServiceImpl)({
            product: product,
            experienceId: 'ai-mate',
            baseUrl: baseUrl,
            headers: headers
        }), // headersKey is the stable proxy for the headers object (which gets a new
    // identity every render from context); keying on it prevents assistanceService
    // from being recreated on every render, which otherwise re-runs the fetch
    // effect on each hover-induced re-render.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        product,
        baseUrl,
        headersKey
    ]);
    const fetchAndUpdateRef = (0, $cozmU.useRef)(async ()=>{});
    const isFetchingRef = (0, $cozmU.useRef)(false);
    const hasMarkedInitialCacheStaleRef = (0, $cozmU.useRef)(false);
    const prevModeRef = (0, $cozmU.useRef)(mode);
    (0, $cozmU.useEffect)(()=>{
        if (!enabled) {
            // Reset the in-flight guard so the next enable can fetch immediately.
            // Without this, a fetch that was in-flight when enabled flipped to false
            // would leave isFetchingRef stuck as true, blocking the next fetch.
            isFetchingRef.current = false;
            hasMarkedInitialCacheStaleRef.current = false;
            setStatus($957d07ec48bc7f6c$var$NO_UNREAD);
            return;
        }
        let cancelled = false;
        const fetchAndUpdate = async (options)=>{
            const forceNetwork = options?.forceNetwork ?? false;
            const cacheResult = forceNetwork ? null : $957d07ec48bc7f6c$var$readCache();
            if (cacheResult) {
                if (!cancelled) setStatus((prev)=>{
                    return $957d07ec48bc7f6c$var$areSummariesEqual(prev, cacheResult.data) ? prev : cacheResult.data;
                });
                if (!cacheResult.isStale) return;
            // Stale cache is still the last good read value: keep it visible
            // while a background fetch refreshes every derived field.
            }
            if (isFetchingRef.current) return;
            isFetchingRef.current = true;
            try {
                const fetchSequence = ++$957d07ec48bc7f6c$var$nextFetchSequence;
                const { items: channels } = await assistanceService.getConversationChannels();
                if (fetchSequence < $957d07ec48bc7f6c$var$latestWrittenFetchSequence) return;
                const now = Date.now();
                // Conversations blocked waiting on user input (max-mode plan /
                // disambiguation / action confirmation), most-recent first so the UI can
                // deep-link to the single awaiting chat. (TREX-1890 / TREX-1892)
                //
                // Apply the SAME recency guard as the unread filter below: task arrays in
                // the channels payload are cumulative and can retain a historical
                // AWAITING_* entry after the user has already responded, so without a
                // look-back window an old/resolved conversation would be counted forever
                // (inflating the count, making the pill wrongly interactive, and
                // deep-linking to a stale conversation id). (TREX-1917)
                const awaitingInput = channels.filter((channel)=>{
                    if (!$957d07ec48bc7f6c$var$isChannelAwaitingInput(channel)) return false;
                    const timestamp = channel.last_message_timestamp;
                    return !!timestamp && now - new Date(timestamp).getTime() < $957d07ec48bc7f6c$var$LOOK_BACK_PERIOD_MS;
                }).sort((a, b)=>{
                    const aTime = a.last_message_timestamp ? new Date(a.last_message_timestamp).getTime() : 0;
                    const bTime = b.last_message_timestamp ? new Date(b.last_message_timestamp).getTime() : 0;
                    return bTime - aTime;
                });
                const awaitingInputCount = awaitingInput.length;
                const mostRecentAwaitingInput = awaitingInput[0] ? {
                    id: String(awaitingInput[0].id),
                    name: awaitingInput[0].name ?? null
                } : null;
                const awaitingInputIds = new Set(awaitingInput.map((channel)=>String(channel.id)));
                const recentInProgress = channels.filter((channel)=>channel.last_agent_message_status === 'IN_PROGRESS' && !awaitingInputIds.has(String(channel.id))).sort((a, b)=>{
                    const aTime = a.last_message_timestamp ? new Date(a.last_message_timestamp).getTime() : 0;
                    const bTime = b.last_message_timestamp ? new Date(b.last_message_timestamp).getTime() : 0;
                    return bTime - aTime;
                });
                const inProgressCount = recentInProgress.length;
                const mostRecentInProgress = recentInProgress[0] ? {
                    id: String(recentInProgress[0].id),
                    name: recentInProgress[0].name ?? null,
                    completedAt: recentInProgress[0].last_message_timestamp ?? null
                } : null;
                const recentUnread = channels.filter((channel)=>{
                    // readStatus === false is the explicit unread signal; null means a legacy/old
                    // conversation with no read-tracking — exclude it to avoid false positives.
                    const isUnread = channel.readStatus === false;
                    // Awaiting-input conversations have their own count/label and must not
                    // also inflate the unread count.
                    const isAwaitingInput = awaitingInputIds.has(String(channel.id));
                    // Only show indicator for completed agent responses — exclude IN_PROGRESS (streaming),
                    // FAILED, CANCELLED, and legacy channels without this field.
                    const hasSuccessfulAgentMessage = channel.last_agent_message_status === 'SUCCESSFUL';
                    const timestamp = channel.last_message_timestamp;
                    const isRecent = !!timestamp && now - new Date(timestamp).getTime() < $957d07ec48bc7f6c$var$LOOK_BACK_PERIOD_MS;
                    return isUnread && !isAwaitingInput && hasSuccessfulAgentMessage && isRecent;
                }).sort((a, b)=>{
                    const aTime = a.last_message_timestamp ? new Date(a.last_message_timestamp).getTime() : 0;
                    const bTime = b.last_message_timestamp ? new Date(b.last_message_timestamp).getTime() : 0;
                    return bTime - aTime;
                });
                const mostRecentUnread = recentUnread[0] ? {
                    id: String(recentUnread[0].id),
                    name: recentUnread[0].name ?? null,
                    completedAt: recentUnread[0].last_message_timestamp ?? null
                } : null;
                const result = {
                    hasUnread: recentUnread.length > 0,
                    unreadCount: recentUnread.length,
                    inProgressCount: inProgressCount,
                    awaitingInputCount: awaitingInputCount,
                    mostRecentAwaitingInput: mostRecentAwaitingInput,
                    mostRecentInProgress: mostRecentInProgress,
                    mostRecentUnread: mostRecentUnread,
                    isStatusReady: true
                };
                // Keep sessionStorage and hook consumers on the same freshly processed summary.
                $957d07ec48bc7f6c$var$latestWrittenFetchSequence = fetchSequence;
                $957d07ec48bc7f6c$var$writeCache(result, now);
                if (!cancelled) setStatus(result);
            } catch  {
                // Preserve the last displayed status. If an empty stale cache was waiting for
                // revalidation, release that pending state so the empty-state UI is not hidden
                // indefinitely when the refresh fails.
                if (!cancelled) setStatus((prev)=>prev.isStatusReady ? prev : {
                        ...prev,
                        isStatusReady: true
                    });
            } finally{
                isFetchingRef.current = false;
            }
        };
        fetchAndUpdateRef.current = fetchAndUpdate;
        if (!hasMarkedInitialCacheStaleRef.current) {
            // Keep the initial cached render instant, then force the normal
            // post-paint fetch path to revalidate even when the cache is within TTL.
            $957d07ec48bc7f6c$export$5ea316be7514c402();
            hasMarkedInitialCacheStaleRef.current = true;
        }
        // Defer the initial fetch until after paint/idle (post-vc90 safe)
        const cancelPostPaint = (0, $ac1f16b2d505946e$export$9c28ad8c8fd2ff2f)(()=>{
            fetchAndUpdate();
        });
        // Refresh on window focus when the cache is stale/expired, while preserving the cached value.
        const unbindFocus = (0, $aff3dfb467c885fa$export$4e09c449d6c407f7)() ? (0, $cbY7C.bindAll)(window, [
            {
                type: 'focus',
                listener: ()=>{
                    fetchAndUpdate();
                }
            }
        ]) : null;
        return ()=>{
            cancelled = true;
            cancelPostPaint();
            unbindFocus?.();
        };
    }, [
        assistanceService,
        enabled
    ]);
    (0, $cozmU.useEffect)(()=>{
        if (!enabled) {
            prevModeRef.current = mode;
            return;
        }
        if (mode === undefined && prevModeRef.current !== undefined) {
            // User closed the sidebar — mark cache stale and re-fetch in the background
            $957d07ec48bc7f6c$export$5ea316be7514c402();
            fetchAndUpdateRef.current();
        }
        prevModeRef.current = mode;
    }, [
        mode,
        enabled
    ]);
    const hasInProgress = status.inProgressCount > 0;
    (0, $cozmU.useEffect)(()=>{
        // Killswitch is read once per polling lifecycle (intentionally not an effect dep): toggling it
        // affects future in-progress polling cycles, not one that is already active. Exposure is
        // suppressed because this is an operational killswitch, not a measured experiment.
        const isPollingDisabled = (0, $cXtTj.default).getExperimentValue('rovo_button_in_progress_polling_killswitch', 'value', false, {
            fireExperimentExposure: false
        });
        if (isPollingDisabled || !enabled || !hasInProgress || !(0, $aff3dfb467c885fa$export$4e09c449d6c407f7)()) return;
        const refetch = ()=>{
            // Force a real network fetch, skipping the cache read.
            fetchAndUpdateRef.current({
                forceNetwork: true
            });
        };
        // Poll while a message is in progress, backing off over time: start at the base
        // interval and add a step every N attempts, until the interval reaches the cache
        // window — at which point polling stops (the next focus/mount/sidebar-close refreshes).
        let attemptsAtCurrentInterval = 0;
        let currentIntervalMs = $957d07ec48bc7f6c$var$IN_PROGRESS_POLL_BASE_INTERVAL_MS;
        let timeoutId;
        const scheduleNext = ()=>{
            timeoutId = setTimeout(onTick, currentIntervalMs);
        };
        function onTick() {
            // Skip ticks while the tab is backgrounded: do not fetch and do not advance the
            // backoff; simply re-schedule at the same interval.
            if (document.visibilityState !== 'visible') {
                scheduleNext();
                return;
            }
            refetch();
            attemptsAtCurrentInterval += 1;
            if (attemptsAtCurrentInterval >= $957d07ec48bc7f6c$var$IN_PROGRESS_POLL_ATTEMPTS_PER_STEP) {
                attemptsAtCurrentInterval = 0;
                currentIntervalMs += $957d07ec48bc7f6c$var$IN_PROGRESS_POLL_BACKOFF_STEP_MS;
            }
            // Once the interval reaches the cache window, stop polling entirely.
            if (currentIntervalMs >= $957d07ec48bc7f6c$var$IN_PROGRESS_POLL_MAX_INTERVAL_MS) return;
            scheduleNext();
        }
        scheduleNext();
        const unbindVisibility = (0, $cbY7C.bindAll)(document, [
            {
                type: 'visibilitychange',
                listener: ()=>{
                    // Catch-up refetch when the tab becomes visible again. This does not count
                    // toward the backoff and does not alter the pending schedule.
                    if (document.visibilityState === 'visible') refetch();
                }
            }
        ]);
        return ()=>{
            clearTimeout(timeoutId);
            unbindVisibility();
        };
    }, [
        enabled,
        hasInProgress
    ]);
    return status;
}




var $eM9tg = parcelRequire("eM9tg");





const $16eeddbb409c6f7d$var$AsyncFullScreenModal = /*#__PURE__*/ (0, $cozmU.lazy)(()=>(parcelRequire("fJkiR")).then((module)=>({
            default: module.AIFullScreenModal
        })));
const $16eeddbb409c6f7d$export$6b0f0aea468bfe6e = ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($16eeddbb409c6f7d$var$AsyncFullScreenModal, null));
};






var $jXwf7 = parcelRequire("jXwf7");

















var $76xix = parcelRequire("76xix");


var $fBd2O = parcelRequire("fBd2O");

const $7b3aafe6b2e763b0$var$styles = {
    miniModalMainContainer: "_0bjKvDKxmn _39xV02Hakr _0KLXruqi9L _2OUyjtGk8v _3iDTPbQ4SZ _0hPCNLDIqT _37wbyuDIqT",
    rovoIcon: "_39xV02pJKa _0jFU0VpJKa"
};
const $7b3aafe6b2e763b0$export$a33efecb32878e39 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(8);
    const { topOffset: topOffset, isNav4Enabled: isNav4Enabled } = t0;
    const t1 = `min(320px, calc(100vh - ${topOffset}px))`;
    let t2;
    if ($[0] !== t1) {
        t2 = {
            height: t1
        };
        $[0] = t1;
        $[1] = t2;
    } else t2 = $[1];
    let t3;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
            xcss: $7b3aafe6b2e763b0$var$styles.rovoIcon
        }, /*#__PURE__*/ $cozmU.createElement((0, $76xix.LazyAnimatedRovoIcon), {
            alt: "",
            testId: "rovo-loading-animation"
        }));
        $[2] = t3;
    } else t3 = $[2];
    let t4;
    if ($[3] !== t2) {
        t4 = /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
            testId: "conversation-assistant-mini-modal-main-container",
            xcss: $7b3aafe6b2e763b0$var$styles.miniModalMainContainer,
            style: t2
        }, t3);
        $[3] = t2;
        $[4] = t4;
    } else t4 = $[4];
    let t5;
    if ($[5] !== isNav4Enabled || $[6] !== t4) {
        t5 = /*#__PURE__*/ $cozmU.createElement((0, $fBd2O.MainWrapper), {
            mode: "mini-modal",
            isNav4Enabled: isNav4Enabled
        }, t4);
        $[5] = isNav4Enabled;
        $[6] = t4;
        $[7] = t5;
    } else t5 = $[7];
    return t5;
} : ({ topOffset: topOffset, isNav4Enabled: isNav4Enabled })=>{
    return /*#__PURE__*/ $cozmU.createElement((0, $fBd2O.MainWrapper), {
        mode: "mini-modal",
        isNav4Enabled: isNav4Enabled
    }, /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        testId: "conversation-assistant-mini-modal-main-container",
        xcss: $7b3aafe6b2e763b0$var$styles.miniModalMainContainer,
        style: {
            height: `min(320px, calc(100vh - ${topOffset}px))`
        }
    }, /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        xcss: $7b3aafe6b2e763b0$var$styles.rovoIcon
    }, /*#__PURE__*/ $cozmU.createElement((0, $76xix.LazyAnimatedRovoIcon), {
        alt: "",
        testId: "rovo-loading-animation"
    }))));
};






const $3bba9b7c8f6d5693$var$LazyAIMiniModal = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).lazy(()=>(parcelRequire("dmmOX")).then((module)=>({
            default: module.AIMiniModal
        })));

const $3bba9b7c8f6d5693$export$1f1f17d801cbb952 = ()=>{
    (parcelRequire("dmmOX")).then((module)=>({
            default: module.AIMiniModal
        }));
};
const $3bba9b7c8f6d5693$export$f36d8da28b18d2c1 = ()=>{
    const context = (0, $61R7O.useAISmartButtonContext)();
    const mousetrapRef = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useRef(null);
    const setContainerRef = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useCallback((node)=>{
        mousetrapRef.current?.reset();
        if (!node) return;
        mousetrapRef.current = new (0, (/*@__PURE__*/$parcel$interopDefault($jXwf7)))(node);
    }, []);
    const suppressKeyPress = (event)=>{
        mousetrapRef.current?.bind(event.key.toLocaleLowerCase(), (e)=>e.stopPropagation());
    };
    const miniModal = (0, $cozmU.useMemo)(()=>{
        // 48px = nav header height, 8px = object sidebar bottom padding, 16px = AI smart button bottom margin, 8px = extra margin so it doesn't align with nav header
        const defaultTopOffset = 80;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Suspense, {
            fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7b3aafe6b2e763b0$export$a33efecb32878e39), {
                topOffset: context.topOffset || defaultTopOffset,
                isNav4Enabled: context.isNav4Enabled
            })
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($3bba9b7c8f6d5693$var$LazyAIMiniModal, null));
    }, [
        context
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        ref: setContainerRef,
        onKeyDown: suppressKeyPress,
        testId: "ai-smart-button-mini-modal-wrapper"
    }, context.overrideMiniModalWrapper ? context.overrideMiniModalWrapper(miniModal) : miniModal);
};


/* index.tsx generated by @compiled/babel-plugin v2.0.0 */ 






var $kSwu1 = parcelRequire("kSwu1");


var $1hQ0e = parcelRequire("1hQ0e");


var $iODl6 = parcelRequire("iODl6");


var $4o0zT = parcelRequire("4o0zT");







var $1l0kj = parcelRequire("1l0kj");

var $hBYtq = parcelRequire("hBYtq");


var $lpNn5 = parcelRequire("lpNn5");
















const $16bdf26a3ae62ad8$var$DAILY_BRIEF_NAME_PREFIXES = [
    'daily brief:',
    'get-daily-brief',
    '/get-daily-brief'
];
function $16bdf26a3ae62ad8$var$toDailyBriefUnread(mostRecentUnread) {
    const lowerName = mostRecentUnread?.name?.toLowerCase() ?? '';
    const isDailyBrief = $16bdf26a3ae62ad8$var$DAILY_BRIEF_NAME_PREFIXES.some((prefix)=>lowerName.startsWith(prefix));
    if (!isDailyBrief || !mostRecentUnread) return null;
    return {
        conversationId: mostRecentUnread.id,
        name: mostRecentUnread.name,
        completedAt: mostRecentUnread.completedAt ?? null
    };
}
function $16bdf26a3ae62ad8$export$187304f0ff940bd0({ enabled: enabled, mostRecentUnread: mostRecentUnread }) {
    const { setDailyBriefUnread: setDailyBriefUnread } = (0, $bXh4X.useAISmartButtonActions)();
    (0, $cozmU.useEffect)(()=>{
        if (!enabled) return;
        setDailyBriefUnread($16bdf26a3ae62ad8$var$toDailyBriefUnread(mostRecentUnread));
    }, [
        mostRecentUnread,
        enabled,
        setDailyBriefUnread
    ]);
}







/* index.tsx generated by @compiled/babel-plugin v2.0.0 */ /* eslint-disable @atlaskit/ui-styling-standard/enforce-style-prop */ /* eslint-disable @atlaskit/ui-styling-standard/no-classname-prop */ 
var $hekY6 = parcelRequire("hekY6");





var $57p4j = parcelRequire("57p4j");

var $kUXcd = parcelRequire("kUXcd");







/* index.tsx generated by @compiled/babel-plugin v2.0.0 */ 



const $dc4d53193fd0f0e0$var$LazyAIActionShortcut = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).lazy(()=>(parcelRequire("kAp8y")).then((module)=>({
            default: module.AIActionShortcut
        })));
const $dc4d53193fd0f0e0$export$2966057c342a8370 = ({ action: action })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($dc4d53193fd0f0e0$var$LazyAIActionShortcut, {
        action: action
    });
};


const $dcd69e36b7d8d2dc$var$styles = {
    actionsWrapperStyles: "_2mHwu81Y8M _1mT5xdWVPG _4ApkO2N91d _0adFHs2ADO _0Bm75GPgdg _3iDTPbQ4SZ _0aFT5vbt8w _0hPCNLz9WS"
};
const $dcd69e36b7d8d2dc$export$fa41c7e6bc1d5bc2 = ({ actionShortcuts: actionShortcuts, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave })=>{
    const { product: product, analyticsAttributes: analyticsAttributes } = (0, $61R7O.useAISmartButtonContext)();
    const { fireRovoButtonUIEvent: fireRovoButtonUIEvent } = (0, $eM9tg.useRovoButtonEventsInstrumentation)();
    const { isExiting: isExiting } = (0, $kUXcd.useExitingPersistence)();
    (0, $cozmU.useEffect)(()=>{
        fireRovoButtonUIEvent({
            source: analyticsAttributes?.productPage ?? product,
            action: 'rendered',
            actionSubject: 'rovoButton',
            actionSubjectId: 'aiRovoActionShortcutMenu',
            attributes: {
                ...analyticsAttributes,
                version: 'refresh',
                actionIdsRendered: actionShortcuts.map((action)=>action.id)
            },
            product: product
        });
    }, [
        actionShortcuts,
        analyticsAttributes,
        product,
        fireRovoButtonUIEvent
    ]);
    return(// Suspense needed here to avoid rendering empty menu when action shortcuts are loading (since they are lazy loaded)
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Suspense, {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $57p4j.default), {
        duration: "large",
        entranceDirection: "right",
        exitDirection: "right"
    }, (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            ref: props.ref,
            className: (0, $hekY6.default)([
                $dcd69e36b7d8d2dc$var$styles.actionsWrapperStyles,
                props.className
            ]),
            style: {
                ...props.style,
                // Prevent hover events during exit animation to avoid flicker.
                // ExitingPersistence keeps elements mounted while exiting, so without this,
                // the exiting menu can re-trigger hover handlers and cause flickering.
                pointerEvents: isExiting ? 'none' : undefined
            },
            onMouseEnter: onMouseEnter,
            onMouseLeave: onMouseLeave,
            onFocus: onMouseEnter,
            onBlur: (e)=>{
                if (!e.currentTarget.contains(e.relatedTarget)) // Only call onMouseLeave if focus is moving outside the container
                onMouseLeave();
            }
        }, actionShortcuts.map((action)=>{
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dc4d53193fd0f0e0$export$2966057c342a8370), {
                key: action.id,
                action: action
            });
        })))));
};



var $ExetK = parcelRequire("ExetK");

/* index.tsx generated by @compiled/babel-plugin v2.0.0 */ 









var $mW7G5 = parcelRequire("mW7G5");








var $2TzCj = parcelRequire("2TzCj");




/**
 * Platform hook for nudge suppression. Wired internally by `ai-proactive-nudge` — do not call directly.
 *
 * Suppression key is read from `nudge.nudgeContext.suppressionKey` (set by the consumer).
 */ 





/**
 * Debug API exposed on `window.ROVO_NUDGE_SUPPRESSION` for inspecting nudge suppression state.
 *
 * Usage:
 *   window.ROVO_NUDGE_SUPPRESSION.list()
 *   window.ROVO_NUDGE_SUPPRESSION.isSuppressed('nudge-id', 'optional-key')
 *   window.ROVO_NUDGE_SUPPRESSION.clearAll()
 *   window.ROVO_NUDGE_SUPPRESSION.clearNudge('nudge-id')
 *   window.ROVO_NUDGE_SUPPRESSION.showAllowlist()
 */ 

var $4lg64 = parcelRequire("4lg64");





/**
 * Browser-session-storage-backed store tracking which nudges have already been shown.
 * Entries expire after 7 days; capped at 500 to prevent unbounded growth.
 *
 * Two separate sessionStorage keys are used:
 *   - `rovo-button-nudges-suppression` (STRICTLY_NECESSARY): tracks nudges suppressed via
 *     explicit user interaction (click, dismiss, auto-dismiss timer). Written with
 *     `setStrictlyNecessaryItem` so it is always available regardless of consent.
 *   - `rovo-button-nudges-ots` (Functional): tracks nudges suppressed via OTS
 *     (opportunity-to-see — 5 second passive view). Written with `setItem` so it is
 *     consent-gated.
 */ const $a2c9d9d152c18ea2$var$STORAGE_KEY = 'rovo-button-nudges-suppression';
const $a2c9d9d152c18ea2$var$OTS_STORAGE_KEY = 'rovo-button-nudges-ots';
// Bounded growth constraints.
const $a2c9d9d152c18ea2$var$MAX_ENTRIES = 500;
const $a2c9d9d152c18ea2$var$MAX_AGE_MS = 604800000;
/**
 * Drop expired entries and, if still over the cap, drop the oldest by expiry.
 * Returns a new map (pure).
 */ const $a2c9d9d152c18ea2$var$pruneEntries = (map, now = Date.now())=>{
    // 1. Drop expired entries.
    const fresh = new Map();
    for (const [key, expiresAt] of map)if (expiresAt > now) fresh.set(key, expiresAt);
    // 2. If still over cap, drop oldest entries by expiry.
    if (fresh.size <= $a2c9d9d152c18ea2$var$MAX_ENTRIES) return fresh;
    const sorted = Array.from(fresh.entries()).sort((a, b)=>a[1] - b[1]);
    return new Map(sorted.slice(sorted.length - $a2c9d9d152c18ea2$var$MAX_ENTRIES));
};
/** Parse a sessionStorage value as a SuppressionMap. Returns an empty Map on miss/corrupt. */ const $a2c9d9d152c18ea2$var$parseFromStorage = (storageKey)=>{
    try {
        const raw = (0, $7dBf8.AtlBrowserStorageSession).getItem(storageKey);
        if (!raw) return new Map();
        const arr = JSON.parse(raw);
        if (Array.isArray(arr) && arr.every((e)=>Array.isArray(e) && typeof e[0] === 'string' && typeof e[1] === 'number')) return new Map(arr);
    } catch  {
    // Corrupt JSON — start fresh.
    }
    return new Map();
};
// ---------------------------------------------------------------------------
// Suppression store — STRICTLY_NECESSARY (click, dismiss, auto-dismiss timer)
// ---------------------------------------------------------------------------
/** In-memory cache for the suppression store. Prevents JSON.parse on every render. */ let $a2c9d9d152c18ea2$var$memoryCache = null;
/** Best-effort write of a suppression map to sessionStorage. Memory cache is always source of truth. */ const $a2c9d9d152c18ea2$var$writeToStorage = (map)=>{
    try {
        (0, $7dBf8.AtlBrowserStorageSession).setStrictlyNecessaryItem($a2c9d9d152c18ea2$var$STORAGE_KEY, JSON.stringify(Array.from(map.entries())));
    } catch  {
    // Best-effort. Memory cache is always source of truth.
    }
};
const $a2c9d9d152c18ea2$export$589c6f1e710012ab = ()=>{
    if (!(0, $aff3dfb467c885fa$export$4e09c449d6c407f7)()) return new Map();
    if ($a2c9d9d152c18ea2$var$memoryCache) // Defensive copy so callers cannot mutate the cache.
    return new Map($a2c9d9d152c18ea2$var$memoryCache);
    const parsed = $a2c9d9d152c18ea2$var$parseFromStorage($a2c9d9d152c18ea2$var$STORAGE_KEY);
    $a2c9d9d152c18ea2$var$memoryCache = parsed;
    return new Map(parsed);
};
const $a2c9d9d152c18ea2$export$c7717ac3db4d7c5e = (suppressionKey)=>{
    if (!(0, $aff3dfb467c885fa$export$4e09c449d6c407f7)()) return;
    const current = $a2c9d9d152c18ea2$export$589c6f1e710012ab();
    // Guard against silently refreshing TTL on an already-suppressed key.
    if (current.has(suppressionKey)) return;
    const next = new Map(current);
    next.set(suppressionKey, Date.now() + $a2c9d9d152c18ea2$var$MAX_AGE_MS);
    const pruned = $a2c9d9d152c18ea2$var$pruneEntries(next);
    $a2c9d9d152c18ea2$var$memoryCache = pruned;
    $a2c9d9d152c18ea2$var$writeToStorage(pruned);
};
const $a2c9d9d152c18ea2$export$836b363c9c8b0260 = (suppressionKey)=>{
    const expiresAt = $a2c9d9d152c18ea2$export$589c6f1e710012ab().get(suppressionKey);
    return expiresAt !== undefined && expiresAt > Date.now();
};
const $a2c9d9d152c18ea2$export$a42fc9133d653f82 = (suppressionKey)=>{
    if (!(0, $aff3dfb467c885fa$export$4e09c449d6c407f7)()) return;
    const next = new Map($a2c9d9d152c18ea2$export$589c6f1e710012ab());
    next.delete(suppressionKey);
    $a2c9d9d152c18ea2$var$memoryCache = next;
    $a2c9d9d152c18ea2$var$writeToStorage(next);
    const nextOts = new Map($a2c9d9d152c18ea2$export$50c9b6d7d14b4832());
    nextOts.delete(suppressionKey);
    $a2c9d9d152c18ea2$var$otsMemoryCache = nextOts;
    $a2c9d9d152c18ea2$var$writeOtsToStorage(nextOts);
};
const $a2c9d9d152c18ea2$export$6ff673702fe4ede7 = ()=>{
    if (!(0, $aff3dfb467c885fa$export$4e09c449d6c407f7)()) return;
    $a2c9d9d152c18ea2$var$memoryCache = new Map();
    $a2c9d9d152c18ea2$var$otsMemoryCache = new Map();
    try {
        (0, $7dBf8.AtlBrowserStorageSession).removeItem($a2c9d9d152c18ea2$var$STORAGE_KEY);
    } catch  {
    // Best-effort.
    }
    try {
        (0, $7dBf8.AtlBrowserStorageSession).removeItem($a2c9d9d152c18ea2$var$OTS_STORAGE_KEY);
    } catch  {
    // Best-effort.
    }
};
// ---------------------------------------------------------------------------
// OTS store — Functional / consent-gated (5-second passive view)
// ---------------------------------------------------------------------------
/** In-memory cache for the OTS store. Prevents JSON.parse on every render. */ let $a2c9d9d152c18ea2$var$otsMemoryCache = null;
/** Best-effort write of the OTS map to sessionStorage. Memory cache is always source of truth. */ const $a2c9d9d152c18ea2$var$writeOtsToStorage = (map)=>{
    try {
        (0, $7dBf8.AtlBrowserStorageSession).setItem($a2c9d9d152c18ea2$var$OTS_STORAGE_KEY, JSON.stringify(Array.from(map.entries())));
    } catch  {
    // Best-effort. Memory cache is always source of truth.
    }
};
const $a2c9d9d152c18ea2$export$50c9b6d7d14b4832 = ()=>{
    if (!(0, $aff3dfb467c885fa$export$4e09c449d6c407f7)()) return new Map();
    if ($a2c9d9d152c18ea2$var$otsMemoryCache) // Defensive copy so callers cannot mutate the cache.
    return new Map($a2c9d9d152c18ea2$var$otsMemoryCache);
    const parsed = $a2c9d9d152c18ea2$var$parseFromStorage($a2c9d9d152c18ea2$var$OTS_STORAGE_KEY);
    $a2c9d9d152c18ea2$var$otsMemoryCache = parsed;
    return new Map(parsed);
};
const $a2c9d9d152c18ea2$export$f2eb0568d964142 = (suppressionKey)=>{
    if (!(0, $aff3dfb467c885fa$export$4e09c449d6c407f7)()) return;
    const current = $a2c9d9d152c18ea2$export$50c9b6d7d14b4832();
    // Guard against silently refreshing TTL on an already-recorded key.
    if (current.has(suppressionKey)) return;
    const next = new Map(current);
    next.set(suppressionKey, Date.now() + $a2c9d9d152c18ea2$var$MAX_AGE_MS);
    const pruned = $a2c9d9d152c18ea2$var$pruneEntries(next);
    $a2c9d9d152c18ea2$var$otsMemoryCache = pruned;
    $a2c9d9d152c18ea2$var$writeOtsToStorage(pruned);
};
const $a2c9d9d152c18ea2$export$f283fabd519e7f50 = (suppressionKey)=>{
    const expiresAt = $a2c9d9d152c18ea2$export$50c9b6d7d14b4832().get(suppressionKey);
    return expiresAt !== undefined && expiresAt > Date.now();
};


const $418e59b84dd9e58c$export$4ec21f37bfe88c35 = ()=>{
    if (!(0, $aff3dfb467c885fa$export$4e09c449d6c407f7)()) return;
    window.ROVO_NUDGE_SUPPRESSION = {
        list: ()=>{
            const now = Date.now();
            const entries = (0, $a2c9d9d152c18ea2$export$589c6f1e710012ab)();
            return Array.from(entries.entries()).filter(([, expiresAt])=>expiresAt > now).map(([key, expiresAt])=>({
                    key: key,
                    expiresAt: expiresAt,
                    expiresAtISO: new Date(expiresAt).toISOString()
                }));
        },
        isSuppressed: (nudgeId, keyPart)=>{
            const fullKey = keyPart ? `${nudgeId}:${keyPart}` : nudgeId;
            const entries = (0, $a2c9d9d152c18ea2$export$589c6f1e710012ab)();
            const expiresAt = entries.get(fullKey);
            return expiresAt !== undefined && expiresAt > Date.now();
        },
        clearAll: ()=>{
            (0, $a2c9d9d152c18ea2$export$6ff673702fe4ede7)();
        },
        clearNudge: (nudgeId)=>{
            const entries = (0, $a2c9d9d152c18ea2$export$589c6f1e710012ab)();
            Array.from(entries.keys()).filter((key)=>key === nudgeId || key.startsWith(`${nudgeId}:`)).forEach((key)=>(0, $a2c9d9d152c18ea2$export$a42fc9133d653f82)(key));
        },
        showAllowlist: ()=>{
            // eslint-disable-next-line no-console
            console.table(Array.from((0, $4lg64.SUPPRESSION_ALLOWLIST)).map((id)=>({
                    id: id
                })));
        }
    };
};
const $418e59b84dd9e58c$export$3ab59d0b121ec1ad = ()=>{
    if (!(0, $aff3dfb467c885fa$export$4e09c449d6c407f7)()) return;
    if (window.ROVO_NUDGE_SUPPRESSION) delete window.ROVO_NUDGE_SUPPRESSION;
};






const $f1a36fe710ec585f$export$634f47956d1161e8 = ()=>{
    const isSuppressed = (0, $cozmU.useCallback)((id, suppressionKey)=>{
        if (!(0, $iDrrr.fg)('rovo_button_nudge_suppression')) return false;
        const key = (0, $4lg64.getSuppressionKey)(id, suppressionKey);
        if (key === null) return false;
        return (0, $a2c9d9d152c18ea2$export$836b363c9c8b0260)(key) || (0, $a2c9d9d152c18ea2$export$f283fabd519e7f50)(key);
    }, []);
    const addSuppressedNudge = (0, $cozmU.useCallback)((id, suppressionKey)=>{
        if (!(0, $iDrrr.fg)('rovo_button_nudge_suppression')) return;
        const key = (0, $4lg64.getSuppressionKey)(id, suppressionKey);
        if (key === null) return;
        (0, $a2c9d9d152c18ea2$export$c7717ac3db4d7c5e)(key);
    }, []);
    const addOtsSuppressedNudge = (0, $cozmU.useCallback)((id, suppressionKey)=>{
        if (!(0, $iDrrr.fg)('rovo_button_nudge_suppression')) return;
        const key = (0, $4lg64.getSuppressionKey)(id, suppressionKey);
        if (key === null) return;
        (0, $a2c9d9d152c18ea2$export$f2eb0568d964142)(key);
    }, []);
    // Expose debug API on window for QA.
    (0, $cozmU.useEffect)(()=>{
        if (!(0, $iDrrr.fg)('rovo_button_nudge_suppression')) return;
        (0, $418e59b84dd9e58c$export$4ec21f37bfe88c35)();
        return ()=>{
            (0, $418e59b84dd9e58c$export$3ab59d0b121ec1ad)();
        };
    }, []);
    return {
        isSuppressed: isSuppressed,
        addSuppressedNudge: addSuppressedNudge,
        addOtsSuppressedNudge: addOtsSuppressedNudge
    };
};



/**
 * Determines whether the current surface uses the nudge recommendation pipeline.
 *
 * Surfaces that return `true` will trigger a call to the `/proactive` API to fetch
 * nudge recommendations — which handles eligibility checking, content generation,
 * and ranking of registered nudges.
 *
 * Surfaces that return `false` bypass the recommendation pipeline entirely and
 * display registered nudges directly based on consumer-defined eligibility.
 */ const $3181de404c199fd8$export$cbdc338e17cb49af = ({ product: product, pageUrl: pageUrl, isLiveDoc: isLiveDoc, isLiveViewMode: isLiveViewMode })=>{
    if (product !== 'confluence') return false;
    if (pageUrl.includes('/wiki/search')) return false;
    if (isLiveDoc && !isLiveViewMode) return false;
    return true;
};



var $02lCe = parcelRequire("02lCe");









// TODO: Extract and use factory pattern for different trigger types.
const $b8e13bf21dbf6d85$var$ROVO_BUTTON_TRIGGER_TYPE = 'ROVO_BUTTON_NUDGE_PAGE_LOAD';
const $b8e13bf21dbf6d85$var$CONVO_AI_URL = '/gateway/api/assist/api/ai/v2/ai-feature/proactive';
const $b8e13bf21dbf6d85$export$921bdedcb199d207 = async ({ triggerId: triggerId, pageUrl: pageUrl, product: product })=>{
    if ((0, $aff3dfb467c885fa$export$4e09c449d6c407f7)() && window.AIX_DEBUG_NUDGE_TRIGGERS?.hasTriggers) return {
        triggers: [
            {
                recommendations: [
                    {
                        recommendation_details: window.AIX_DEBUG_NUDGE_TRIGGERS?.useNextTrigger()
                    }
                ]
            }
        ]
    };
    const request = {
        ai_feature_input: {
            triggers: [
                {
                    trigger_id: triggerId,
                    trigger_details: {
                        page_url: pageUrl
                    },
                    trigger_type: $b8e13bf21dbf6d85$var$ROVO_BUTTON_TRIGGER_TYPE
                }
            ]
        }
    };
    const response = await fetch($b8e13bf21dbf6d85$var$CONVO_AI_URL, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json;charset=UTF-8',
            'X-Product': product,
            'X-Experience-Id': 'proactive-ai-rovo-button'
        },
        body: JSON.stringify(request)
    });
    if (!response.ok) throw new Error(`Error fetching agent recommendations and convo starters, status code: ${response.status}`);
    // Allow error to raise if response is not valid JSON
    // Allow undefined to be returned if ai_feature_output is not present
    return (await response.json())?.ai_feature_output;
};


const $a7a1cafecc8b013c$var$DEFAULT_NUDGE_RECOMMENDATION_CACHE_TTL_MS = 600000;
const $a7a1cafecc8b013c$var$getNudgeRecommendationCacheTTL = ()=>(0, $cXtTj.default).getExperimentValue('page_catchup_cache_ttl', 'value', $a7a1cafecc8b013c$var$DEFAULT_NUDGE_RECOMMENDATION_CACHE_TTL_MS);
const $a7a1cafecc8b013c$var$isPageCatchupCacheTTLExperimentEnabled = (hasPageCatchupNudge)=>{
    if (!hasPageCatchupNudge) return false;
    return (0, $cXtTj.default).getExperimentValue('add_cache_ttl_for_page_catchup_nudge_experiment', 'isEnabled', false);
};
const $a7a1cafecc8b013c$export$dbee8b6a491a53c = (triggerId, shouldTrigger, pageUrl, product, hasPageCatchupNudge = false, isLiveDoc = false, isLiveViewMode = false)=>{
    const [error, setError] = (0, $cozmU.useState)();
    const [loading, setLoading] = (0, $cozmU.useState)(true);
    const [recommendations, setRecommendations] = (0, $cozmU.useState)(undefined);
    const [previousRequestCache, setPreviousRequestCache] = (0, $cozmU.useState)({});
    const makeNudgeRecommendationsRequest = (0, $cozmU.useCallback)(async ()=>{
        const isSamePageRequest = pageUrl === previousRequestCache.pageUrl;
        const isDuplicateRequestWithinCacheTTL = isSamePageRequest && typeof previousRequestCache.cachedAt === 'number' && Date.now() - previousRequestCache.cachedAt < $a7a1cafecc8b013c$var$getNudgeRecommendationCacheTTL();
        const shouldSkipDuplicatePageRequest = $a7a1cafecc8b013c$var$isPageCatchupCacheTTLExperimentEnabled(hasPageCatchupNudge) ? isDuplicateRequestWithinCacheTTL : isSamePageRequest;
        if (!(0, $3181de404c199fd8$export$cbdc338e17cb49af)({
            product: product,
            pageUrl: pageUrl,
            isLiveDoc: isLiveDoc,
            isLiveViewMode: isLiveViewMode
        })) {
            setLoading(false);
            return;
        }
        if (!product || // invalid request parameter
        !shouldTrigger || // unsupported, no nudges to recommend
        shouldSkipDuplicatePageRequest // prevent duplicate page requests
        ) {
            setLoading(false);
            return;
        }
        // Begin new request under valid conditions
        if (!loading && product && shouldTrigger && !shouldSkipDuplicatePageRequest) {
            setLoading(true);
            setError(undefined);
            setRecommendations(undefined);
            return;
        }
        try {
            const response = await (0, $b8e13bf21dbf6d85$export$921bdedcb199d207)({
                triggerId: triggerId,
                pageUrl: pageUrl,
                product: product
            });
            setRecommendations(response?.triggers.flatMap((trigger)=>trigger.recommendations.map((recommendation)=>recommendation.recommendation_details)));
            setError(undefined);
        } catch (error) {
            setRecommendations(undefined);
            setError(error);
        } finally{
            setPreviousRequestCache({
                pageUrl: pageUrl,
                cachedAt: Date.now()
            });
            setLoading(false);
        }
    }, [
        loading,
        pageUrl,
        previousRequestCache,
        product,
        shouldTrigger,
        triggerId,
        hasPageCatchupNudge,
        isLiveDoc,
        isLiveViewMode
    ]);
    (0, $cozmU.useEffect)(()=>{
        makeNudgeRecommendationsRequest();
    }, [
        loading,
        makeNudgeRecommendationsRequest
    ]);
    return (0, $cozmU.useMemo)(()=>({
            recommendations: loading ? undefined : recommendations,
            loading: loading,
            error: error
        }), [
        loading,
        error,
        recommendations
    ]);
};






var $mfdwv = parcelRequire("mfdwv");







const $869050cb11b05549$export$ff61339971a5979d = (recommendation)=>{
    const label = recommendation.cta.cta_label;
    const contextId = recommendation.context?.context_id;
    if (!label || !contextId) return undefined;
    return {
        id: (0, $02lCe.CONVO_STARTER_ID),
        title: label,
        icon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($mfdwv))), {
                label: ""
            }),
        type: 'convo-starter-action',
        staticPrompt: label,
        starterType: 'static',
        handleType: (0, $6iWVH.HandleActionType).Chat,
        nudgeContext: {
            id: (0, $02lCe.CONVO_STARTER_ID),
            suppressionKey: contextId
        }
    };
};


const $36cc6fb65874f595$export$17110c9fdd9f02a6 = (nudge, recommendation)=>{
    if (nudge.type === 'convo-starter-action') {
        const enriched = (0, $869050cb11b05549$export$ff61339971a5979d)(recommendation);
        if (!enriched) return undefined;
        return {
            ...enriched,
            recommendationNudgeId: nudge.recommendationNudgeId
        };
    }
    return nudge;
};


const $d05590d3ac370b21$export$6c62f9c964ed3ae0 = (recommendations, availableNudges)=>{
    for (const recommendation of recommendations){
        // Primary match: nudge registered with id matching the BE feature_id
        const matchedNudge = availableNudges.find((nudge)=>nudge.id === recommendation.feature_details.feature_id);
        // Fallback match: nudge registered with nudgeContext.id matching the BE feature_id.
        // This exists because some nudge types use nudgeContext.id instead of id for matching —
        // a data model inconsistency that should be unified.
        const matchedNudgeByContextId = availableNudges.find((action)=>action.nudgeContext?.id === recommendation.feature_details.feature_id);
        if (matchedNudge) {
            const enriched = (0, $36cc6fb65874f595$export$17110c9fdd9f02a6)({
                ...matchedNudge,
                recommendationNudgeId: recommendation.nudge_id
            }, recommendation);
            if (enriched) return enriched;
        }
        if (matchedNudgeByContextId) {
            const enriched = (0, $36cc6fb65874f595$export$17110c9fdd9f02a6)({
                ...matchedNudgeByContextId,
                recommendationNudgeId: recommendation.nudge_id
            }, recommendation);
            if (enriched) return enriched;
        }
    }
    return undefined;
};












/**
 * The state only resets when:
 * - Location Changes: User navigates to a different page
 * - Page Refresh: Browser refreshes the page (global variables reset)
 * What Doesn't Reset the State
 * - Component Re-renders: State persists
 * - Component Unmount/Remount: State persists (this is what you want)
 * - Button Disappears/Reappears: State persists
 */ let $1b19a472abe2ebd8$var$globalAcceptedNudges = [];
let $1b19a472abe2ebd8$var$globalDismissedNudges = [];
const $1b19a472abe2ebd8$export$2dd8f6b7dbe1b931 = ()=>{
    $1b19a472abe2ebd8$var$globalAcceptedNudges = [];
    $1b19a472abe2ebd8$var$globalDismissedNudges = [];
};
const $1b19a472abe2ebd8$export$2bad233bdabe73c4 = ()=>{
    const { setNudges: setNudges } = (0, $bXh4X.useAISmartButtonActions)();
    const [location, setLocation] = (0, $cozmU.useState)((0, $aff3dfb467c885fa$export$4e09c449d6c407f7)() ? window.location.pathname : undefined);
    const [acceptedNudges, setAcceptedNudges] = (0, $cozmU.useState)($1b19a472abe2ebd8$var$globalAcceptedNudges);
    const [dismissedNudges, setDismissedNudges] = (0, $cozmU.useState)($1b19a472abe2ebd8$var$globalDismissedNudges);
    // Helper functions
    const addAcceptedNudge = (0, $cozmU.useCallback)((id)=>{
        setAcceptedNudges((prev)=>{
            if (!prev.includes(id)) {
                const newNudges = [
                    ...prev,
                    id
                ];
                $1b19a472abe2ebd8$var$globalAcceptedNudges = newNudges;
                return newNudges;
            }
            return prev;
        });
    }, []);
    const addDismissedNudge = (0, $cozmU.useCallback)((id)=>{
        setDismissedNudges((prev)=>{
            if (!prev.includes(id)) {
                const newNudges = [
                    ...prev,
                    id
                ];
                $1b19a472abe2ebd8$var$globalDismissedNudges = newNudges;
                return newNudges;
            }
            return prev;
        });
    }, []);
    const clearState = (0, $cozmU.useCallback)(()=>{
        setNudges([]);
        setAcceptedNudges([]);
        setDismissedNudges([]);
        $1b19a472abe2ebd8$var$globalAcceptedNudges = [];
        $1b19a472abe2ebd8$var$globalDismissedNudges = [];
    }, [
        setNudges
    ]);
    const handleLocationChange = (0, $cozmU.useCallback)(()=>{
        if (!(0, $aff3dfb467c885fa$export$4e09c449d6c407f7)()) return;
        if (location !== window.location.pathname) {
            setLocation(window.location.pathname);
            clearState();
        }
    }, [
        clearState,
        location,
        setLocation
    ]);
    (0, $cozmU.useEffect)(()=>{
        if (!(0, $aff3dfb467c885fa$export$4e09c449d6c407f7)()) return;
        const originalPushState = window.history.pushState;
        const originalReplaceState = window.history.replaceState;
        window.history.pushState = function(...args) {
            originalPushState.apply(this, args);
            handleLocationChange();
        };
        window.history.replaceState = function(...args) {
            originalReplaceState.apply(this, args);
            handleLocationChange();
        };
        const unbind = (0, $cbY7C.bindAll)(window, [
            {
                type: 'popstate',
                listener: handleLocationChange
            }
        ]);
        return ()=>{
            if (!(0, $aff3dfb467c885fa$export$4e09c449d6c407f7)()) return;
            unbind();
            window.history.pushState = originalPushState;
            window.history.replaceState = originalReplaceState;
        };
    }, [
        handleLocationChange
    ]);
    return {
        acceptedNudges: acceptedNudges,
        dismissedNudges: dismissedNudges,
        addAcceptedNudge: addAcceptedNudge,
        addDismissedNudge: addDismissedNudge,
        clearState: clearState
    };
};


const $257691f193cbe091$var$messages = (0, $kSwu1.defineMessages)({
    convoStarterSubheader: {
        id: "ai-smart-button.convo-starter.nudge.subheader",
        defaultMessage: "Open Rovo chat with this page-specific starter"
    }
}); // Lazy load to avoid loading useRovoActionTrigger when there's no active nudge

const $257691f193cbe091$var$LazyAIProactiveNudge = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).lazy(()=>(parcelRequire("1j4Hw")).then((module)=>({
            default: module.AIProactiveNudge
        })));
const $257691f193cbe091$export$50a342ac0fc7ff57 = ({ onActiveNudgeChange: onActiveNudgeChange })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const { product: product, pageMode: pageMode, isLiveViewMode: isLiveViewMode } = (0, $61R7O.useAISmartButtonContext)();
    const isLiveDoc = pageMode === 'live';
    const [triggerId] = (0, $cozmU.useState)(()=>crypto.randomUUID());
    const selectedNudges = (0, $k9SyR.useAINudges)();
    const shouldTrigger = Boolean(selectedNudges?.length);
    const hasPageCatchupNudge = selectedNudges?.some((nudge)=>nudge.nudgeContext?.id === 'content-catchup') ?? false;
    const pageUrl = (0, $aff3dfb467c885fa$export$4e09c449d6c407f7)() ? `${window.location.origin}${window.location.pathname}` : '';
    const { recommendations: recommendations, loading: loading, error: error } = (0, $a7a1cafecc8b013c$export$dbee8b6a491a53c)(triggerId, shouldTrigger, pageUrl, product, hasPageCatchupNudge, isLiveDoc, isLiveViewMode);
    const { acceptedNudges: acceptedNudges, dismissedNudges: dismissedNudges, addAcceptedNudge: addAcceptedNudge, addDismissedNudge: addDismissedNudge } = (0, $1b19a472abe2ebd8$export$2bad233bdabe73c4)();
    const { isSuppressed: isSuppressed, addSuppressedNudge: addSuppressedNudge, addOtsSuppressedNudge: addOtsSuppressedNudge } = (0, $f1a36fe710ec585f$export$634f47956d1161e8)();
    const { setConvoStarterActionPrompt: setConvoStarterActionPrompt } = (0, $9aRNV.useConversationActionsStoreActions)(); // Hold the active nudge for the page load. Resets on navigation.
    const [activeNudge, setActiveNudge] = (0, $cozmU.useState)(null);
    const [isExitingForReplacement, setIsExitingForReplacement] = (0, $cozmU.useState)(false);
    const [replacementNudgeSequence, setReplacementNudgeSequence] = (0, $cozmU.useState)(0); // Keep transition refs outside the effect dependencies so clearing the active nudge
    // does not immediately re-pin the next resolved nudge on the experiment-off path.
    const activeNudgeForPageRef = (0, $cozmU.useRef)(null);
    const pendingReplacementNudgeRef = (0, $cozmU.useRef)(null);
    const prevPageUrlRef = (0, $cozmU.useRef)(pageUrl);
    const isRecommendationSurface = (0, $cozmU.useMemo)(()=>(0, $3181de404c199fd8$export$cbdc338e17cb49af)({
            product: product,
            pageUrl: pageUrl,
            isLiveDoc: isLiveDoc,
            isLiveViewMode: isLiveViewMode
        }), [
        product,
        pageUrl,
        isLiveDoc,
        isLiveViewMode
    ]);
    // FE-driven nudges the user has not already dismissed, accepted, or had suppressed for this session.
    const availableNudges = (0, $cozmU.useMemo)(()=>selectedNudges.filter((nudge)=>!dismissedNudges.includes(nudge.id) && !acceptedNudges.includes(nudge.id) && !isSuppressed(nudge.id, nudge.nudgeContext?.suppressionKey)), [
        selectedNudges,
        dismissedNudges,
        acceptedNudges,
        isSuppressed
    ]); // Fallback FE nudge (self-eligible) used when the BE produces no winner.
    const feFallback = (0, $cozmU.useMemo)(()=>availableNudges.find((nudge)=>nudge.nudgeContext?.selfEligible) ?? null, [
        availableNudges
    ]);
    const resolvedNudge = (0, $cozmU.useMemo)(()=>{
        // Non-recommendation surfaces (search, Jira, live doc edit) skip the BE call and show the
        // first available registered nudge.
        if (!isRecommendationSurface) return availableNudges[0] ?? null;
         // Wait for BE recommendations before resolving so BE-driven nudges can win when eligible.
        if (loading || !selectedNudges?.length) return null;
         // On BE error or empty recommendations, fall back to FE self-eligible.
        if (error || !recommendations?.length) return feFallback;
         // TODO: dismiss/accept nudge by its nudgeContext.id so we only need to check recommendations
        const availableRecommendations = recommendations.filter((recommendation)=>{
            const id = recommendation.feature_details.feature_id;
            const suppressionKey = recommendation.context?.context_id ?? undefined;
            return !dismissedNudges.includes(id) && !acceptedNudges.includes(id) && !isSuppressed(id, suppressionKey);
        }); // If every BE recommendation was filtered out, fall back to FE self-eligible.
        if (!availableRecommendations.length) return feFallback;
         // If no BE recommendation matched a registered FE placeholder, fall back to FE self-eligible.
        const nudge = (0, $d05590d3ac370b21$export$6c62f9c964ed3ae0)(availableRecommendations, availableNudges) ?? null;
        if (!nudge) return feFallback;
        if (nudge.id === (0, $02lCe.CONVO_STARTER_ID)) return {
            ...nudge,
            secondaryTitle: formatMessage($257691f193cbe091$var$messages.convoStarterSubheader)
        };
        return nudge;
    }, [
        acceptedNudges,
        availableNudges,
        dismissedNudges,
        error,
        feFallback,
        formatMessage,
        isRecommendationSurface,
        isSuppressed,
        loading,
        recommendations,
        selectedNudges
    ]);
    const shouldWaitForRecommendations = loading && isRecommendationSurface;
    const hasActiveNudge = activeNudge !== null;
    const isAgentMentionsExperimentEnabled = (0, $mW7G5.expVal)('platform_editor_agent_mentions', 'isEnabled', false);
    const shouldReplaceActiveNudgeAfterExit = isAgentMentionsExperimentEnabled && Boolean(activeNudge && resolvedNudge && resolvedNudge !== activeNudge);
    const setActiveNudgeForPage = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useCallback((nextNudge)=>{
        activeNudgeForPageRef.current = nextNudge;
        setActiveNudge(nextNudge);
    }, []);
    const handleReplacementExitComplete = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useCallback(()=>{
        const nextNudge = pendingReplacementNudgeRef.current;
        pendingReplacementNudgeRef.current = null;
        setIsExitingForReplacement(false);
        setActiveNudgeForPage(nextNudge);
        if (nextNudge) setReplacementNudgeSequence((current)=>current + 1);
    }, [
        setActiveNudgeForPage
    ]); // Set the active nudge once BE finishes loading (or immediately on non-recommendation surfaces).
    // Reset on page navigation. Clear when the active nudge is dismissed/accepted/suppressed.
    (0, $cozmU.useEffect)(()=>{
        let activeNudgeForPage = activeNudgeForPageRef.current; // Reset on navigation — fall through so the new page's nudge can be pinned in this same effect run.
        if (prevPageUrlRef.current !== pageUrl) {
            prevPageUrlRef.current = pageUrl;
            pendingReplacementNudgeRef.current = null;
            setIsExitingForReplacement(false);
            setActiveNudgeForPage(null);
            activeNudgeForPage = null;
        } // On non-recommendation surfaces, pin immediately (no BE call to wait for).
        // On recommendation surfaces, wait for BE to finish loading.
        if (shouldWaitForRecommendations) return;
        if (!isAgentMentionsExperimentEnabled) {
            setActiveNudge((prev)=>{
                if (prev === null) return resolvedNudge;
                if (resolvedNudge === null || resolvedNudge.id !== prev.id) return null;
                return prev;
            });
            return;
        }
        if (activeNudgeForPage === null) {
            setActiveNudgeForPage(resolvedNudge);
            return;
        }
        if (resolvedNudge === null) {
            pendingReplacementNudgeRef.current = null;
            setIsExitingForReplacement(false);
            setActiveNudgeForPage(null);
            return;
        } // Intentionally compare object identity rather than id. Agent mention nudges can
        // reuse the same action id while representing a new mention instance/context,
        // so a new object should be allowed to exit and refire.
        if (resolvedNudge === activeNudgeForPage && !isExitingForReplacement) return;
        if (shouldReplaceActiveNudgeAfterExit) {
            pendingReplacementNudgeRef.current = resolvedNudge;
            setIsExitingForReplacement(true);
            return;
        }
        if (resolvedNudge.id !== activeNudgeForPage.id) // Active nudge was dismissed/accepted/suppressed (anti-spam: don't replace mid-page).
        setActiveNudgeForPage(null);
    }, [
        pageUrl,
        shouldWaitForRecommendations,
        resolvedNudge,
        isExitingForReplacement,
        isAgentMentionsExperimentEnabled,
        shouldReplaceActiveNudgeAfterExit,
        setActiveNudgeForPage
    ]);
    // Notify parent about active nudge state
    (0, $cozmU.useEffect)(()=>{
        onActiveNudgeChange?.(Boolean(activeNudge));
    }, [
        activeNudge,
        onActiveNudgeChange
    ]); // Sync the active nudge convo starter prompt into the shared store so the actions panel
    // can find the matching starter and pin it at position 0.
    (0, $cozmU.useEffect)(()=>{
        if (activeNudge?.id === (0, $02lCe.CONVO_STARTER_ID) && (0, $2TzCj.isChatAction)(activeNudge) && (0, $iDrrr.fg)('aix_convo_starter_nudge_enabled')) setConvoStarterActionPrompt(activeNudge.staticPrompt);
        else setConvoStarterActionPrompt(undefined);
        return ()=>{
            setConvoStarterActionPrompt(undefined);
        };
    }, [
        activeNudge,
        setConvoStarterActionPrompt
    ]); // Early exit if no nudge to show
    if (!hasActiveNudge) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Suspense, {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($257691f193cbe091$var$LazyAIProactiveNudge, {
        key: `${activeNudge.id}:${replacementNudgeSequence}`,
        activeNudge: activeNudge,
        addAcceptedNudge: addAcceptedNudge,
        addDismissedNudge: addDismissedNudge,
        addSuppressedNudge: addSuppressedNudge,
        addOtsSuppressedNudge: addOtsSuppressedNudge,
        isExitingForReplacement: isExitingForReplacement,
        onReplacementExitComplete: handleReplacementExitComplete
    }));
};


/* index.tsx generated by @compiled/babel-plugin v2.0.0 */ 






var $iHsYL = parcelRequire("iHsYL");

var $39691e3198a56ca7$exports = {};
$39691e3198a56ca7$exports = JSON.parse("{\"v\":\"5.7.4\",\"fr\":60,\"ip\":0,\"op\":120,\"w\":48,\"h\":48,\"nm\":\"rovo-glow-blobs\",\"ddd\":0,\"assets\":[],\"layers\":[{\"ddd\":0,\"ind\":1,\"ty\":4,\"nm\":\"purple\",\"sr\":1,\"ks\":{\"o\":{\"a\":1,\"k\":[{\"t\":0,\"s\":[0],\"i\":{\"x\":[0.5],\"y\":[0.5]},\"o\":{\"x\":[0.5],\"y\":[0.5]}},{\"t\":3,\"s\":[1.2874993780736568],\"i\":{\"x\":[0.5],\"y\":[0.5]},\"o\":{\"x\":[0.5],\"y\":[0.5]}},{\"t\":5,\"s\":[4.896948147169498],\"i\":{\"x\":[0.5],\"y\":[0.5]},\"o\":{\"x\":[0.5],\"y\":[0.5]}},{\"t\":8,\"s\":[10.431107503111988],\"i\":{\"x\":[0.5],\"y\":[0.5]},\"o\":{\"x\":[0.5],\"y\":[0.5]}},{\"t\":10,\"s\":[17.46759259259259],\"i\":{\"x\":[0.5],\"y\":[0.5]},\"o\":{\"x\":[0.5],\"y\":[0.5]}},{\"t\":13,\"s\":[25.558390264173763],\"i\":{\"x\":[0.5],\"y\":[0.5]},\"o\":{\"x\":[0.5],\"y\":[0.5]}},{\"t\":15,\"s\":[34.23115530061469],\"i\":{\"x\":[0.5],\"y\":[0.5]},\"o\":{\"x\":[0.5],\"y\":[0.5]}},{\"t\":18,\"s\":[42.99217779477908],\"i\":{\"x\":[0.5],\"y\":[0.5]},\"o\":{\"x\":[0.5],\"y\":[0.5]}},{\"t\":20,\"s\":[51.330839533235775],\"i\":{\"x\":[0.5],\"y\":[0.5]},\"o\":{\"x\":[0.5],\"y\":[0.5]}},{\"t\":23,\"s\":[58.72531011667109],\"i\":{\"x\":[0.5],\"y\":[0.5]},\"o\":{\"x\":[0.5],\"y\":[0.5]}},{\"t\":25,\"s\":[64.64917647038668],\"i\":{\"x\":[0.5],\"y\":[0.5]},\"o\":{\"x\":[0.5],\"y\":[0.5]}},{\"t\":28,\"s\":[68.57865444133563],\"i\":{\"x\":[0.5],\"y\":[0.5]},\"o\":{\"x\":[0.5],\"y\":[0.5]}},{\"t\":30,\"s\":[70],\"i\":{\"x\":[0.5],\"y\":[0.5]},\"o\":{\"x\":[0.5],\"y\":[0.5]}},{\"t\":33,\"s\":[69.9550855222125],\"i\":{\"x\":[0.5],\"y\":[0.5]},\"o\":{\"x\":[0.5],\"y\":[0.5]}},{\"t\":35,\"s\":[69.8211105880176],\"i\":{\"x\":[0.5],\"y\":[0.5]},\"o\":{\"x\":[0.5],\"y\":[0.5]}},{\"t\":38,\"s\":[69.60036754568426],\"i\":{\"x\":[0.5],\"y\":[0.5]},\"o\":{\"x\":[0.5],\"y\":[0.5]}},{\"t\":40,\"s\":[69.2966333698683],\"i\":{\"x\":[0.5],\"y\":[0.5]},\"o\":{\"x\":[0.5],\"y\":[0.5]}},{\"t\":43,\"s\":[68.91510503652898],\"i\":{\"x\":[0.5],\"y\":[0.5]},\"o\":{\"x\":[0.5],\"y\":[0.5]}},{\"t\":45,\"s\":[68.46231060122938],\"i\":{\"x\":[0.5],\"y\":[0.5]},\"o\":{\"x\":[0.5],\"y\":[0.5]}},{\"t\":48,\"s\":[67.94599750229578],\"i\":{\"x\":[0.5],\"y\":[0.5]},\"o\":{\"x\":[0.5],\"y\":[0.5]}},{\"t\":50,\"s\":[67.375],\"i\":{\"x\":[0.5],\"y\":[0.5]},\"o\":{\"x\":[0.5],\"y\":[0.5]}},{\"t\":53,\"s\":[66.75908801991672],\"i\":{\"x\":[0.5],\"y\":[0.5]},\"o\":{\"x\":[0.5],\"y\":[0.5]}},{\"t\":55,\"s\":[66.10879998678824],\"i\":{\"x\":[0.5],\"y\":[0.5]},\"o\":{\"x\":[0.5],\"y\":[0.5]}},{\"t\":58,\"s\":[65.43526250915527],\"i\":{\"x\":[0.5],\"y\":[0.5]},\"o\":{\"x\":[0.5],\"y\":[0.5]}},{\"t\":60,\"s\":[64.75],\"i\":{\"x\":[0.5],\"y\":[0.5]},\"o\":{\"x\":[0.5],\"y\":[0.5]}},{\"t\":63,\"s\":[64.06473749084472],\"i\":{\"x\":[0.5],\"y\":[0.5]},\"o\":{\"x\":[0.5],\"y\":[0.5]}},{\"t\":65,\"s\":[63.391200013211765],\"i\":{\"x\":[0.5],\"y\":[0.5]},\"o\":{\"x\":[0.5],\"y\":[0.5]}},{\"t\":68,\"s\":[62.74091198008328],\"i\":{\"x\":[0.5],\"y\":[0.5]},\"o\":{\"x\":[0.5],\"y\":[0.5]}},{\"t\":70,\"s\":[62.125],\"i\":{\"x\":[0.5],\"y\":[0.5]},\"o\":{\"x\":[0.5],\"y\":[0.5]}},{\"t\":73,\"s\":[61.55400249770422],\"i\":{\"x\":[0.5],\"y\":[0.5]},\"o\":{\"x\":[0.5],\"y\":[0.5]}},{\"t\":75,\"s\":[61.037689398770624],\"i\":{\"x\":[0.5],\"y\":[0.5]},\"o\":{\"x\":[0.5],\"y\":[0.5]}},{\"t\":78,\"s\":[60.584894963471015],\"i\":{\"x\":[0.5],\"y\":[0.5]},\"o\":{\"x\":[0.5],\"y\":[0.5]}},{\"t\":80,\"s\":[60.2033666301317],\"i\":{\"x\":[0.5],\"y\":[0.5]},\"o\":{\"x\":[0.5],\"y\":[0.5]}},{\"t\":83,\"s\":[59.89963245431574],\"i\":{\"x\":[0.5],\"y\":[0.5]},\"o\":{\"x\":[0.5],\"y\":[0.5]}},{\"t\":85,\"s\":[59.6788894119824],\"i\":{\"x\":[0.5],\"y\":[0.5]},\"o\":{\"x\":[0.5],\"y\":[0.5]}},{\"t\":88,\"s\":[59.54491447778749],\"i\":{\"x\":[0.5],\"y\":[0.5]},\"o\":{\"x\":[0.5],\"y\":[0.5]}},{\"t\":90,\"s\":[59.5],\"i\":{\"x\":[0.5],\"y\":[0.5]},\"o\":{\"x\":[0.5],\"y\":[0.5]}},{\"t\":93,\"s\":[58.373313151256944],\"i\":{\"x\":[0.5],\"y\":[0.5]},\"o\":{\"x\":[0.5],\"y\":[0.5]}},{\"t\":95,\"s\":[55.25823093702075],\"i\":{\"x\":[0.5],\"y\":[0.5]},\"o\":{\"x\":[0.5],\"y\":[0.5]}},{\"t\":98,\"s\":[50.540314883328904],\"i\":{\"x\":[0.5],\"y\":[0.5]},\"o\":{\"x\":[0.5],\"y\":[0.5]}},{\"t\":100,\"s\":[44.59508639269013],\"i\":{\"x\":[0.5],\"y\":[0.5]},\"o\":{\"x\":[0.5],\"y\":[0.5]}},{\"t\":103,\"s\":[37.79543794596167],\"i\":{\"x\":[0.5],\"y\":[0.5]},\"o\":{\"x\":[0.5],\"y\":[0.5]}},{\"t\":105,\"s\":[30.518844699385312],\"i\":{\"x\":[0.5],\"y\":[0.5]},\"o\":{\"x\":[0.5],\"y\":[0.5]}},{\"t\":108,\"s\":[23.153993995085486],\"i\":{\"x\":[0.5],\"y\":[0.5]},\"o\":{\"x\":[0.5],\"y\":[0.5]}},{\"t\":110,\"s\":[16.10648148148149],\"i\":{\"x\":[0.5],\"y\":[0.5]},\"o\":{\"x\":[0.5],\"y\":[0.5]}},{\"t\":113,\"s\":[9.803267496888013],\"i\":{\"x\":[0.5],\"y\":[0.5]},\"o\":{\"x\":[0.5],\"y\":[0.5]}},{\"t\":115,\"s\":[4.695644445423094],\"i\":{\"x\":[0.5],\"y\":[0.5]},\"o\":{\"x\":[0.5],\"y\":[0.5]}},{\"t\":118,\"s\":[1.2605330293337578],\"i\":{\"x\":[0.5],\"y\":[0.5]},\"o\":{\"x\":[0.5],\"y\":[0.5]}},{\"t\":120,\"s\":[0]}]},\"r\":{\"a\":0,\"k\":0},\"p\":{\"a\":1,\"k\":[{\"t\":0,\"s\":[18,21.5],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":3,\"s\":[19.044209537760413,20.67878402655563],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":5,\"s\":[20.070552360820166,19.811733315717646],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":8,\"s\":[21.061467458920717,18.913683345540363],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":10,\"s\":[22,18],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":13,\"s\":[22.870091432069763,17.08631665445964],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":15,\"s\":[23.65685424949238,16.188266684282354],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":18,\"s\":[24.34682672232988,15.321215973444371],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":20,\"s\":[24.928203230275507,14.500000000000002],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":23,\"s\":[25.391036260090296,13.738669996938956],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":25,\"s\":[25.727406610312546,13.050252531694168],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":28,\"s\":[25.931558890990484,12.446526617961354],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":30,\"s\":[26,11.93782217350893],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":33,\"s\":[25.931558890990484,11.532843272420994],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":35,\"s\":[25.727406610312546,11.238519215976522],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":38,\"s\":[25.391036260090296,11.059885970383327],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":40,\"s\":[24.92820323027551,11],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":43,\"s\":[24.34682672232988,11.059885970383327],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":45,\"s\":[23.65685424949238,11.23851921597652],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":48,\"s\":[22.870091432069767,11.53284327242099],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":50,\"s\":[22,11.93782217350893],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":53,\"s\":[21.06146745892072,12.446526617961354],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":55,\"s\":[20.07055236082017,13.050252531694166],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":58,\"s\":[19.044209537760413,13.738669996938954],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":60,\"s\":[18,14.499999999999996],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":63,\"s\":[16.955790462239587,15.321215973444374],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":65,\"s\":[15.929447639179838,16.18826668428235],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":68,\"s\":[14.938532541079283,17.086316654459637],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":70,\"s\":[14,18],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":73,\"s\":[13.129908567930237,18.91368334554036],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":75,\"s\":[12.34314575050762,19.811733315717643],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":78,\"s\":[11.65317327767012,20.678784026555626],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":80,\"s\":[11.071796769724493,21.499999999999996],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":83,\"s\":[10.608963739909708,22.26133000306104],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":85,\"s\":[10.272593389687454,22.94974746830583],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":88,\"s\":[10.068441109009516,23.553473382038646],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":90,\"s\":[10,24.06217782649107],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":93,\"s\":[10.068441109009516,24.467156727579006],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":95,\"s\":[10.272593389687453,24.761480784023476],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":98,\"s\":[10.608963739909708,24.940114029616673],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":100,\"s\":[11.071796769724491,25],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":103,\"s\":[11.653173277670119,24.940114029616673],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":105,\"s\":[12.343145750507619,24.76148078402348],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":108,\"s\":[13.129908567930233,24.46715672757901],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":110,\"s\":[13.999999999999996,24.062177826491073],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":113,\"s\":[14.938532541079276,23.55347338203865],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":115,\"s\":[15.929447639179834,22.949747468305834],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":118,\"s\":[16.955790462239587,22.261330003061047],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":120,\"s\":[18,21.5]}]},\"a\":{\"a\":0,\"k\":[0,0,0]},\"s\":{\"a\":1,\"k\":[{\"t\":0,\"s\":[100,100],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":3,\"s\":[100.65263096110027,100.65263096110027],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":5,\"s\":[101.2940952255126,101.2940952255126],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":8,\"s\":[101.91341716182545,101.91341716182545],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":10,\"s\":[102.49999999999999,102.49999999999999],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":13,\"s\":[103.0438071450436,103.0438071450436],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":15,\"s\":[103.53553390593274,103.53553390593274],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":18,\"s\":[103.96676670145617,103.96676670145617],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":20,\"s\":[104.3301270189222,104.3301270189222],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":23,\"s\":[104.61939766255644,104.61939766255644],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":25,\"s\":[104.82962913144533,104.82962913144533],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":28,\"s\":[104.95722430686905,104.95722430686905],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":30,\"s\":[105,105],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":33,\"s\":[104.95722430686905,104.95722430686905],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":35,\"s\":[104.82962913144533,104.82962913144533],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":38,\"s\":[104.61939766255644,104.61939766255644],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":40,\"s\":[104.3301270189222,104.3301270189222],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":43,\"s\":[103.96676670145617,103.96676670145617],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":45,\"s\":[103.53553390593274,103.53553390593274],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":48,\"s\":[103.0438071450436,103.0438071450436],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":50,\"s\":[102.49999999999999,102.49999999999999],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":53,\"s\":[101.91341716182545,101.91341716182545],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":55,\"s\":[101.2940952255126,101.2940952255126],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":58,\"s\":[100.65263096110027,100.65263096110027],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":60,\"s\":[100,100],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":63,\"s\":[99.34736903889974,99.34736903889974],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":65,\"s\":[98.7059047744874,98.7059047744874],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":68,\"s\":[98.08658283817455,98.08658283817455],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":70,\"s\":[97.5,97.5],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":73,\"s\":[96.9561928549564,96.9561928549564],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":75,\"s\":[96.46446609406726,96.46446609406726],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":78,\"s\":[96.03323329854383,96.03323329854383],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":80,\"s\":[95.6698729810778,95.6698729810778],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":83,\"s\":[95.38060233744356,95.38060233744356],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":85,\"s\":[95.17037086855466,95.17037086855466],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":88,\"s\":[95.04277569313095,95.04277569313095],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":90,\"s\":[95,95],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":93,\"s\":[95.04277569313095,95.04277569313095],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":95,\"s\":[95.17037086855466,95.17037086855466],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":98,\"s\":[95.38060233744356,95.38060233744356],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":100,\"s\":[95.6698729810778,95.6698729810778],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":103,\"s\":[96.03323329854383,96.03323329854383],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":105,\"s\":[96.46446609406726,96.46446609406726],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":108,\"s\":[96.95619285495638,96.95619285495638],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":110,\"s\":[97.5,97.5],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":113,\"s\":[98.08658283817455,98.08658283817455],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":115,\"s\":[98.7059047744874,98.7059047744874],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":118,\"s\":[99.34736903889974,99.34736903889974],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":120,\"s\":[100,100]}]}},\"ao\":0,\"shapes\":[{\"ty\":\"gr\",\"nm\":\"g\",\"it\":[{\"ty\":\"el\",\"nm\":\"e\",\"p\":{\"a\":0,\"k\":[0,0]},\"s\":{\"a\":0,\"k\":[30,30]}},{\"ty\":\"fl\",\"nm\":\"f\",\"c\":{\"a\":0,\"k\":[0.6588235294117647,0.3333333333333333,0.9686274509803922,1]},\"o\":{\"a\":0,\"k\":100},\"r\":1},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[0,0]},\"a\":{\"a\":0,\"k\":[0,0]},\"s\":{\"a\":0,\"k\":[100,100]},\"r\":{\"a\":0,\"k\":0},\"o\":{\"a\":0,\"k\":100},\"sk\":{\"a\":0,\"k\":0},\"sa\":{\"a\":0,\"k\":0}}]}],\"ef\":[{\"ty\":29,\"nm\":\"Gaussian Blur\",\"np\":5,\"mn\":\"ADBE Gaussian Blur 2\",\"ef\":[{\"ty\":0,\"nm\":\"Blurriness\",\"v\":{\"a\":0,\"k\":24}},{\"ty\":7,\"nm\":\"Blur Dimensions\",\"v\":{\"a\":0,\"k\":1}},{\"ty\":7,\"nm\":\"Repeat Edge Pixels\",\"v\":{\"a\":0,\"k\":0}}]}],\"ip\":0,\"op\":120,\"st\":0,\"bm\":0},{\"ddd\":0,\"ind\":2,\"ty\":4,\"nm\":\"blue\",\"sr\":1,\"ks\":{\"o\":{\"a\":1,\"k\":[{\"t\":0,\"s\":[0],\"i\":{\"x\":[0.5],\"y\":[0.5]},\"o\":{\"x\":[0.5],\"y\":[0.5]}},{\"t\":3,\"s\":[1.291197294746325],\"i\":{\"x\":[0.5],\"y\":[0.5]},\"o\":{\"x\":[0.5],\"y\":[0.5]}},{\"t\":5,\"s\":[4.876395025194881],\"i\":{\"x\":[0.5],\"y\":[0.5]},\"o\":{\"x\":[0.5],\"y\":[0.5]}},{\"t\":8,\"s\":[10.305883134968807],\"i\":{\"x\":[0.5],\"y\":[0.5]},\"o\":{\"x\":[0.5],\"y\":[0.5]}},{\"t\":10,\"s\":[17.11111111111111],\"i\":{\"x\":[0.5],\"y\":[0.5]},\"o\":{\"x\":[0.5],\"y\":[0.5]}},{\"t\":13,\"s\":[24.810459398998983],\"i\":{\"x\":[0.5],\"y\":[0.5]},\"o\":{\"x\":[0.5],\"y\":[0.5]}},{\"t\":15,\"s\":[32.91566642006545],\"i\":{\"x\":[0.5],\"y\":[0.5]},\"o\":{\"x\":[0.5],\"y\":[0.5]}},{\"t\":18,\"s\":[40.9385495216629],\"i\":{\"x\":[0.5],\"y\":[0.5]},\"o\":{\"x\":[0.5],\"y\":[0.5]}},{\"t\":20,\"s\":[48.39764870276516],\"i\":{\"x\":[0.5],\"y\":[0.5]},\"o\":{\"x\":[0.5],\"y\":[0.5]}},{\"t\":23,\"s\":[54.82442731031012],\"i\":{\"x\":[0.5],\"y\":[0.5]},\"o\":{\"x\":[0.5],\"y\":[0.5]}},{\"t\":25,\"s\":[59.76868385821613],\"i\":{\"x\":[0.5],\"y\":[0.5]},\"o\":{\"x\":[0.5],\"y\":[0.5]}},{\"t\":28,\"s\":[62.80286296913591],\"i\":{\"x\":[0.5],\"y\":[0.5]},\"o\":{\"x\":[0.5],\"y\":[0.5]}},{\"t\":30,\"s\":[63.525000000000006],\"i\":{\"x\":[0.5],\"y\":[0.5]},\"o\":{\"x\":[0.5],\"y\":[0.5]}},{\"t\":33,\"s\":[62.9442829902072],\"i\":{\"x\":[0.5],\"y\":[0.5]},\"o\":{\"x\":[0.5],\"y\":[0.5]}},{\"t\":35,\"s\":[62.33115427325748],\"i\":{\"x\":[0.5],\"y\":[0.5]},\"o\":{\"x\":[0.5],\"y\":[0.5]}},{\"t\":38,\"s\":[61.69610465148926],\"i\":{\"x\":[0.5],\"y\":[0.5]},\"o\":{\"x\":[0.5],\"y\":[0.5]}},{\"t\":40,\"s\":[61.050000000000004],\"i\":{\"x\":[0.5],\"y\":[0.5]},\"o\":{\"x\":[0.5],\"y\":[0.5]}},{\"t\":43,\"s\":[60.40389534851075],\"i\":{\"x\":[0.5],\"y\":[0.5]},\"o\":{\"x\":[0.5],\"y\":[0.5]}},{\"t\":45,\"s\":[59.768845726742526],\"i\":{\"x\":[0.5],\"y\":[0.5]},\"o\":{\"x\":[0.5],\"y\":[0.5]}},{\"t\":48,\"s\":[59.15571700979281],\"i\":{\"x\":[0.5],\"y\":[0.5]},\"o\":{\"x\":[0.5],\"y\":[0.5]}},{\"t\":50,\"s\":[58.57500000000001],\"i\":{\"x\":[0.5],\"y\":[0.5]},\"o\":{\"x\":[0.5],\"y\":[0.5]}},{\"t\":53,\"s\":[58.03663092640684],\"i\":{\"x\":[0.5],\"y\":[0.5]},\"o\":{\"x\":[0.5],\"y\":[0.5]}},{\"t\":55,\"s\":[57.54982143312659],\"i\":{\"x\":[0.5],\"y\":[0.5]},\"o\":{\"x\":[0.5],\"y\":[0.5]}},{\"t\":58,\"s\":[57.12290096555839],\"i\":{\"x\":[0.5],\"y\":[0.5]},\"o\":{\"x\":[0.5],\"y\":[0.5]}},{\"t\":60,\"s\":[56.76317425126703],\"i\":{\"x\":[0.5],\"y\":[0.5]},\"o\":{\"x\":[0.5],\"y\":[0.5]}},{\"t\":63,\"s\":[56.476796314069134],\"i\":{\"x\":[0.5],\"y\":[0.5]},\"o\":{\"x\":[0.5],\"y\":[0.5]}},{\"t\":65,\"s\":[56.26866715986911],\"i\":{\"x\":[0.5],\"y\":[0.5]},\"o\":{\"x\":[0.5],\"y\":[0.5]}},{\"t\":68,\"s\":[56.14234793619964],\"i\":{\"x\":[0.5],\"y\":[0.5]},\"o\":{\"x\":[0.5],\"y\":[0.5]}},{\"t\":70,\"s\":[56.10000000000001],\"i\":{\"x\":[0.5],\"y\":[0.5]},\"o\":{\"x\":[0.5],\"y\":[0.5]}},{\"t\":73,\"s\":[56.14234793619964],\"i\":{\"x\":[0.5],\"y\":[0.5]},\"o\":{\"x\":[0.5],\"y\":[0.5]}},{\"t\":75,\"s\":[56.26866715986911],\"i\":{\"x\":[0.5],\"y\":[0.5]},\"o\":{\"x\":[0.5],\"y\":[0.5]}},{\"t\":78,\"s\":[56.476796314069134],\"i\":{\"x\":[0.5],\"y\":[0.5]},\"o\":{\"x\":[0.5],\"y\":[0.5]}},{\"t\":80,\"s\":[56.76317425126703],\"i\":{\"x\":[0.5],\"y\":[0.5]},\"o\":{\"x\":[0.5],\"y\":[0.5]}},{\"t\":83,\"s\":[57.12290096555839],\"i\":{\"x\":[0.5],\"y\":[0.5]},\"o\":{\"x\":[0.5],\"y\":[0.5]}},{\"t\":85,\"s\":[57.54982143312659],\"i\":{\"x\":[0.5],\"y\":[0.5]},\"o\":{\"x\":[0.5],\"y\":[0.5]}},{\"t\":88,\"s\":[58.03663092640684],\"i\":{\"x\":[0.5],\"y\":[0.5]},\"o\":{\"x\":[0.5],\"y\":[0.5]}},{\"t\":90,\"s\":[58.575],\"i\":{\"x\":[0.5],\"y\":[0.5]},\"o\":{\"x\":[0.5],\"y\":[0.5]}},{\"t\":93,\"s\":[57.99177350381308],\"i\":{\"x\":[0.5],\"y\":[0.5]},\"o\":{\"x\":[0.5],\"y\":[0.5]}},{\"t\":95,\"s\":[55.341523821057905],\"i\":{\"x\":[0.5],\"y\":[0.5]},\"o\":{\"x\":[0.5],\"y\":[0.5]}},{\"t\":98,\"s\":[50.96578670030595],\"i\":{\"x\":[0.5],\"y\":[0.5]},\"o\":{\"x\":[0.5],\"y\":[0.5]}},{\"t\":100,\"s\":[45.22222222222221],\"i\":{\"x\":[0.5],\"y\":[0.5]},\"o\":{\"x\":[0.5],\"y\":[0.5]}},{\"t\":103,\"s\":[38.48865787864898],\"i\":{\"x\":[0.5],\"y\":[0.5]},\"o\":{\"x\":[0.5],\"y\":[0.5]}},{\"t\":105,\"s\":[31.16557713662874],\"i\":{\"x\":[0.5],\"y\":[0.5]},\"o\":{\"x\":[0.5],\"y\":[0.5]}},{\"t\":108,\"s\":[23.676958300714503],\"i\":{\"x\":[0.5],\"y\":[0.5]},\"o\":{\"x\":[0.5],\"y\":[0.5]}},{\"t\":110,\"s\":[16.469444444444456],\"i\":{\"x\":[0.5],\"y\":[0.5]},\"o\":{\"x\":[0.5],\"y\":[0.5]}},{\"t\":113,\"s\":[10.009901417748933],\"i\":{\"x\":[0.5],\"y\":[0.5]},\"o\":{\"x\":[0.5],\"y\":[0.5]}},{\"t\":115,\"s\":[4.78149470865729],\"i\":{\"x\":[0.5],\"y\":[0.5]},\"o\":{\"x\":[0.5],\"y\":[0.5]}},{\"t\":118,\"s\":[1.2784845874832338],\"i\":{\"x\":[0.5],\"y\":[0.5]},\"o\":{\"x\":[0.5],\"y\":[0.5]}},{\"t\":120,\"s\":[0]}]},\"r\":{\"a\":0,\"k\":0},\"p\":{\"a\":1,\"k\":[{\"t\":0,\"s\":[37,10],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":3,\"s\":[36.94011402961667,10.068441109009516],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":5,\"s\":[36.761480784023476,10.272593389687454],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":8,\"s\":[36.46715672757901,10.608963739909704],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":10,\"s\":[36.06217782649107,11.07179676972449],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":13,\"s\":[35.553473382038646,11.653173277670119],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":15,\"s\":[34.94974746830583,12.343145750507619],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":18,\"s\":[34.26133000306105,13.129908567930233],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":20,\"s\":[33.5,13.999999999999996],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":23,\"s\":[32.67878402655563,14.938532541079278],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":25,\"s\":[31.811733315717643,15.929447639179834],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":28,\"s\":[30.91368334554036,16.955790462239587],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":30,\"s\":[30,18],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":33,\"s\":[29.08631665445964,19.04420953776041],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":35,\"s\":[28.188266684282354,20.070552360820162],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":38,\"s\":[27.32121597344437,21.06146745892072],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":40,\"s\":[26.5,21.999999999999993],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":43,\"s\":[25.738669996938956,22.870091432069763],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":45,\"s\":[25.05025253169417,23.65685424949238],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":48,\"s\":[24.446526617961354,24.34682672232988],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":50,\"s\":[23.937822173508927,24.92820323027551],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":53,\"s\":[23.532843272420994,25.391036260090292],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":55,\"s\":[23.238519215976524,25.727406610312546],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":58,\"s\":[23.059885970383327,25.931558890990484],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":60,\"s\":[23,26],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":63,\"s\":[23.059885970383327,25.931558890990484],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":65,\"s\":[23.23851921597652,25.72740661031255],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":68,\"s\":[23.532843272420994,25.391036260090296],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":70,\"s\":[23.93782217350893,24.928203230275507],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":73,\"s\":[24.446526617961354,24.346826722329883],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":75,\"s\":[25.050252531694166,23.656854249492383],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":78,\"s\":[25.738669996938953,22.870091432069767],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":80,\"s\":[26.499999999999996,22.000000000000004],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":83,\"s\":[27.321215973444367,21.061467458920724],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":85,\"s\":[28.188266684282354,20.070552360820166],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":88,\"s\":[29.086316654459637,19.044209537760413],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":90,\"s\":[30,18.000000000000004],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":93,\"s\":[30.91368334554036,16.95579046223959],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":95,\"s\":[31.811733315717643,15.929447639179838],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":98,\"s\":[32.67878402655563,14.938532541079281],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":100,\"s\":[33.5,13.999999999999993],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":103,\"s\":[34.26133000306105,13.129908567930237],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":105,\"s\":[34.94974746830583,12.343145750507627],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":108,\"s\":[35.553473382038646,11.65317327767012],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":110,\"s\":[36.062177826491066,11.07179676972449],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":113,\"s\":[36.46715672757901,10.608963739909708],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":115,\"s\":[36.761480784023476,10.272593389687454],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":118,\"s\":[36.94011402961667,10.068441109009518],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":120,\"s\":[37,10]}]},\"a\":{\"a\":0,\"k\":[0,0,0]},\"s\":{\"a\":1,\"k\":[{\"t\":0,\"s\":[106,106],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":3,\"s\":[105.94866916824286,105.94866916824286],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":5,\"s\":[105.79555495773441,105.79555495773441],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":8,\"s\":[105.54327719506773,105.54327719506773],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":10,\"s\":[105.19615242270663,105.19615242270663],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":13,\"s\":[104.76012004174741,104.76012004174741],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":15,\"s\":[104.24264068711928,104.24264068711928],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":18,\"s\":[103.65256857405231,103.65256857405231],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":20,\"s\":[103,103],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":23,\"s\":[102.29610059419055,102.29610059419055],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":25,\"s\":[101.55291427061512,101.55291427061512],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":28,\"s\":[100.78315715332032,100.78315715332032],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":30,\"s\":[100,100],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":33,\"s\":[99.21684284667968,99.21684284667968],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":35,\"s\":[98.44708572938488,98.44708572938488],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":38,\"s\":[97.70389940580945,97.70389940580945],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":40,\"s\":[97,97],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":43,\"s\":[96.34743142594768,96.34743142594768],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":45,\"s\":[95.75735931288072,95.75735931288072],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":48,\"s\":[95.23987995825259,95.23987995825259],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":50,\"s\":[94.80384757729337,94.80384757729337],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":53,\"s\":[94.45672280493228,94.45672280493228],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":55,\"s\":[94.20444504226559,94.20444504226559],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":58,\"s\":[94.05133083175714,94.05133083175714],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":60,\"s\":[94,94],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":63,\"s\":[94.05133083175714,94.05133083175714],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":65,\"s\":[94.20444504226559,94.20444504226559],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":68,\"s\":[94.45672280493228,94.45672280493228],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":70,\"s\":[94.80384757729337,94.80384757729337],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":73,\"s\":[95.23987995825259,95.23987995825259],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":75,\"s\":[95.75735931288072,95.75735931288072],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":78,\"s\":[96.34743142594768,96.34743142594768],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":80,\"s\":[97,97],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":83,\"s\":[97.70389940580945,97.70389940580945],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":85,\"s\":[98.44708572938488,98.44708572938488],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":88,\"s\":[99.21684284667968,99.21684284667968],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":90,\"s\":[100,100],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":93,\"s\":[100.78315715332032,100.78315715332032],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":95,\"s\":[101.55291427061512,101.55291427061512],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":98,\"s\":[102.29610059419055,102.29610059419055],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":100,\"s\":[103,103],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":103,\"s\":[103.65256857405231,103.65256857405231],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":105,\"s\":[104.24264068711928,104.24264068711928],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":108,\"s\":[104.76012004174741,104.76012004174741],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":110,\"s\":[105.19615242270663,105.19615242270663],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":113,\"s\":[105.5432771950677,105.5432771950677],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":115,\"s\":[105.79555495773441,105.79555495773441],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":118,\"s\":[105.94866916824286,105.94866916824286],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":120,\"s\":[106,106]}]}},\"ao\":0,\"shapes\":[{\"ty\":\"gr\",\"nm\":\"g\",\"it\":[{\"ty\":\"el\",\"nm\":\"e\",\"p\":{\"a\":0,\"k\":[0,0]},\"s\":{\"a\":0,\"k\":[26,26]}},{\"ty\":\"fl\",\"nm\":\"f\",\"c\":{\"a\":0,\"k\":[0.2196078431372549,0.7411764705882353,0.9725490196078431,1]},\"o\":{\"a\":0,\"k\":100},\"r\":1},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[0,0]},\"a\":{\"a\":0,\"k\":[0,0]},\"s\":{\"a\":0,\"k\":[100,100]},\"r\":{\"a\":0,\"k\":0},\"o\":{\"a\":0,\"k\":100},\"sk\":{\"a\":0,\"k\":0},\"sa\":{\"a\":0,\"k\":0}}]}],\"ef\":[{\"ty\":29,\"nm\":\"Gaussian Blur\",\"np\":5,\"mn\":\"ADBE Gaussian Blur 2\",\"ef\":[{\"ty\":0,\"nm\":\"Blurriness\",\"v\":{\"a\":0,\"k\":24}},{\"ty\":7,\"nm\":\"Blur Dimensions\",\"v\":{\"a\":0,\"k\":1}},{\"ty\":7,\"nm\":\"Repeat Edge Pixels\",\"v\":{\"a\":0,\"k\":0}}]}],\"ip\":0,\"op\":120,\"st\":0,\"bm\":0},{\"ddd\":0,\"ind\":3,\"ty\":4,\"nm\":\"pink\",\"sr\":1,\"ks\":{\"o\":{\"a\":1,\"k\":[{\"t\":0,\"s\":[0],\"i\":{\"x\":[0.5],\"y\":[0.5]},\"o\":{\"x\":[0.5],\"y\":[0.5]}},{\"t\":3,\"s\":[1.219124671633796],\"i\":{\"x\":[0.5],\"y\":[0.5]},\"o\":{\"x\":[0.5],\"y\":[0.5]}},{\"t\":5,\"s\":[4.580855932758827],\"i\":{\"x\":[0.5],\"y\":[0.5]},\"o\":{\"x\":[0.5],\"y\":[0.5]}},{\"t\":8,\"s\":[9.632193722840231],\"i\":{\"x\":[0.5],\"y\":[0.5]},\"o\":{\"x\":[0.5],\"y\":[0.5]}},{\"t\":10,\"s\":[15.91256025530309],\"i\":{\"x\":[0.5],\"y\":[0.5]},\"o\":{\"x\":[0.5],\"y\":[0.5]}},{\"t\":13,\"s\":[22.960306985549924],\"i\":{\"x\":[0.5],\"y\":[0.5]},\"o\":{\"x\":[0.5],\"y\":[0.5]}},{\"t\":15,\"s\":[30.319023266258725],\"i\":{\"x\":[0.5],\"y\":[0.5]},\"o\":{\"x\":[0.5],\"y\":[0.5]}},{\"t\":18,\"s\":[37.54330926805094],\"i\":{\"x\":[0.5],\"y\":[0.5]},\"o\":{\"x\":[0.5],\"y\":[0.5]}},{\"t\":20,\"s\":[44.2037037037037],\"i\":{\"x\":[0.5],\"y\":[0.5]},\"o\":{\"x\":[0.5],\"y\":[0.5]}},{\"t\":23,\"s\":[49.89049702916991],\"i\":{\"x\":[0.5],\"y\":[0.5]},\"o\":{\"x\":[0.5],\"y\":[0.5]}},{\"t\":25,\"s\":[54.2162116293766],\"i\":{\"x\":[0.5],\"y\":[0.5]},\"o\":{\"x\":[0.5],\"y\":[0.5]}},{\"t\":28,\"s\":[56.816590201815146],\"i\":{\"x\":[0.5],\"y\":[0.5]},\"o\":{\"x\":[0.5],\"y\":[0.5]}},{\"t\":30,\"s\":[57.35],\"i\":{\"x\":[0.5],\"y\":[0.5]},\"o\":{\"x\":[0.5],\"y\":[0.5]}},{\"t\":33,\"s\":[56.74305320617676],\"i\":{\"x\":[0.5],\"y\":[0.5]},\"o\":{\"x\":[0.5],\"y\":[0.5]}},{\"t\":35,\"s\":[56.14649144027328],\"i\":{\"x\":[0.5],\"y\":[0.5]},\"o\":{\"x\":[0.5],\"y\":[0.5]}},{\"t\":38,\"s\":[55.570522039502336],\"i\":{\"x\":[0.5],\"y\":[0.5]},\"o\":{\"x\":[0.5],\"y\":[0.5]}},{\"t\":40,\"s\":[55.025],\"i\":{\"x\":[0.5],\"y\":[0.5]},\"o\":{\"x\":[0.5],\"y\":[0.5]}},{\"t\":43,\"s\":[54.51925935510945],\"i\":{\"x\":[0.5],\"y\":[0.5]},\"o\":{\"x\":[0.5],\"y\":[0.5]}},{\"t\":45,\"s\":[54.06195346748256],\"i\":{\"x\":[0.5],\"y\":[0.5]},\"o\":{\"x\":[0.5],\"y\":[0.5]}},{\"t\":48,\"s\":[53.66090696764576],\"i\":{\"x\":[0.5],\"y\":[0.5]},\"o\":{\"x\":[0.5],\"y\":[0.5]}},{\"t\":50,\"s\":[53.322981872402366],\"i\":{\"x\":[0.5],\"y\":[0.5]},\"o\":{\"x\":[0.5],\"y\":[0.5]}},{\"t\":53,\"s\":[53.053960173822524],\"i\":{\"x\":[0.5],\"y\":[0.5]},\"o\":{\"x\":[0.5],\"y\":[0.5]}},{\"t\":55,\"s\":[52.85844490775583],\"i\":{\"x\":[0.5],\"y\":[0.5]},\"o\":{\"x\":[0.5],\"y\":[0.5]}},{\"t\":58,\"s\":[52.73978139461178],\"i\":{\"x\":[0.5],\"y\":[0.5]},\"o\":{\"x\":[0.5],\"y\":[0.5]}},{\"t\":60,\"s\":[52.7],\"i\":{\"x\":[0.5],\"y\":[0.5]},\"o\":{\"x\":[0.5],\"y\":[0.5]}},{\"t\":63,\"s\":[52.73978139461178],\"i\":{\"x\":[0.5],\"y\":[0.5]},\"o\":{\"x\":[0.5],\"y\":[0.5]}},{\"t\":65,\"s\":[52.85844490775583],\"i\":{\"x\":[0.5],\"y\":[0.5]},\"o\":{\"x\":[0.5],\"y\":[0.5]}},{\"t\":68,\"s\":[53.053960173822524],\"i\":{\"x\":[0.5],\"y\":[0.5]},\"o\":{\"x\":[0.5],\"y\":[0.5]}},{\"t\":70,\"s\":[53.322981872402366],\"i\":{\"x\":[0.5],\"y\":[0.5]},\"o\":{\"x\":[0.5],\"y\":[0.5]}},{\"t\":73,\"s\":[53.66090696764576],\"i\":{\"x\":[0.5],\"y\":[0.5]},\"o\":{\"x\":[0.5],\"y\":[0.5]}},{\"t\":75,\"s\":[54.06195346748256],\"i\":{\"x\":[0.5],\"y\":[0.5]},\"o\":{\"x\":[0.5],\"y\":[0.5]}},{\"t\":78,\"s\":[54.51925935510945],\"i\":{\"x\":[0.5],\"y\":[0.5]},\"o\":{\"x\":[0.5],\"y\":[0.5]}},{\"t\":80,\"s\":[55.025],\"i\":{\"x\":[0.5],\"y\":[0.5]},\"o\":{\"x\":[0.5],\"y\":[0.5]}},{\"t\":83,\"s\":[55.570522039502336],\"i\":{\"x\":[0.5],\"y\":[0.5]},\"o\":{\"x\":[0.5],\"y\":[0.5]}},{\"t\":85,\"s\":[56.14649144027328],\"i\":{\"x\":[0.5],\"y\":[0.5]},\"o\":{\"x\":[0.5],\"y\":[0.5]}},{\"t\":88,\"s\":[56.74305320617676],\"i\":{\"x\":[0.5],\"y\":[0.5]},\"o\":{\"x\":[0.5],\"y\":[0.5]}},{\"t\":90,\"s\":[57.35],\"i\":{\"x\":[0.5],\"y\":[0.5]},\"o\":{\"x\":[0.5],\"y\":[0.5]}},{\"t\":93,\"s\":[56.81659020181513],\"i\":{\"x\":[0.5],\"y\":[0.5]},\"o\":{\"x\":[0.5],\"y\":[0.5]}},{\"t\":95,\"s\":[54.2162116293766],\"i\":{\"x\":[0.5],\"y\":[0.5]},\"o\":{\"x\":[0.5],\"y\":[0.5]}},{\"t\":98,\"s\":[49.89049702916991],\"i\":{\"x\":[0.5],\"y\":[0.5]},\"o\":{\"x\":[0.5],\"y\":[0.5]}},{\"t\":100,\"s\":[44.20370370370369],\"i\":{\"x\":[0.5],\"y\":[0.5]},\"o\":{\"x\":[0.5],\"y\":[0.5]}},{\"t\":103,\"s\":[37.54330926805095],\"i\":{\"x\":[0.5],\"y\":[0.5]},\"o\":{\"x\":[0.5],\"y\":[0.5]}},{\"t\":105,\"s\":[30.319023266258725],\"i\":{\"x\":[0.5],\"y\":[0.5]},\"o\":{\"x\":[0.5],\"y\":[0.5]}},{\"t\":108,\"s\":[22.96030698554991],\"i\":{\"x\":[0.5],\"y\":[0.5]},\"o\":{\"x\":[0.5],\"y\":[0.5]}},{\"t\":110,\"s\":[15.912560255303102],\"i\":{\"x\":[0.5],\"y\":[0.5]},\"o\":{\"x\":[0.5],\"y\":[0.5]}},{\"t\":113,\"s\":[9.632193722840231],\"i\":{\"x\":[0.5],\"y\":[0.5]},\"o\":{\"x\":[0.5],\"y\":[0.5]}},{\"t\":115,\"s\":[4.580855932758827],\"i\":{\"x\":[0.5],\"y\":[0.5]},\"o\":{\"x\":[0.5],\"y\":[0.5]}},{\"t\":118,\"s\":[1.2191246716338031],\"i\":{\"x\":[0.5],\"y\":[0.5]},\"o\":{\"x\":[0.5],\"y\":[0.5]}},{\"t\":120,\"s\":[0]}]},\"r\":{\"a\":0,\"k\":0},\"p\":{\"a\":1,\"k\":[{\"t\":0,\"s\":[22,30],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":3,\"s\":[20.95579046223959,29.08631665445964],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":5,\"s\":[19.929447639179834,28.188266684282354],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":8,\"s\":[18.938532541079283,27.32121597344437],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":10,\"s\":[18.000000000000004,26.5],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":13,\"s\":[17.129908567930237,25.738669996938956],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":15,\"s\":[16.34314575050762,25.05025253169417],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":18,\"s\":[15.65317327767012,24.446526617961354],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":20,\"s\":[15.071796769724493,23.93782217350893],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":23,\"s\":[14.608963739909708,23.532843272420994],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":25,\"s\":[14.272593389687454,23.238519215976524],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":28,\"s\":[14.068441109009516,23.059885970383327],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":30,\"s\":[14,23],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":33,\"s\":[14.068441109009516,23.059885970383327],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":35,\"s\":[14.272593389687453,23.238519215976524],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":38,\"s\":[14.608963739909708,23.53284327242099],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":40,\"s\":[15.071796769724488,23.937822173508927],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":43,\"s\":[15.653173277670119,24.446526617961354],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":45,\"s\":[16.343145750507617,25.050252531694166],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":48,\"s\":[17.129908567930233,25.738669996938953],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":50,\"s\":[18.000000000000004,26.500000000000004],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":53,\"s\":[18.938532541079276,27.321215973444367],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":55,\"s\":[19.929447639179834,28.188266684282354],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":58,\"s\":[20.955790462239587,29.086316654459637],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":60,\"s\":[21.999999999999996,30],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":63,\"s\":[23.044209537760416,30.913683345540363],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":65,\"s\":[24.070552360820162,31.811733315717643],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":68,\"s\":[25.06146745892072,32.67878402655563],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":70,\"s\":[26,33.5],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":73,\"s\":[26.870091432069763,34.26133000306105],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":75,\"s\":[27.65685424949238,34.94974746830583],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":78,\"s\":[28.34682672232988,35.553473382038646],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":80,\"s\":[28.928203230275507,36.062177826491066],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":83,\"s\":[29.391036260090292,36.46715672757901],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":85,\"s\":[29.727406610312546,36.761480784023476],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":88,\"s\":[29.931558890990484,36.94011402961667],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":90,\"s\":[30,37],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":93,\"s\":[29.931558890990484,36.94011402961667],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":95,\"s\":[29.72740661031255,36.761480784023476],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":98,\"s\":[29.391036260090296,36.46715672757901],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":100,\"s\":[28.928203230275507,36.06217782649107],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":103,\"s\":[28.346826722329883,35.553473382038646],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":105,\"s\":[27.656854249492387,34.94974746830583],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":108,\"s\":[26.870091432069767,34.26133000306105],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":110,\"s\":[26,33.50000000000001],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":113,\"s\":[25.061467458920724,32.67878402655563],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":115,\"s\":[24.070552360820166,31.811733315717646],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":118,\"s\":[23.044209537760423,30.913683345540363],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":120,\"s\":[22,30]}]},\"a\":{\"a\":0,\"k\":[0,0,0]},\"s\":{\"a\":1,\"k\":[{\"t\":0,\"s\":[100,100],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":3,\"s\":[99.08631665445964,99.08631665445964],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":5,\"s\":[98.18826668428235,98.18826668428235],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":8,\"s\":[97.32121597344438,97.32121597344438],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":10,\"s\":[96.5,96.5],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":13,\"s\":[95.73866999693895,95.73866999693895],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":15,\"s\":[95.05025253169417,95.05025253169417],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":18,\"s\":[94.44652661796135,94.44652661796135],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":20,\"s\":[93.93782217350893,93.93782217350893],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":23,\"s\":[93.53284327242099,93.53284327242099],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":25,\"s\":[93.23851921597652,93.23851921597652],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":28,\"s\":[93.05988597038333,93.05988597038333],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":30,\"s\":[93,93],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":33,\"s\":[93.05988597038333,93.05988597038333],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":35,\"s\":[93.23851921597652,93.23851921597652],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":38,\"s\":[93.53284327242099,93.53284327242099],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":40,\"s\":[93.93782217350892,93.93782217350892],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":43,\"s\":[94.44652661796135,94.44652661796135],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":45,\"s\":[95.05025253169417,95.05025253169417],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":48,\"s\":[95.73866999693895,95.73866999693895],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":50,\"s\":[96.5,96.5],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":53,\"s\":[97.32121597344437,97.32121597344437],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":55,\"s\":[98.18826668428235,98.18826668428235],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":58,\"s\":[99.08631665445964,99.08631665445964],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":60,\"s\":[100,100],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":63,\"s\":[100.91368334554036,100.91368334554036],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":65,\"s\":[101.81173331571765,101.81173331571765],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":68,\"s\":[102.67878402655563,102.67878402655563],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":70,\"s\":[103.49999999999999,103.49999999999999],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":73,\"s\":[104.26133000306103,104.26133000306103],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":75,\"s\":[104.94974746830583,104.94974746830583],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":78,\"s\":[105.55347338203865,105.55347338203865],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":80,\"s\":[106.06217782649108,106.06217782649108],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":83,\"s\":[106.46715672757901,106.46715672757901],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":85,\"s\":[106.76148078402348,106.76148078402348],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":88,\"s\":[106.94011402961667,106.94011402961667],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":90,\"s\":[107,107],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":93,\"s\":[106.94011402961667,106.94011402961667],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":95,\"s\":[106.76148078402348,106.76148078402348],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":98,\"s\":[106.46715672757901,106.46715672757901],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":100,\"s\":[106.06217782649108,106.06217782649108],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":103,\"s\":[105.55347338203865,105.55347338203865],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":105,\"s\":[104.94974746830583,104.94974746830583],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":108,\"s\":[104.26133000306103,104.26133000306103],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":110,\"s\":[103.49999999999999,103.49999999999999],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":113,\"s\":[102.67878402655563,102.67878402655563],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":115,\"s\":[101.81173331571765,101.81173331571765],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":118,\"s\":[100.91368334554036,100.91368334554036],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":120,\"s\":[100,100]}]}},\"ao\":0,\"shapes\":[{\"ty\":\"gr\",\"nm\":\"g\",\"it\":[{\"ty\":\"el\",\"nm\":\"e\",\"p\":{\"a\":0,\"k\":[0,0]},\"s\":{\"a\":0,\"k\":[22,22]}},{\"ty\":\"fl\",\"nm\":\"f\",\"c\":{\"a\":0,\"k\":[0.9568627450980393,0.4470588235294118,0.7137254901960784,1]},\"o\":{\"a\":0,\"k\":100},\"r\":1},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[0,0]},\"a\":{\"a\":0,\"k\":[0,0]},\"s\":{\"a\":0,\"k\":[100,100]},\"r\":{\"a\":0,\"k\":0},\"o\":{\"a\":0,\"k\":100},\"sk\":{\"a\":0,\"k\":0},\"sa\":{\"a\":0,\"k\":0}}]}],\"ef\":[{\"ty\":29,\"nm\":\"Gaussian Blur\",\"np\":5,\"mn\":\"ADBE Gaussian Blur 2\",\"ef\":[{\"ty\":0,\"nm\":\"Blurriness\",\"v\":{\"a\":0,\"k\":22}},{\"ty\":7,\"nm\":\"Blur Dimensions\",\"v\":{\"a\":0,\"k\":1}},{\"ty\":7,\"nm\":\"Repeat Edge Pixels\",\"v\":{\"a\":0,\"k\":0}}]}],\"ip\":0,\"op\":120,\"st\":0,\"bm\":0},{\"ddd\":0,\"ind\":4,\"ty\":4,\"nm\":\"yellow\",\"sr\":1,\"ks\":{\"o\":{\"a\":1,\"k\":[{\"t\":0,\"s\":[0],\"i\":{\"x\":[0.5],\"y\":[0.5]},\"o\":{\"x\":[0.5],\"y\":[0.5]}},{\"t\":3,\"s\":[1.1176984198337485],\"i\":{\"x\":[0.5],\"y\":[0.5]},\"o\":{\"x\":[0.5],\"y\":[0.5]}},{\"t\":5,\"s\":[4.17685508896791],\"i\":{\"x\":[0.5],\"y\":[0.5]},\"o\":{\"x\":[0.5],\"y\":[0.5]}},{\"t\":8,\"s\":[8.73794824320537],\"i\":{\"x\":[0.5],\"y\":[0.5]},\"o\":{\"x\":[0.5],\"y\":[0.5]}},{\"t\":10,\"s\":[14.367967806728076],\"i\":{\"x\":[0.5],\"y\":[0.5]},\"o\":{\"x\":[0.5],\"y\":[0.5]}},{\"t\":13,\"s\":[20.645574876823115],\"i\":{\"x\":[0.5],\"y\":[0.5]},\"o\":{\"x\":[0.5],\"y\":[0.5]}},{\"t\":15,\"s\":[27.165244961462502],\"i\":{\"x\":[0.5],\"y\":[0.5]},\"o\":{\"x\":[0.5],\"y\":[0.5]}},{\"t\":18,\"s\":[33.54019187714127],\"i\":{\"x\":[0.5],\"y\":[0.5]},\"o\":{\"x\":[0.5],\"y\":[0.5]}},{\"t\":20,\"s\":[39.40392680354496],\"i\":{\"x\":[0.5],\"y\":[0.5]},\"o\":{\"x\":[0.5],\"y\":[0.5]}},{\"t\":23,\"s\":[44.41037006297262],\"i\":{\"x\":[0.5],\"y\":[0.5]},\"o\":{\"x\":[0.5],\"y\":[0.5]}},{\"t\":25,\"s\":[48.23249946247958],\"i\":{\"x\":[0.5],\"y\":[0.5]},\"o\":{\"x\":[0.5],\"y\":[0.5]}},{\"t\":28,\"s\":[50.559586117779496],\"i\":{\"x\":[0.5],\"y\":[0.5]},\"o\":{\"x\":[0.5],\"y\":[0.5]}},{\"t\":30,\"s\":[51.09313415252774],\"i\":{\"x\":[0.5],\"y\":[0.5]},\"o\":{\"x\":[0.5],\"y\":[0.5]}},{\"t\":33,\"s\":[50.65565759573217],\"i\":{\"x\":[0.5],\"y\":[0.5]},\"o\":{\"x\":[0.5],\"y\":[0.5]}},{\"t\":35,\"s\":[50.26941506766217],\"i\":{\"x\":[0.5],\"y\":[0.5]},\"o\":{\"x\":[0.5],\"y\":[0.5]}},{\"t\":38,\"s\":[49.9410152850597],\"i\":{\"x\":[0.5],\"y\":[0.5]},\"o\":{\"x\":[0.5],\"y\":[0.5]}},{\"t\":40,\"s\":[49.67607725925468],\"i\":{\"x\":[0.5],\"y\":[0.5]},\"o\":{\"x\":[0.5],\"y\":[0.5]}},{\"t\":43,\"s\":[49.47913415332336],\"i\":{\"x\":[0.5],\"y\":[0.5]},\"o\":{\"x\":[0.5],\"y\":[0.5]}},{\"t\":45,\"s\":[49.35355571841115],\"i\":{\"x\":[0.5],\"y\":[0.5]},\"o\":{\"x\":[0.5],\"y\":[0.5]}},{\"t\":48,\"s\":[49.30149063635633],\"i\":{\"x\":[0.5],\"y\":[0.5]},\"o\":{\"x\":[0.5],\"y\":[0.5]}},{\"t\":50,\"s\":[49.32382975514801],\"i\":{\"x\":[0.5],\"y\":[0.5]},\"o\":{\"x\":[0.5],\"y\":[0.5]}},{\"t\":53,\"s\":[49.42019084627011],\"i\":{\"x\":[0.5],\"y\":[0.5]},\"o\":{\"x\":[0.5],\"y\":[0.5]}},{\"t\":55,\"s\":[49.588925144737175],\"i\":{\"x\":[0.5],\"y\":[0.5]},\"o\":{\"x\":[0.5],\"y\":[0.5]}},{\"t\":58,\"s\":[49.82714555992045],\"i\":{\"x\":[0.5],\"y\":[0.5]},\"o\":{\"x\":[0.5],\"y\":[0.5]}},{\"t\":60,\"s\":[50.130776074468976],\"i\":{\"x\":[0.5],\"y\":[0.5]},\"o\":{\"x\":[0.5],\"y\":[0.5]}},{\"t\":63,\"s\":[50.49462148609655],\"i\":{\"x\":[0.5],\"y\":[0.5]},\"o\":{\"x\":[0.5],\"y\":[0.5]}},{\"t\":65,\"s\":[50.91245629893321],\"i\":{\"x\":[0.5],\"y\":[0.5]},\"o\":{\"x\":[0.5],\"y\":[0.5]}},{\"t\":68,\"s\":[51.37713124348562],\"i\":{\"x\":[0.5],\"y\":[0.5]},\"o\":{\"x\":[0.5],\"y\":[0.5]}},{\"t\":70,\"s\":[51.880695602620264],\"i\":{\"x\":[0.5],\"y\":[0.5]},\"o\":{\"x\":[0.5],\"y\":[0.5]}},{\"t\":73,\"s\":[52.41453325053794],\"i\":{\"x\":[0.5],\"y\":[0.5]},\"o\":{\"x\":[0.5],\"y\":[0.5]}},{\"t\":75,\"s\":[52.969510077075],\"i\":{\"x\":[0.5],\"y\":[0.5]},\"o\":{\"x\":[0.5],\"y\":[0.5]}},{\"t\":78,\"s\":[53.53613027486075],\"i\":{\"x\":[0.5],\"y\":[0.5]},\"o\":{\"x\":[0.5],\"y\":[0.5]}},{\"t\":80,\"s\":[54.10469881521429],\"i\":{\"x\":[0.5],\"y\":[0.5]},\"o\":{\"x\":[0.5],\"y\":[0.5]}},{\"t\":83,\"s\":[54.665487332773175],\"i\":{\"x\":[0.5],\"y\":[0.5]},\"o\":{\"x\":[0.5],\"y\":[0.5]}},{\"t\":85,\"s\":[55.20890058052205],\"i\":{\"x\":[0.5],\"y\":[0.5]},\"o\":{\"x\":[0.5],\"y\":[0.5]}},{\"t\":88,\"s\":[55.72564060712929],\"i\":{\"x\":[0.5],\"y\":[0.5]},\"o\":{\"x\":[0.5],\"y\":[0.5]}},{\"t\":90,\"s\":[56.20686584747225],\"i\":{\"x\":[0.5],\"y\":[0.5]},\"o\":{\"x\":[0.5],\"y\":[0.5]}},{\"t\":93,\"s\":[55.52981251899867],\"i\":{\"x\":[0.5],\"y\":[0.5]},\"o\":{\"x\":[0.5],\"y\":[0.5]}},{\"t\":95,\"s\":[52.80609715957206],\"i\":{\"x\":[0.5],\"y\":[0.5]},\"o\":{\"x\":[0.5],\"y\":[0.5]}},{\"t\":98,\"s\":[48.39664335323088],\"i\":{\"x\":[0.5],\"y\":[0.5]},\"o\":{\"x\":[0.5],\"y\":[0.5]}},{\"t\":100,\"s\":[42.68438721536689],\"i\":{\"x\":[0.5],\"y\":[0.5]},\"o\":{\"x\":[0.5],\"y\":[0.5]}},{\"t\":103,\"s\":[36.07111885573926],\"i\":{\"x\":[0.5],\"y\":[0.5]},\"o\":{\"x\":[0.5],\"y\":[0.5]}},{\"t\":105,\"s\":[28.973222140794423],\"i\":{\"x\":[0.5],\"y\":[0.5]},\"o\":{\"x\":[0.5],\"y\":[0.5]}},{\"t\":108,\"s\":[21.816568915722435],\"i\":{\"x\":[0.5],\"y\":[0.5]},\"o\":{\"x\":[0.5],\"y\":[0.5]}},{\"t\":110,\"s\":[15.03085895236904],\"i\":{\"x\":[0.5],\"y\":[0.5]},\"o\":{\"x\":[0.5],\"y\":[0.5]}},{\"t\":113,\"s\":[9.043720180270295],\"i\":{\"x\":[0.5],\"y\":[0.5]},\"o\":{\"x\":[0.5],\"y\":[0.5]}},{\"t\":115,\"s\":[4.274894433723172],\"i\":{\"x\":[0.5],\"y\":[0.5]},\"o\":{\"x\":[0.5],\"y\":[0.5]}},{\"t\":118,\"s\":[1.1308316267145349],\"i\":{\"x\":[0.5],\"y\":[0.5]},\"o\":{\"x\":[0.5],\"y\":[0.5]}},{\"t\":120,\"s\":[0]}]},\"r\":{\"a\":0,\"k\":0},\"p\":{\"a\":1,\"k\":[{\"t\":0,\"s\":[27.535533905932738,20.464466094067262],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":3,\"s\":[27.966766701456176,20.956192854956395],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":5,\"s\":[28.33012701892219,21.499999999999996],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":8,\"s\":[28.619397662556434,22.08658283817455],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":10,\"s\":[28.82962913144534,22.705904774487397],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":13,\"s\":[28.95722430686905,23.347369038899743],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":15,\"s\":[29,24],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":18,\"s\":[28.95722430686905,24.652630961100257],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":20,\"s\":[28.82962913144534,25.294095225512603],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":23,\"s\":[28.619397662556434,25.91341716182545],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":25,\"s\":[28.33012701892219,26.5],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":28,\"s\":[27.966766701456176,27.0438071450436],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":30,\"s\":[27.535533905932738,27.535533905932738],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":33,\"s\":[27.043807145043605,27.966766701456173],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":35,\"s\":[26.5,28.330127018922195],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":38,\"s\":[25.91341716182545,28.61939766255643],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":40,\"s\":[25.294095225512606,28.82962913144534],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":43,\"s\":[24.652630961100257,28.95722430686905],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":45,\"s\":[24,29],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":48,\"s\":[23.347369038899743,28.95722430686905],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":50,\"s\":[22.705904774487397,28.829629131445344],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":53,\"s\":[22.08658283817455,28.619397662556434],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":55,\"s\":[21.5,28.330127018922195],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":58,\"s\":[20.9561928549564,27.966766701456176],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":60,\"s\":[20.464466094067262,27.535533905932738],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":63,\"s\":[20.033233298543827,27.043807145043605],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":65,\"s\":[19.66987298107781,26.500000000000004],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":68,\"s\":[19.38060233744357,25.913417161825453],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":70,\"s\":[19.17037086855466,25.294095225512603],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":73,\"s\":[19.04277569313095,24.652630961100265],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":75,\"s\":[19,24],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":78,\"s\":[19.04277569313095,23.347369038899743],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":80,\"s\":[19.170370868554656,22.7059047744874],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":83,\"s\":[19.380602337443566,22.08658283817455],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":85,\"s\":[19.66987298107781,21.499999999999996],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":88,\"s\":[20.033233298543824,20.9561928549564],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":90,\"s\":[20.464466094067262,20.464466094067266],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":93,\"s\":[20.956192854956395,20.033233298543827],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":95,\"s\":[21.499999999999996,19.669872981077805],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":98,\"s\":[22.086582838174554,19.380602337443563],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":100,\"s\":[22.705904774487397,19.17037086855466],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":103,\"s\":[23.347369038899743,19.04277569313095],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":105,\"s\":[24,19],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":108,\"s\":[24.652630961100257,19.04277569313095],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":110,\"s\":[25.294095225512603,19.170370868554656],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":113,\"s\":[25.913417161825446,19.380602337443563],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":115,\"s\":[26.5,19.669872981077805],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":118,\"s\":[27.0438071450436,20.033233298543824],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":120,\"s\":[27.535533905932738,20.464466094067262]}]},\"a\":{\"a\":0,\"k\":[0,0,0]},\"s\":{\"a\":1,\"k\":[{\"t\":0,\"s\":[105.65685424949238,105.65685424949238],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":3,\"s\":[106.3468267223299,106.3468267223299],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":5,\"s\":[106.9282032302755,106.9282032302755],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":8,\"s\":[107.3910362600903,107.3910362600903],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":10,\"s\":[107.72740661031254,107.72740661031254],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":13,\"s\":[107.93155889099049,107.93155889099049],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":15,\"s\":[108,108],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":18,\"s\":[107.93155889099049,107.93155889099049],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":20,\"s\":[107.72740661031254,107.72740661031254],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":23,\"s\":[107.3910362600903,107.3910362600903],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":25,\"s\":[106.9282032302755,106.9282032302755],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":28,\"s\":[106.3468267223299,106.3468267223299],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":30,\"s\":[105.65685424949238,105.65685424949238],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":33,\"s\":[104.87009143206976,104.87009143206976],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":35,\"s\":[104,104],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":38,\"s\":[103.0614674589207,103.0614674589207],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":40,\"s\":[102.07055236082016,102.07055236082016],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":43,\"s\":[101.04420953776041,101.04420953776041],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":45,\"s\":[100,100],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":48,\"s\":[98.95579046223959,98.95579046223959],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":50,\"s\":[97.92944763917984,97.92944763917984],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":53,\"s\":[96.93853254107928,96.93853254107928],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":55,\"s\":[96,96],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":58,\"s\":[95.12990856793023,95.12990856793023],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":60,\"s\":[94.34314575050762,94.34314575050762],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":63,\"s\":[93.65317327767012,93.65317327767012],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":65,\"s\":[93.07179676972449,93.07179676972449],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":68,\"s\":[92.60896373990971,92.60896373990971],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":70,\"s\":[92.27259338968746,92.27259338968746],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":73,\"s\":[92.06844110900951,92.06844110900951],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":75,\"s\":[92,92],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":78,\"s\":[92.06844110900951,92.06844110900951],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":80,\"s\":[92.27259338968746,92.27259338968746],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":83,\"s\":[92.6089637399097,92.6089637399097],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":85,\"s\":[93.07179676972449,93.07179676972449],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":88,\"s\":[93.65317327767012,93.65317327767012],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":90,\"s\":[94.34314575050762,94.34314575050762],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":93,\"s\":[95.12990856793023,95.12990856793023],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":95,\"s\":[96,96],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":98,\"s\":[96.93853254107928,96.93853254107928],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":100,\"s\":[97.92944763917984,97.92944763917984],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":103,\"s\":[98.95579046223959,98.95579046223959],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":105,\"s\":[100,100],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":108,\"s\":[101.04420953776041,101.04420953776041],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":110,\"s\":[102.07055236082016,102.07055236082016],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":113,\"s\":[103.0614674589207,103.0614674589207],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":115,\"s\":[104,104],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":118,\"s\":[104.87009143206976,104.87009143206976],\"i\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]},\"o\":{\"x\":[0.5,0.5],\"y\":[0.5,0.5]}},{\"t\":120,\"s\":[105.65685424949238,105.65685424949238]}]}},\"ao\":0,\"shapes\":[{\"ty\":\"gr\",\"nm\":\"g\",\"it\":[{\"ty\":\"el\",\"nm\":\"e\",\"p\":{\"a\":0,\"k\":[0,0]},\"s\":{\"a\":0,\"k\":[18,18]}},{\"ty\":\"fl\",\"nm\":\"f\",\"c\":{\"a\":0,\"k\":[0.9803921568627451,0.8,0.08235294117647059,1]},\"o\":{\"a\":0,\"k\":100},\"r\":1},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[0,0]},\"a\":{\"a\":0,\"k\":[0,0]},\"s\":{\"a\":0,\"k\":[100,100]},\"r\":{\"a\":0,\"k\":0},\"o\":{\"a\":0,\"k\":100},\"sk\":{\"a\":0,\"k\":0},\"sa\":{\"a\":0,\"k\":0}}]}],\"ef\":[{\"ty\":29,\"nm\":\"Gaussian Blur\",\"np\":5,\"mn\":\"ADBE Gaussian Blur 2\",\"ef\":[{\"ty\":0,\"nm\":\"Blurriness\",\"v\":{\"a\":0,\"k\":16}},{\"ty\":7,\"nm\":\"Blur Dimensions\",\"v\":{\"a\":0,\"k\":1}},{\"ty\":7,\"nm\":\"Repeat Edge Pixels\",\"v\":{\"a\":0,\"k\":0}}]}],\"ip\":0,\"op\":120,\"st\":0,\"bm\":0}],\"meta\":{\"g\":\"replit\",\"a\":\"rovo\",\"k\":\"glow,liquid,blobs\",\"d\":\"Liquid glow blobs, fade in/out\"}}");


const $0fb69e02722ded52$var$styles = {
    glowOverlay: "_0bjKvDuMRm _4bt5LAnQyn _2WAcuGnQyn _1mT5xdWVPG _2IhTon715P _3OE6xY715P _1VJPcaiDnZ _39xV02pJKa _0jFU0VpJKa _1pp6NdYbGa _42Yu6B7dHp _3NPCoqYbGa"
};
function $0fb69e02722ded52$export$c18249cbd1532738() {
    const [visible, setVisible] = (0, $cozmU.useState)(true);
    if (!visible) return null;
    return /*#__PURE__*/ $cozmU.createElement("div", {
        style: {
            opacity: 0.6
        },
        "aria-hidden": "true",
        className: (0, $hekY6.default)([
            $0fb69e02722ded52$var$styles.glowOverlay
        ])
    }, /*#__PURE__*/ $cozmU.createElement((0, (/*@__PURE__*/$parcel$interopDefault($iHsYL))), {
        animationData: (0, (/*@__PURE__*/$parcel$interopDefault($39691e3198a56ca7$exports))),
        loop: false,
        onComplete: ()=>setVisible(false)
    }));
}


/* index.tsx generated by @compiled/babel-plugin v2.0.0 */ 












var $1sCHt = parcelRequire("1sCHt");


var $aRvnq = parcelRequire("aRvnq");


var $l3wuH = parcelRequire("l3wuH");


var $4yg9g = parcelRequire("4yg9g");

const $10f7ee76fcc6cf65$var$i18n = (0, $kSwu1.defineMessages)({
    placeholder: {
        id: "ai-smart-button.ai-smart-button.ai-smart-button-ui.quick-input.placeholder",
        defaultMessage: "Ask Rovo anything\u2026"
    },
    clearLabel: {
        id: "ai-smart-button.ai-smart-button.ai-smart-button-ui.quick-input.clearLabel",
        defaultMessage: "Clear question"
    },
    submitLabel: {
        id: "ai-smart-button.ai-smart-button.ai-smart-button-ui.quick-input.submitLabel",
        defaultMessage: "Send question"
    }
});
const $10f7ee76fcc6cf65$var$styles = {
    form: "_2mHwu82ADO _3iDTPbQ4SZ _0hPCNLDIqT _39xV02sz7G _0LQT5E8HPE",
    input: "_4ouGXIdnbC _1UtDYze5R3 _3AxjleKGUX",
    actions: "_2mHwu81Y8M _3iDTPbQ4SZ _0hPCNLDIqT _3YEZNOdnbC",
    submitButtonWrapper: "_0bjKvDS5Zs _3iDTPbQ4SZ",
    disabledSubmitButtonWrapper: "_0KLXrukTlo"
};
function $10f7ee76fcc6cf65$export$fec47ab16aaceba9({ onOverflowChange: onOverflowChange, onPromptChange: onPromptChange, onStart: onStart, onSubmit: onSubmit }) {
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const [prompt, setPrompt] = (0, $cozmU.useState)('');
    const inputRef = (0, $cozmU.useRef)(null);
    const hasStartedRef = (0, $cozmU.useRef)(false);
    const trimmedPrompt = prompt.trim();
    const updateOverflow = (0, $cozmU.useCallback)(()=>{
        const input = inputRef.current;
        onOverflowChange?.(Boolean(input?.value.trim() && input.scrollWidth > input.clientWidth));
    }, [
        onOverflowChange
    ]);
    (0, $cozmU.useEffect)(()=>{
        updateOverflow();
    }, [
        prompt,
        updateOverflow
    ]);
    (0, $cozmU.useEffect)(()=>{
        const input = inputRef.current;
        if (!input || typeof ResizeObserver === 'undefined') return;
        const resizeObserver = new ResizeObserver(updateOverflow);
        resizeObserver.observe(input);
        return ()=>resizeObserver.disconnect();
    }, [
        updateOverflow
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("form", {
        "data-quick-input": true,
        onSubmit: (event)=>{
            event.preventDefault();
            if (!trimmedPrompt) return;
            onSubmit?.(trimmedPrompt);
        },
        className: (0, $hekY6.default)([
            $10f7ee76fcc6cf65$var$styles.form
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4yg9g.default), {
        appearance: "none",
        "aria-label": formatMessage($10f7ee76fcc6cf65$var$i18n.placeholder),
        placeholder: formatMessage($10f7ee76fcc6cf65$var$i18n.placeholder),
        ref: inputRef,
        testId: "rovo-button-quick-input",
        value: prompt,
        onChange: (event)=>{
            const nextPrompt = event.currentTarget.value;
            setPrompt(nextPrompt);
            onPromptChange?.(nextPrompt);
            if (!hasStartedRef.current && nextPrompt.trim()) {
                hasStartedRef.current = true;
                onStart?.();
            }
        },
        onMouseDownCapture: ()=>{
            const input = inputRef.current;
            if (input && (0, $1hQ0e.getDocument)()?.activeElement !== input) {
                input.setSelectionRange(0, 0);
                input.scrollLeft = 0;
            }
        },
        className: (0, $hekY6.default)([
            $10f7ee76fcc6cf65$var$styles.input
        ])
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        className: (0, $hekY6.default)([
            $10f7ee76fcc6cf65$var$styles.actions
        ])
    }, prompt.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1sCHt.default), {
        appearance: "subtle",
        icon: (iconProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($l3wuH))), {
                ...iconProps,
                color: "var(--ds-icon-subtle, #505258)",
                size: "small"
            }),
        label: formatMessage($10f7ee76fcc6cf65$var$i18n.clearLabel),
        onClick: ()=>{
            setPrompt('');
            onPromptChange?.('');
            inputRef.current?.focus();
        },
        shape: "circle",
        type: "button"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", {
        "data-testid": "rovo-button-quick-input-submit-wrapper",
        className: (0, $hekY6.default)([
            $10f7ee76fcc6cf65$var$styles.submitButtonWrapper,
            !trimmedPrompt && $10f7ee76fcc6cf65$var$styles.disabledSubmitButtonWrapper
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1sCHt.default), {
        appearance: "primary",
        icon: (iconProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($aRvnq))), {
                ...iconProps,
                color: !trimmedPrompt ? "var(--ds-icon-subtlest, #6B6E76)" : undefined
            }),
        isDisabled: !trimmedPrompt,
        label: formatMessage($10f7ee76fcc6cf65$var$i18n.submitLabel),
        shape: "circle",
        type: "submit"
    }))));
}


/* continue-in-chat.tsx generated by @compiled/babel-plugin v2.0.0 */ 











var $4aRua = parcelRequire("4aRua");

const $0a98db3c9d067baf$var$i18n = (0, $kSwu1.defineMessages)({
    label: {
        id: "ai-smart-button.ai-smart-button.ai-smart-button-ui.quick-input.continue-in-chat.label",
        defaultMessage: "Continue in chat"
    }
});
const $0a98db3c9d067baf$var$styles = {
    button: "_2mHwu82ADO _0bjKvDyzSk _4c065U1Y8M _2Y7lL42ADO _3iDTPbQ4SZ _0hPCNLDIqT _4kiQYAoWWg _1ANEUSLRg7 _1UtDYze5R3 _0KLXrugozt _0wOv4Q7zJH _1eOmH6kTlo _3gzVzLVbka"
};
function $0a98db3c9d067baf$export$811443fa679fd0b7({ onClick: onClick }) {
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hBYtq.Pressable), {
        xcss: $0a98db3c9d067baf$var$styles.button,
        onClick: onClick,
        testId: "rovo-button-continue-in-chat",
        type: "button"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        color: "inherit"
    }, formatMessage($0a98db3c9d067baf$var$i18n.label)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($aRvnq))), {
        label: "",
        size: "small"
    }));
}


/* index.tsx generated by @compiled/babel-plugin v2.0.0 */ 








const $5376dc69e77beff0$var$styles = {
    wrapper: "_3iDTPbccYA _0hPCNLDIqT _37wbyuF05b _1mT5xdRAKS",
    pill: "_0bjKvDuMRm _23rrnHaO0L _3iDTPbccYA _0hPCNLDIqT _37wbyuF05b _0KLXrugozt _2OUyjtH3uR _1VJPcaHW0I _0yKXXaatqR _1sLQ8qC67X",
    overlay: "_3iDTPbYbGa _1mT5xdWVPG _4ApkO2Pgdg _0Bm75GN91d _1DCdHi2ADO _42Yu6B7dHp",
    showOverlayForQuickInputFocus: "_0zsViEvLZJ",
    hoverScale: "_3NJLv81VUY _46ILVR1VUY",
    expandPill: "_4bt5LAnQyn _2WAcuGnQyn _23rrnHu4wg _3iDTPbgBM8 _4xdlr0FlnN _2iEGP2VDI5 _1SdfoHYbGa",
    expandPillExpanded: "_2iEGP2UfmU",
    expandPillClip: "_23rrnH18Ym _3iDTPbQ4SZ _1ANEUSLRg7 _4ouGXIdnbC _0fKRyPnQyn _1VJPcaKthN _1sLQ8qC67X _1SdfoHYbGa",
    expandPillClipExpanded: "_0fKRyPYvD1 _1VJPcalna5 _3OZqoKUiLg"
};
function $5376dc69e77beff0$export$74b768e0056334f4({ children: children, expandedContent: expandedContent, isExpansionSuppressed: isExpansionSuppressed = false, onExpandedChange: onExpandedChange, overlayContent: overlayContent, testId: testId }) {
    const [isHovered, setIsHovered] = (0, $cozmU.useState)(false);
    const [isFocusWithin, setIsFocusWithin] = (0, $cozmU.useState)(false);
    const isExpanded = !isExpansionSuppressed && (isHovered || isFocusWithin);
    (0, $cozmU.useEffect)(()=>{
        onExpandedChange?.(isExpanded);
    }, [
        isExpanded,
        onExpandedChange
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: (0, $w6R6I.cx)($5376dc69e77beff0$var$styles.wrapper, !!overlayContent && $5376dc69e77beff0$var$styles.showOverlayForQuickInputFocus),
        onMouseEnter: ()=>setIsHovered(true),
        onMouseLeave: ()=>setIsHovered(false),
        onFocus: ()=>setIsFocusWithin(true),
        onBlur: (event)=>{
            if (!event.currentTarget.contains(event.relatedTarget)) setIsFocusWithin(false);
        }
    }, isExpanded && overlayContent && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $5376dc69e77beff0$var$styles.overlay,
        "data-quick-input-overlay": true
    }, overlayContent), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        testId: testId,
        xcss: (0, $w6R6I.cx)($5376dc69e77beff0$var$styles.pill, $5376dc69e77beff0$var$styles.hoverScale)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: (0, $w6R6I.cx)($5376dc69e77beff0$var$styles.expandPill, isExpanded && $5376dc69e77beff0$var$styles.expandPillExpanded),
        "data-expandable-pill": true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: (0, $w6R6I.cx)($5376dc69e77beff0$var$styles.expandPillClip, isExpanded && $5376dc69e77beff0$var$styles.expandPillClipExpanded),
        "data-expandable-pill-clip": true
    }, expandedContent)), children));
}


const $c391f500d982e61a$var$i18n = (0, $kSwu1.defineMessages)({
    tooltipLabel: {
        id: "ai-smart-button.tooltip.label.v3",
        defaultMessage: "Ask Rovo anything"
    },
    tooltipUnreadSuffix: {
        id: "ai-smart-button.tooltip.unread-suffix.v2",
        defaultMessage: "{count, plural, one {# unread chat} other {# unread chats}}"
    },
    tooltipInProgress: {
        id: "ai-smart-button.tooltip.in-progress.v2",
        defaultMessage: "{count, plural, one {# task in progress} other {# tasks in progress}}"
    },
    tooltipAwaitingInput: {
        id: "ai-smart-button.tooltip.awaiting-input.v3",
        defaultMessage: "{count, plural, one {# task needs input} other {# tasks need input}}"
    }
});
const $c391f500d982e61a$var$styles = {
    buttonWrapper: "_1mT5xdRAKS",
    tooltipContent: "_2fwxA5ecOK",
    expandPillInteractive: "_30huDKYbGa _2sNsIg7NXe _034jHtYbGa _0wOv4Q7zJH _0KLXrujOvk _3iDTPbQ4SZ _0hPCNLDIqT _1UtDYze5R3 _2OgLIsj02L",
    expandPillInner: "_2sNsIg7NXe _3iDTPbQ4SZ _0aFT5vbt8w _37wbyuDIqT _0hPCNLz9WS _1ANEUSLRg7 _1UtDYze5R3",
    expandedPillContent: "_1UtDYze5R3 _3iDTPbQ4SZ _0hPCNLDIqT _37wbyu7p2s _0LQT5E8HPE"
};

const $c391f500d982e61a$export$21695acdb18697b9 = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ onClick: onClick, isDisabled: isDisabled, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, onQuickInputContinueInChat: onQuickInputContinueInChat, onQuickInputSubmit: onQuickInputSubmit, proximityAnimationKey: proximityAnimationKey, onChatHistoryClick: onChatHistoryClick, onUnreadConversationClick: onUnreadConversationClick }, ref)=>{
    const { sidebarApi: sidebarApi, analyticsAttributes: analyticsAttributes, product: product, productPage: productPage, getActions: getActions, onAnchorElementReady: onAnchorElementReady } = (0, $61R7O.useAISmartButtonContext)();
    const isUnreadIndicatorEnabled = (0, $4o0zT.isExperimentEnabled)('rovo_button_unread_indicator');
    const isDailyBriefEnabled = (0, $iDrrr.fg)('rovo_button_daily_brief_nudge');
    const isQuickInputEnabled = (0, $4o0zT.isExperimentEnabled)('rovo_button_quick_chat_input');
    const unreadStatusHookEnabled = isUnreadIndicatorEnabled || isDailyBriefEnabled || isQuickInputEnabled;
    const { hasUnread: hasUnread, unreadCount: unreadCount, inProgressCount: inProgressCount, awaitingInputCount: awaitingInputCount, mostRecentUnread: mostRecentUnread, mostRecentInProgress: mostRecentInProgress, mostRecentAwaitingInput: mostRecentAwaitingInput, isStatusReady: isStatusReady } = (0, $957d07ec48bc7f6c$export$e34a0a17cdc941c7)({
        enabled: unreadStatusHookEnabled
    });
    (0, $16bdf26a3ae62ad8$export$187304f0ff940bd0)({
        enabled: isDailyBriefEnabled,
        mostRecentUnread: mostRecentUnread
    }); // Awaiting-input drives the button's needs-input icon. The expanded label can
    // show awaiting-input alongside unread or in-progress counts when multiple
    // conversation states are present.
    // (TREX-1891)
    const displayAwaitingInputCount = isUnreadIndicatorEnabled ? awaitingInputCount : 0;
    const displayUnreadCount = isUnreadIndicatorEnabled && hasUnread ? unreadCount : 0;
    const displayInProgressCount = isUnreadIndicatorEnabled ? inProgressCount : 0;
    const showAwaitingInput = displayAwaitingInputCount > 0;
    const showUnread = displayUnreadCount > 0;
    const hasVisibleConversationStatus = showUnread || displayInProgressCount > 0 || showAwaitingInput;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const { toggleConversationAssistantUIMode: toggleConversationAssistantUIMode } = (0, $93Gae.useRovoExperienceAPIStore)();
    const { fireRovoButtonUIEvent: fireRovoButtonUIEvent } = (0, $eM9tg.useRovoButtonEventsInstrumentation)();
    const fireQuickInputUIEvent = (0, $cozmU.useCallback)((action, actionSubjectId = 'aiRovoQuickInput')=>{
        fireRovoButtonUIEvent({
            source: productPage,
            action: action,
            actionSubject: 'rovoButton',
            actionSubjectId: actionSubjectId,
            attributes: {
                product: product,
                productPage: productPage,
                ...analyticsAttributes,
                version: 'refresh'
            },
            product: product
        });
    }, [
        analyticsAttributes,
        fireRovoButtonUIEvent,
        product,
        productPage
    ]);
    const fireConversationStatusUIEvent = (0, $cozmU.useCallback)((action, destination)=>{
        fireRovoButtonUIEvent({
            source: productPage,
            action: action,
            actionSubject: 'rovoButton',
            actionSubjectId: 'aiRovoConversationStatus',
            attributes: {
                product: product,
                productPage: productPage,
                ...analyticsAttributes,
                version: 'refresh',
                unreadCount: displayUnreadCount,
                inProgressCount: displayInProgressCount,
                awaitingInputCount: displayAwaitingInputCount,
                totalConversationCount: displayUnreadCount + displayInProgressCount + displayAwaitingInputCount,
                ...destination ? {
                    destination: destination
                } : {}
            },
            product: product
        });
    }, [
        analyticsAttributes,
        displayAwaitingInputCount,
        displayInProgressCount,
        displayUnreadCount,
        fireRovoButtonUIEvent,
        product,
        productPage
    ]);
    const handleQuickInputStarted = (0, $cozmU.useCallback)(()=>{
        fireQuickInputUIEvent('started');
    }, [
        fireQuickInputUIEvent
    ]);
    const handleQuickInputSubmit = (0, $cozmU.useCallback)((prompt)=>{
        fireQuickInputUIEvent('submitted');
        onQuickInputSubmit?.(prompt);
    }, [
        fireQuickInputUIEvent,
        onQuickInputSubmit
    ]);
    const handleQuickInputContinueInChat = (0, $cozmU.useCallback)((prompt)=>{
        fireQuickInputUIEvent('clicked', 'aiRovoQuickInputContinueInChat');
        onQuickInputContinueInChat?.(prompt);
    }, [
        fireQuickInputUIEvent,
        onQuickInputContinueInChat
    ]);
    const [canShowNudge, setCanShowNudge] = (0, $cozmU.useState)(false);
    const [spotlightRendered, setSpotlightRendered] = (0, $cozmU.useState)(false);
    const [hasActiveNudge, setHasActiveNudge] = (0, $cozmU.useState)(false);
    const nudgeCounterRef = (0, $cozmU.useRef)(0);
    const handleActiveNudgeChange = (0, $cozmU.useCallback)((active)=>{
        setHasActiveNudge((prev)=>{
            if (active && !prev) nudgeCounterRef.current += 1;
            return active;
        });
    }, []);
    const [isHovering, setIsHovering] = (0, $cozmU.useState)(false);
    const [isExpanded, setIsExpanded] = (0, $cozmU.useState)(false);
    const quickInputPromptRef = (0, $cozmU.useRef)('');
    const [isQuickInputOverflowing, setIsQuickInputOverflowing] = (0, $cozmU.useState)(false); // Only wait for conversation status when its indicator is enabled. Hidden
    // statuses must not precondition the quick-input experiment.
    const isConversationStatusPending = isUnreadIndicatorEnabled && !isStatusReady;
    const canShowQuickInput = isQuickInputEnabled && !isConversationStatusPending && !hasVisibleConversationStatus && !hasActiveNudge;
    const wasQuickInputExpandedRef = (0, $cozmU.useRef)(false);
    const wasConversationStatusExpandedRef = (0, $cozmU.useRef)(false);
    const handleExpandedChange = (0, $cozmU.useCallback)((expanded)=>{
        setIsExpanded(expanded);
        const isQuickInputExpanded = expanded && canShowQuickInput;
        if (isQuickInputExpanded && !wasQuickInputExpandedRef.current) fireQuickInputUIEvent('expanded');
        wasQuickInputExpandedRef.current = isQuickInputExpanded;
        const isConversationStatusExpanded = expanded && hasVisibleConversationStatus;
        if (isConversationStatusExpanded && !wasConversationStatusExpandedRef.current) fireConversationStatusUIEvent('expanded');
        wasConversationStatusExpandedRef.current = isConversationStatusExpanded;
    }, [
        canShowQuickInput,
        fireConversationStatusUIEvent,
        fireQuickInputUIEvent,
        hasVisibleConversationStatus
    ]);
    const handleQuickInputPromptChange = (0, $cozmU.useCallback)((prompt)=>{
        quickInputPromptRef.current = prompt;
    }, []);
    const [actionShortcuts, setActionShortcuts] = (0, $cozmU.useState)([]);
    const placementElementRef = (0, $cozmU.useRef)(null);
    const notifiedSpotlightAnchorIdRef = (0, $cozmU.useRef)();
    const hoverTimeoutRef = (0, $cozmU.useRef)();
    const onboardingSpotlightElementId = (0, $cozmU.useMemo)(()=>{
        const isLiveOrEditPage = analyticsAttributes?.pageMode === 'live' || analyticsAttributes?.pageMode === 'edit';
        const isPageOrBlogpost = productPage === 'page' || productPage === 'blogpost';
        if (isPageOrBlogpost && isLiveOrEditPage) return `rovo-button-onboarding-spotlight-live-or-edit`;
        return `rovo-button-onboarding-spotlight`;
    }, [
        productPage,
        analyticsAttributes
    ]);
    (0, $cozmU.useEffect)(()=>{
        const placementElement = placementElementRef.current;
        if (!placementElement?.isConnected || placementElement.id !== onboardingSpotlightElementId || notifiedSpotlightAnchorIdRef.current === onboardingSpotlightElementId) return;
        notifiedSpotlightAnchorIdRef.current = onboardingSpotlightElementId;
        onAnchorElementReady?.(onboardingSpotlightElementId);
    }, [
        onAnchorElementReady,
        onboardingSpotlightElementId
    ]); // Fetch action shortcuts when experiment is enabled
    const slaOperationsEnabled = (0, $iDrrr.fg)('jmb-4989_add_sla_operations_in_rovo');
    (0, $cozmU.useEffect)(()=>{
        const shouldFetch = getActions && product === 'jira' && slaOperationsEnabled;
        if (shouldFetch) getActions().then((actions)=>{
            // Filter to only get actions that can be used as shortcuts (Base, Chat, or Skill e.g. Jira SLA when feature-flagged)
            const shortcuts = actions.filter((action)=>action.handleType === (0, $6iWVH.HandleActionType).Base || action.handleType === (0, $6iWVH.HandleActionType).Chat || slaOperationsEnabled && action.handleType === (0, $6iWVH.HandleActionType).Skill);
            const slicedShortcuts = shortcuts.slice(0, 3);
            setActionShortcuts(slicedShortcuts);
        }).catch(()=>{
            setActionShortcuts([]);
        });
    }, [
        getActions,
        product,
        slaOperationsEnabled
    ]); // Handle "Get Started" button click from spotlight
    const handleGetStartedClick = (0, $cozmU.useCallback)(()=>{
        if (sidebarApi) toggleConversationAssistantUIMode({
            targetMode: 'mini-modal',
            sidebarApi: sidebarApi
        });
    }, [
        sidebarApi,
        toggleConversationAssistantUIMode
    ]); // Set up event listeners for spotlight communication
    (0, $cozmU.useEffect)(()=>{
        if (!(0, $aff3dfb467c885fa$export$4e09c449d6c407f7)() || !placementElementRef.current || !(0, $iDrrr.fg)('cc_ai_growth_welcome_from_rovo_gate')) return;
        const doc = (0, $1hQ0e.getDocument)();
        if (!doc) return;
         // Listen for spotlight rendered event
        const handleSpotlightRendered = (event)=>{
            const customEvent = event;
            if (customEvent.detail?.elementId === onboardingSpotlightElementId) setSpotlightRendered(true);
        }; // Listen for "Get Started" button click event
        const handleGetStartedEvent = (event)=>{
            const customEvent = event;
            if (customEvent.detail?.elementId === onboardingSpotlightElementId) handleGetStartedClick();
        };
        const unbind = (0, $cbY7C.bindAll)(doc, [
            {
                type: 'rovo-button-onboarding-spotlight-rendered',
                listener: handleSpotlightRendered
            },
            {
                type: 'rovo-button-onboarding-spotlight-get-started-click',
                listener: handleGetStartedEvent
            }
        ]);
        return ()=>{
            unbind();
        };
    }, [
        handleGetStartedClick,
        onboardingSpotlightElementId
    ]);
    (0, $cozmU.useEffect)(()=>{
        if (spotlightRendered) return;
        if (!(0, $iDrrr.fg)('cc_ai_growth_welcome_from_rovo_gate') && !canShowNudge) {
            setCanShowNudge(true);
            return;
        } // Give spotlight time to render (if it will) since it needs to run decisions logic
        const timeout = setTimeout(()=>{
            if (!spotlightRendered && !canShowNudge) setCanShowNudge(true);
        }, 1000);
        return ()=>clearTimeout(timeout);
    }, [
        spotlightRendered,
        canShowNudge
    ]); /* eslint-disable @atlaskit/platform/no-preconditioning -- intentional gate + experiment layering */ 
    const nudgeOrPlacement = (0, $cozmU.useMemo)(()=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, (0, $iDrrr.fg)('cc_ai_growth_welcome_from_rovo_gate') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            id: onboardingSpotlightElementId,
            ref: placementElementRef
        }), canShowNudge && (hasActiveNudge || !isExpanded) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $257691f193cbe091$export$50a342ac0fc7ff57), {
            onActiveNudgeChange: handleActiveNudgeChange
        }));
    }, [
        canShowNudge,
        handleActiveNudgeChange,
        onboardingSpotlightElementId,
        hasActiveNudge,
        isExpanded
    ]); /* eslint-enable @atlaskit/platform/no-preconditioning */ 
    const handleButtonMouseEnter = (0, $cozmU.useCallback)(()=>{
        clearTimeout(hoverTimeoutRef.current);
        hoverTimeoutRef.current = setTimeout(()=>{
            setIsHovering(true);
        }, 250);
        (parcelRequire("b5CWo")).then((m)=>m.preloadChatOnIntent()).catch(()=>{});
        onMouseEnter();
    }, [
        onMouseEnter
    ]);
    const handleButtonMouseLeave = (0, $cozmU.useCallback)(()=>{
        clearTimeout(hoverTimeoutRef.current);
        hoverTimeoutRef.current = setTimeout(()=>{
            setIsHovering(false);
            onMouseLeave();
        }, 1000);
    }, [
        onMouseLeave
    ]);
    const handleActionBoxMouseEnter = (0, $cozmU.useCallback)(()=>{
        clearTimeout(hoverTimeoutRef.current);
        setIsHovering(true);
    }, []);
    const handleActionBoxMouseLeave = (0, $cozmU.useCallback)(()=>{
        clearTimeout(hoverTimeoutRef.current);
        hoverTimeoutRef.current = setTimeout(()=>{
            setIsHovering(false);
        }, 1000);
    }, []);
    const canShowActionShortcuts = (0, $cozmU.useMemo)(()=>{
        const jiraWithShortcuts = slaOperationsEnabled && product === 'jira' && actionShortcuts.length > 0;
        return actionShortcuts.length > 0 && !hasActiveNudge && !spotlightRendered && jiraWithShortcuts;
    }, [
        actionShortcuts.length,
        hasActiveNudge,
        spotlightRendered,
        product,
        slaOperationsEnabled
    ]);
    const actionShortcutsRendering = (0, $cozmU.useMemo)(()=>{
        if (!isHovering || !canShowActionShortcuts) return null;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dcd69e36b7d8d2dc$export$fa41c7e6bc1d5bc2), {
            actionShortcuts: actionShortcuts,
            onMouseEnter: handleActionBoxMouseEnter,
            onMouseLeave: handleActionBoxMouseLeave
        });
    }, [
        isHovering,
        canShowActionShortcuts,
        actionShortcuts,
        handleActionBoxMouseEnter,
        handleActionBoxMouseLeave
    ]);
    const defaultLabel = formatMessage($c391f500d982e61a$var$i18n.tooltipLabel);
    const awaitingInputLabel = showAwaitingInput ? formatMessage($c391f500d982e61a$var$i18n.tooltipAwaitingInput, {
        count: displayAwaitingInputCount
    }) : null;
    const unreadLabel = showUnread ? formatMessage($c391f500d982e61a$var$i18n.tooltipUnreadSuffix, {
        count: displayUnreadCount
    }) : null;
    const inProgressLabel = displayInProgressCount > 0 ? formatMessage($c391f500d982e61a$var$i18n.tooltipInProgress, {
        count: displayInProgressCount
    }) : null;
    const labelLines = (()=>{
        if (awaitingInputLabel && unreadLabel) return [
            {
                key: 'awaiting-input',
                label: awaitingInputLabel
            },
            {
                key: 'unread',
                label: unreadLabel
            }
        ];
        if (awaitingInputLabel && inProgressLabel) return [
            {
                key: 'awaiting-input',
                label: awaitingInputLabel
            },
            {
                key: 'in-progress',
                label: inProgressLabel
            }
        ];
        if (awaitingInputLabel) return [
            {
                key: 'awaiting-input',
                label: awaitingInputLabel
            }
        ];
        if (unreadLabel && inProgressLabel) return [
            {
                key: 'unread',
                label: unreadLabel
            },
            {
                key: 'in-progress',
                label: inProgressLabel
            }
        ];
        if (unreadLabel) return [
            {
                key: 'unread',
                label: unreadLabel
            }
        ];
        if (inProgressLabel) return [
            {
                key: 'in-progress',
                label: inProgressLabel
            }
        ];
        return [
            {
                key: 'default',
                label: defaultLabel
            }
        ];
    })();
    const labelContent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $c391f500d982e61a$var$styles.tooltipContent
    }, labelLines.map((line)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            key: line.key
        }, line.label))); // The visible inline label is aria-hidden, so provide an SR-only text node
    // carrying the same awaiting/unread/in-progress information.
    const accessibleLabelText = labelLines.map((line)=>line.label).join('. ');
    const shouldUseExpander = isUnreadIndicatorEnabled || isQuickInputEnabled;
    const isExpansionSuppressed = hasActiveNudge || isConversationStatusPending && !hasVisibleConversationStatus; // Decide between deep-linking to a single chat vs opening chat history. We
    // deep-link only when the visible conversation-status counts add up to one.
    // Any total of two or more opens the history list instead. (TREX-1891 / TREX-1894)
    const handleConversationStatusClick = (0, $cozmU.useCallback)(()=>{
        const signals = [
            {
                count: displayAwaitingInputCount,
                conversationId: mostRecentAwaitingInput?.id
            },
            {
                count: displayUnreadCount,
                conversationId: mostRecentUnread?.id
            },
            {
                count: displayInProgressCount,
                conversationId: mostRecentInProgress?.id
            }
        ].filter((signal)=>signal.count > 0);
        const totalConversationCount = signals.reduce((total, signal)=>total + signal.count, 0);
        const singleConversationId = totalConversationCount === 1 ? signals[0]?.conversationId : undefined;
        fireConversationStatusUIEvent('clicked', singleConversationId ? 'conversation' : 'history');
        if (singleConversationId) {
            if (onUnreadConversationClick) {
                onUnreadConversationClick(singleConversationId);
                return;
            }
        }
        onChatHistoryClick?.();
    }, [
        displayAwaitingInputCount,
        mostRecentAwaitingInput,
        displayUnreadCount,
        mostRecentUnread,
        displayInProgressCount,
        mostRecentInProgress,
        fireConversationStatusUIEvent,
        onUnreadConversationClick,
        onChatHistoryClick
    ]);
    const conversationStatusContent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hBYtq.Pressable), {
        testId: "rovo-button-expanded-click",
        xcss: $c391f500d982e61a$var$styles.expandPillInteractive,
        "data-rovo-expand-pill": true,
        "aria-label": accessibleLabelText,
        onClick: handleConversationStatusClick
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $c391f500d982e61a$var$styles.expandedPillContent
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $c391f500d982e61a$var$styles.expandPillInner
    }, labelContent)));
    const idleExpandedContent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hBYtq.Pressable), {
        testId: "rovo-button-expanded-click",
        xcss: $c391f500d982e61a$var$styles.expandPillInteractive,
        "data-rovo-expand-pill": true,
        "aria-label": accessibleLabelText,
        onClick: onClick,
        isDisabled: isDisabled
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $c391f500d982e61a$var$styles.expandedPillContent
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $c391f500d982e61a$var$styles.expandPillInner
    }, labelContent)));
    const expandedContent = hasVisibleConversationStatus ? conversationStatusContent : canShowQuickInput ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $10f7ee76fcc6cf65$export$fec47ab16aaceba9), {
        onOverflowChange: setIsQuickInputOverflowing,
        onPromptChange: handleQuickInputPromptChange,
        onStart: handleQuickInputStarted,
        onSubmit: handleQuickInputSubmit
    }) : idleExpandedContent;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
        space: "space.100",
        alignBlock: "center",
        xcss: $c391f500d982e61a$var$styles.buttonWrapper
    }, nudgeOrPlacement, shouldUseExpander ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5376dc69e77beff0$export$74b768e0056334f4), {
        isExpansionSuppressed: isExpansionSuppressed,
        onExpandedChange: handleExpandedChange,
        overlayContent: canShowQuickInput && isQuickInputOverflowing ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $0a98db3c9d067baf$export$811443fa679fd0b7), {
            onClick: ()=>handleQuickInputContinueInChat(quickInputPromptRef.current.trim())
        }) : undefined,
        expandedContent: expandedContent
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ExetK.AIButton), {
        onClick: onClick,
        isDisabled: isDisabled,
        hasUnread: showUnread,
        isAwaitingInput: showAwaitingInput,
        onMouseEnter: handleButtonMouseEnter,
        onMouseLeave: handleButtonMouseLeave,
        ref: ref,
        proximityAnimationKey: proximityAnimationKey,
        isExpandable: shouldUseExpander
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lpNn5.default), {
        position: "left",
        content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $c391f500d982e61a$var$styles.tooltipContent
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), null, showUnread ? `${formatMessage($c391f500d982e61a$var$i18n.tooltipLabel)} \u{2022} ${formatMessage($c391f500d982e61a$var$i18n.tooltipUnreadSuffix, {
            count: displayUnreadCount
        })}` : formatMessage($c391f500d982e61a$var$i18n.tooltipLabel)), displayInProgressCount > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), null, formatMessage($c391f500d982e61a$var$i18n.tooltipInProgress, {
            count: displayInProgressCount
        }))),
        hideTooltipOnClick: true,
        ignoreTooltipPointerEvents: true,
        canAppear: ()=>{
            // If control or not on editor surface, always show tooltip when no active nudge
            // If treatment and on editor surface, show tooltip only when shortcuts cannot be shown
            return !hasActiveNudge && !canShowActionShortcuts;
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ExetK.AIButton), {
        onClick: onClick,
        isDisabled: isDisabled,
        hasUnread: showUnread,
        onMouseEnter: handleButtonMouseEnter,
        onMouseLeave: handleButtonMouseLeave,
        ref: ref,
        proximityAnimationKey: proximityAnimationKey
    })), hasActiveNudge && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $0fb69e02722ded52$export$c18249cbd1532738), {
        key: nudgeCounterRef.current
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iODl6.default), {
        appear: true
    }, actionShortcutsRendering));
});


function $866eb0b9d9cb8ffa$var$safeIsPointInRange(range, node, offset) {
    try {
        return range.isPointInRange(node, offset);
    } catch  {
        // some node types can throw, treat as "outside"
        return false;
    }
}
function $866eb0b9d9cb8ffa$var$fullyInside(r, container) {
    return $866eb0b9d9cb8ffa$var$safeIsPointInRange(container, r.startContainer, r.startOffset) && $866eb0b9d9cb8ffa$var$safeIsPointInRange(container, r.endContainer, r.endOffset);
}
/**
 * Find the "main" ProseMirror for a given sidebar container:
 * Walk up from the sidebar to the nearest .ak-editor-content-area. Return its direct
 * child .ProseMirror (even if other editors exist deeper in the subtree).
 */ function $866eb0b9d9cb8ffa$var$getMainProseMirrorForSidebar(sidebar) {
    const sidebarEl = typeof sidebar === 'string' && typeof document !== 'undefined' ? document.querySelector(sidebar) : sidebar;
    if (!sidebarEl) return null;
    const contentArea = sidebarEl.closest('.ak-editor-content-area');
    if (!contentArea) return null;
    for (const child of Array.from(contentArea.children)){
        if (child instanceof HTMLElement && child.classList.contains('ProseMirror')) return child;
    }
    return null;
}
function $866eb0b9d9cb8ffa$var$countWords(text) {
    const t = text.trim();
    if (!t) return 0;
    try {
        const Segmenter = Intl?.Segmenter;
        if (Segmenter) {
            const seg = new Segmenter(undefined, {
                granularity: 'word'
            });
            let c = 0;
            for (const { isWordLike: isWordLike } of seg.segment(t))if (isWordLike) c++;
            return c;
        }
    } catch  {}
    return t.split(/\s+/u).filter(Boolean).length;
}
function $866eb0b9d9cb8ffa$export$f18468c773f95821(sidebar) {
    try {
        const editor = $866eb0b9d9cb8ffa$var$getMainProseMirrorForSidebar(sidebar);
        if (!editor) return null;
        const doc = editor.ownerDocument ?? (typeof document !== 'undefined' ? document : null);
        if (!doc) return null;
        const sel = doc.getSelection?.();
        if (!sel || sel.rangeCount === 0 || sel.isCollapsed) return null;
        // range covering just the editor's contents to test containment
        const container = doc.createRange();
        container.selectNodeContents(editor);
        // snapshot rangeCount up-front to avoid races if selection changes
        const rangeCount = sel.rangeCount;
        // require every selection range to be fully inside
        let text = '';
        for(let i = 0; i < rangeCount; i++){
            const r = sel.getRangeAt(i);
            if (!$866eb0b9d9cb8ffa$var$fullyInside(r, container)) return null;
            const part = r.toString();
            text += text ? `\n${part}` : part;
        }
        return {
            text: text,
            words: $866eb0b9d9cb8ffa$var$countWords(text),
            chars: text.length
        };
    } catch (err) {
        return null;
    }
}


const $5760501401d54ef0$var$ANIMATION_DURATION = 150;
const $5760501401d54ef0$var$styles = {
    wrapper: "_1mT5xdRAKS",
    animatedMiniModalBefore: "_23rrnHJy76 _0yKXXaQoMs _0fKRyPnQyn _1YKVNsVx3j _1VJPcaBtpp _1llTr6Npdy _1sLQ8q17HO _1SdfoHIYTX",
    animatedMiniModalAfter: "_1YKVNs7dHp _1VJPcaHW0I _0fKRyPYvD1 _1llTr6scVB"
};
const $5760501401d54ef0$export$2b989c5e58d6ba9 = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ isDisabled: isDisabled = false, ...contextProps }, forwardedRef)=>{
    const { product: product, sidebarApi: sidebarApi, productPage: productPage, analyticsAttributes: analyticsAttributes, conversationAssistantConfig: conversationAssistantConfig } = contextProps;
    const hoverTimerRef = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useRef(null);
    const { fireRovoButtonUIEvent: fireRovoButtonUIEvent } = (0, $eM9tg.useRovoButtonEventsInstrumentation)();
    const publishRovo = (0, $hdBxM.usePublish)('ai-mate');
    const { setButtonClickedTimestamp: setButtonClickedTimestamp } = (0, $922055794f511dc6$export$cb9c0d3b5896f957)(); // The JSM contextual-prompt attributes shared by this button's hovered and
    // aiRovoSmartButton clicked events (set by the Jira Rovo config providers behind the grw-524
    // gate). Both interactions happen before Rovo opens, so they carry only the identity
    // attributes — the window and timing fields only apply once a Rovo window is open.
    const contextualPromptAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useMemo(()=>{
        const contextualPromptAnalyticsMetadata = conversationAssistantConfig?.contextualPromptAnalyticsMetadata;
        const firstPromptMetadata = contextualPromptAnalyticsMetadata?.promptMetadata?.[0];
        return contextualPromptAnalyticsMetadata ? {
            experimentKey: contextualPromptAnalyticsMetadata.experimentKey,
            experimentCohort: contextualPromptAnalyticsMetadata.experimentCohort ?? 'variation',
            routeName: contextualPromptAnalyticsMetadata.routeName,
            pageContext: contextualPromptAnalyticsMetadata.pageContext,
            promptId: firstPromptMetadata?.promptId,
            promptCategory: firstPromptMetadata?.promptCategory,
            promptSetId: contextualPromptAnalyticsMetadata.promptSetId
        } : {};
    }, [
        conversationAssistantConfig
    ]);
    const { mode: mode, toggleConversationAssistantUIMode: toggleConversationAssistantUIMode, openConversationAssistantUIMode: openConversationAssistantUIMode, setIsMiniModalAvailable: setIsMiniModalAvailable, setIsFullScreenModalAvailable: setIsFullScreenModalAvailable, setOpenWithChatHistory: setOpenWithChatHistory, setTargetConversationId: setTargetConversationId } = (0, $93Gae.useRovoExperienceAPIStore)();
    const prevModeRef = (0, $cozmU.useRef)(mode);
    const isFullScreenModalEnabled = product === 'jira' && (0, $iDrrr.fg)('asx_full_screen_modal_mode') && (0, $cXtTj.default).getExperimentValue('ai_agent_sessions_experience', 'isEnabled', false, {
        fireExperimentExposure: false
    });
    const isFullScreenModalExperience = mode === (0, $dPoYT.ConversationAssistantUIModes).FULL_SCREEN_MODAL && isFullScreenModalEnabled;
    const [rovoButtonCanRender, setRovoButtonCanRender] = (0, $cozmU.useState)(mode !== (0, $dPoYT.ConversationAssistantUIModes).MINI_MODAL && !isFullScreenModalExperience);
    const [hasStartedPreloading, setHasStartedPreloading] = (0, $cozmU.useState)(false); // Ref to the button wrapper. Used by the proximity handler below to
    // measure the button's screen-space center for distance calculations.
    const proximityWrapperRef = (0, $cozmU.useRef)(null); // Ref mirror of `rovoButtonCanRender` so the proximity handler — which
    // runs from inside a useEffect that doesn't re-subscribe on render —
    // can see the current visibility state without consuming the animation
    // budget while the button is hidden (mini-modal mode). Updated by a
    // tiny sync-effect below.
    const canRenderRef = (0, $cozmU.useRef)(rovoButtonCanRender); // Mouse-proximity animation enablement (TREX-1527). Read from the
    // `rovo_button_mouse_tracking_animation` Statsig experiment on every
    // render — FeatureGates dedupes exposure logging per session, so this
    // is safe and naturally handles the case where the SDK hadn't fully
    // initialised when AISmartButton first rendered (the next render
    // picks up the live value). Matches the pattern used by
    // `isUnreadIndicatorEnabled` in AISmartButtonUI.
    //
    // When false (control / not bucketed / Statsig unreachable), the
    // animated logo is never rendered — AIButton falls back to the
    // existing static RovoColorLogo. This gates the *visual*; the trigger
    // logic is gated separately inside the effect below.
    const proximityAnimationEnabled = (0, $cXtTj.default).getExperimentValue('rovo_button_mouse_tracking_animation', 'isEnabled', false); // Mouse-proximity animation key (TREX-1527). Bumped each time the
    // cursor crosses INTO the proximity radius, which remounts the
    // animated Rovo SVG and restarts its 2.5s SMIL color-cycle.
    // Starts at `undefined` so that on first mount AIButton renders the
    // static fallback. The proximity handler sets it to 0 on the FIRST
    // in-radius cross, which triggers the animated logo's first SMIL run,
    // and bumps it on every subsequent entry while `repeatable = true`.
    const [proximityAnimationKey, setProximityAnimationKey] = (0, $cozmU.useState)(undefined); // Refs that survive proximity-effect re-runs (TREX-1606).
    //
    // Previously these were closure-scoped `let` variables INSIDE the
    // proximity effect. Any time the effect tore down and re-ran they
    // silently reset to `false`, which produced two visible bugs:
    //
    //   1. `wasInRadius` losing its `true` state caused the edge-detector
    //      (`isInRadius && !wasInRadius`) to miss the next entry into the
    //      radius — the user had to physically move OUT and back IN
    //      before the animation would fire again.
    //   2. `proximityHasFired` losing its `true` state caused the
    //      `repeatable=false` mode to fire more than once per page, and
    //      could also cause "first-fire per session" tracking to lie.
    //
    // Promoting to refs means the values persist for the lifetime of the
    // component instance, independent of how many times the effect
    // re-binds its listener. The route-change reset effect below
    // explicitly clears them when the user navigates.
    const proximityHasFiredRef = (0, $cozmU.useRef)(false);
    const wasInRadiusRef = (0, $cozmU.useRef)(false); // Ref mirror of `proximityAnimationEnabled` (TREX-1606).
    //
    // The proximity effect previously had `proximityAnimationEnabled` in
    // its dep array. Because the gate value is read fresh on every render
    // via `FeatureGates.getExperimentValue`, the value can flip
    // `false → true` shortly after mount (when the Statsig SDK finishes
    // initialising and returns the bucketed value instead of the default
    // `false` fallback). That dep-array flip caused the effect to tear
    // down and re-run, blowing away the per-session proximity state.
    //
    // We now mirror the value into a ref and read it inside the effect.
    // The effect itself runs exactly once per mount with an empty dep
    // array, which is the behaviour the original comment claimed but the
    // original dep array did not deliver.
    const proximityAnimationEnabledRef = (0, $cozmU.useRef)(proximityAnimationEnabled); // Keep `canRenderRef` in sync with `rovoButtonCanRender` so the
    // long-lived proximity effect (which only subscribes once on mount)
    // can read the current value without re-running.
    (0, $cozmU.useEffect)(()=>{
        canRenderRef.current = rovoButtonCanRender;
    }, [
        rovoButtonCanRender
    ]); // Keep `proximityAnimationEnabledRef` in sync with the latest gate
    // value. Lets the proximity effect early-bail without re-running when
    // the gate is off.
    (0, $cozmU.useEffect)(()=>{
        proximityAnimationEnabledRef.current = proximityAnimationEnabled;
    }, [
        proximityAnimationEnabled
    ]); // Reset per-page proximity state when the user navigates between
    // pages (TREX-1606). `productPage` is a stable identifier for the
    // current page surface — when it changes, the user has moved to a
    // new page, so:
    //   - `proximityHasFiredRef` is reset so `repeatable=false` users
    //     can see the animation again on the new page (matches the
    //     "once per page" intent in the effect comment).
    //   - `wasInRadiusRef` is reset so the next mousemove correctly
    //     re-evaluates whether the cursor is in the radius for the
    //     newly-positioned button.
    //   - `proximityAnimationKey` is reset so the AISmartButtonUI
    //     re-renders with the static fallback at first, then transitions
    //     to the animated logo on the next radius entry — preserving the
    //     "static at rest" UX on every fresh page.
    (0, $cozmU.useEffect)(()=>{
        proximityHasFiredRef.current = false;
        wasInRadiusRef.current = false;
        setProximityAnimationKey(undefined);
    }, [
        productPage
    ]); // Proximity animation suppression while a nudge is visible (TREX-1601).
    //
    // `AIProactiveNudge` publishes its visibility into the shared
    // `AISmartButtonStore`; we subscribe via `useIsNudgeVisible` and
    // mirror it into a ref so the mount-once proximity effect can read
    // the current value on every mousemove without re-binding its
    // listener. Mirrors the `canRenderRef` pattern just above.
    //
    // Suppressing the animation while a nudge is on screen avoids two
    // visual effects (the nudge bubble and the color-cycle on the
    // button itself) competing for the same surface, which is jarring
    // and dilutes the impact of both.
    const isNudgeVisible = (0, $k9SyR.useIsNudgeVisible)();
    const isNudgeVisibleRef = (0, $cozmU.useRef)(isNudgeVisible);
    (0, $cozmU.useEffect)(()=>{
        isNudgeVisibleRef.current = isNudgeVisible;
    }, [
        isNudgeVisible
    ]);
    (0, $8f0437d4d92bed1c$export$a8ab20a5170c41b3)();
    (0, $cozmU.useEffect)(()=>{
        setIsMiniModalAvailable(true);
        if (isFullScreenModalEnabled) setIsFullScreenModalAvailable?.(true);
        if (!(0, $aff3dfb467c885fa$export$4e09c449d6c407f7)()) return;
         // Start preloading when mouse is within the bottom-right box (300px from bottom, 300px from right)
        const handleMouseMove = (event)=>{
            if ((0, $aff3dfb467c885fa$export$4e09c449d6c407f7)() && !hasStartedPreloading) {
                const viewportHeight = window.innerHeight;
                const viewportWidth = window.innerWidth;
                const mouseX = event.clientX;
                const mouseY = event.clientY;
                const distanceFromBottom = viewportHeight - mouseY;
                const distanceFromRight = viewportWidth - mouseX;
                if (distanceFromBottom <= 300 && distanceFromRight <= 300) {
                    (0, $3bba9b7c8f6d5693$export$1f1f17d801cbb952)();
                    setHasStartedPreloading(true);
                }
            }
        };
        const unbind = (0, $cbY7C.bindAll)(window, [
            {
                type: 'mousemove',
                listener: handleMouseMove
            }
        ]);
        return ()=>{
            setIsMiniModalAvailable(false);
            if (isFullScreenModalEnabled) setIsFullScreenModalAvailable?.(false);
            (0, $aff3dfb467c885fa$export$4e09c449d6c407f7)() && unbind();
        };
    }, [
        setIsMiniModalAvailable,
        setIsFullScreenModalAvailable,
        hasStartedPreloading,
        isFullScreenModalEnabled
    ]); // --- Mouse-proximity animation (TREX-1527, hardened in TREX-1606) ---
    // This effect is intentionally mount-once / unmount-once: the dep
    // array is empty. All values that can change between renders
    // (the enabled gate, the render-eligibility flag, the per-trigger
    // state) are read through refs that are kept in sync above so the
    // effect never has to tear down and re-run. Previously this effect
    // depended on `proximityAnimationEnabled`, which flipped from `false`
    // (Statsig SDK not yet initialised) to `true` (bucketed value
    // resolved) shortly after mount and silently reset the per-page
    // proximity state — see TREX-1606 for the full investigation.
    //
    // IMPORTANT: the listener is registered unconditionally. The
    // "is the experiment enabled?" check is deliberately inside
    // `updateProximity` rather than at the top of the effect. Gating
    // the registration here would mean a user whose Statsig SDK
    // resolves AFTER mount (i.e. `proximityAnimationEnabled` was
    // `false` at the moment the effect ran but became `true` shortly
    // after) never gets a listener at all — because the mount-once
    // effect doesn't re-run. Bailing inside the handler is virtually
    // free (a ref read + early return on each mousemove for
    // non-bucketed users) and is consistent with how `canRenderRef` is
    // already handled.
    //
    // The Statsig param reads (`PROXIMITY_RADIUS_PX`, `PROXIMITY_REPEAT`)
    // remain inside the effect closure so they capture the value at
    // mount time. This is intentional: mid-session experiment-param
    // changes should NOT silently change the radius or repeat behaviour
    // for a user already on a page — they take effect on the next mount.
    (0, $cozmU.useEffect)(()=>{
        if (!(0, $aff3dfb467c885fa$export$4e09c449d6c407f7)()) return;
         // Tunable from Switcheroo without redeploying:
        //   proximityRadiusPx (number)  — radius around the button in pixels.
        //   repeatable        (boolean) — true: replay on every entry into radius.
        //                                  false: play once per page mount.
        const PROXIMITY_RADIUS_PX = (0, $cXtTj.default).getExperimentValue('rovo_button_mouse_tracking_animation', 'proximityRadiusPx', 150);
        const PROXIMITY_REPEAT = (0, $cXtTj.default).getExperimentValue('rovo_button_mouse_tracking_animation', 'repeatable', false);
        let lastMouseX = -1;
        let lastMouseY = -1;
        let rafId;
        const updateProximity = ()=>{
            rafId = undefined; // Bail if the experiment isn't enabled for this user. Read
            // fresh each frame via the ref so users whose Statsig SDK
            // resolves after mount still get the animation once the
            // flag flips `true`. See effect header for the full
            // rationale.
            if (!proximityAnimationEnabledRef.current) return;
             // Don't measure or fire while the button is not actually
            // being rendered (e.g. mini-modal mode). Prevents the
            // once-per-page animation budget from being consumed
            // invisibly.
            if (!canRenderRef.current) return;
             // Suppress the animation while a nudge bubble is on screen
            // (TREX-1601). Skipping the entry — rather than queuing it
            // to fire after the nudge dismisses — is deliberate: the
            // animation is meant to react to live cursor approach, not
            // to replay a stale gesture once the screen is clear. The
            // suppression behaviour ships as part of the same
            // experiment as the proximity animation itself.
            //
            // We reach this line only when `proximityAnimationEnabledRef`
            // (read via `getExperimentValue`) is true, so the user is
            // already bucketed into the experiment — no separate gate
            // check is needed for the decision. We still call `fg(...)`
            // for its exposure-tracking side effect to satisfy the
            // `@atlaskit/platform/no-preconditioning` ESLint rule and
            // keep Statsig's exposure metric attributable to the
            // suppression code path. Calling `fg(...)` for side effect
            // (rather than using its return value as the gate) avoids
            // the publisher/consumer SDK mismatch we hit in TREX-1601
            // local testing — see ai-proactive-nudge/main.tsx for the
            // matching publisher fix.
            if (isNudgeVisibleRef.current) {
                (0, $iDrrr.fg)('rovo_button_mouse_tracking_animation');
                return;
            }
            const el = proximityWrapperRef.current;
            if (!el) return;
            const rect = el.getBoundingClientRect();
            const centerX = rect.left + rect.width / 2;
            const centerY = rect.top + rect.height / 2;
            const dx = lastMouseX - centerX;
            const dy = lastMouseY - centerY;
            const distance = Math.hypot(dx, dy);
            const isInRadius = distance <= PROXIMITY_RADIUS_PX; // Detect "entered the radius" → mount (first entry) or remount
            // (subsequent entries when repeatable=true) the animated Rovo
            // SVG by setting/bumping the React key. This is the only place
            // we touch React state from the mousemove handler.
            //
            // Respect `prefers-reduced-motion: reduce` (WCAG 2.3.3): users
            // who have requested reduced motion should not see the
            // color-cycle animation even when bucketed into the test
            // cohort. We bail BEFORE mutating React state so the static
            // RovoColorLogo fallback continues to render. Re-evaluated
            // per-trigger (cheap) so that if the user changes their OS
            // setting mid-session it takes effect on the next entry.
            if (isInRadius && !wasInRadiusRef.current) {
                const prefersReducedMotion = typeof window !== 'undefined' && typeof window.matchMedia === 'function' && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
                if (!prefersReducedMotion && (PROXIMITY_REPEAT || !proximityHasFiredRef.current)) {
                    setProximityAnimationKey((k)=>k === undefined ? 0 : k + 1);
                    proximityHasFiredRef.current = true;
                }
            }
            wasInRadiusRef.current = isInRadius;
        };
        const handleProximityMouseMove = (event)=>{
            lastMouseX = event.clientX;
            lastMouseY = event.clientY; // Only schedule a new rAF if one isn't already pending. Track the
            // rAF ID so we can cancel it in the cleanup — without this, a
            // pending rAF would still fire after unmount and call
            // setProximityAnimationKey on an unmounted component (a React
            // warning in dev, a potential no-op state update in prod that
            // breaks React StrictMode double-invocation invariants).
            if (rafId === undefined) rafId = requestAnimationFrame(updateProximity);
        };
        const unbind = (0, $cbY7C.bindAll)(window, [
            {
                type: 'mousemove',
                listener: handleProximityMouseMove
            }
        ]);
        return ()=>{
            if (rafId !== undefined) cancelAnimationFrame(rafId);
            unbind();
        }; // eslint-disable-next-line react-hooks/exhaustive-deps -- See header comment: effect deliberately runs once per mount and reads
    // proximityAnimationEnabledRef / canRenderRef / wasInRadiusRef /
    // proximityHasFiredRef / proximityWrapperRef through refs that
    // are kept in sync above (or, in the case of proximityWrapperRef,
    // attached to the rendered wrapper element via ref={...}).
    }, []);
    (0, $cozmU.useEffect)(()=>{
        fireRovoButtonUIEvent({
            source: productPage,
            action: 'rendered',
            actionSubject: 'rovoButton',
            actionSubjectId: 'aiSmartButton',
            attributes: {
                product: product,
                productPage: productPage,
                ...analyticsAttributes,
                version: 'refresh',
                legacy: false
            },
            product: product
        });
    }, [
        fireRovoButtonUIEvent,
        product,
        productPage,
        analyticsAttributes
    ]);
    (0, $cozmU.useEffect)(()=>{
        // Wait for the closing animation of modal to complete before showing the rovo button.
        // The timer must be cleared on cleanup; otherwise rapid mode transitions
        // (e.g. undefined → sidebar → mini-modal) leave stale timers that fire after
        // ANIMATION_DURATION and incorrectly set rovoButtonCanRender to true,
        // unmounting the AIMiniModal even though mode is still 'mini-modal'.
        if (mode !== (0, $dPoYT.ConversationAssistantUIModes).MINI_MODAL && !isFullScreenModalExperience) {
            const timerId = setTimeout(()=>{
                setRovoButtonCanRender(true);
            }, $5760501401d54ef0$var$ANIMATION_DURATION);
            return ()=>{
                clearTimeout(timerId);
            };
        }
        setRovoButtonCanRender(false);
    }, [
        mode,
        setRovoButtonCanRender,
        isFullScreenModalExperience
    ]);
    (0, $cozmU.useEffect)(()=>{
        if (mode === undefined && (prevModeRef.current === (0, $dPoYT.ConversationAssistantUIModes).MINI_MODAL || prevModeRef.current === (0, $dPoYT.ConversationAssistantUIModes).SIDEBAR || prevModeRef.current === (0, $dPoYT.ConversationAssistantUIModes).FULL_SCREEN_MODAL && (0, $iDrrr.fg)('agent_session_experience_fg'))) // AISmartButtonUI is unmounted while mini-modal, sidebar, or full-screen-modal is open, so the hook
        // cannot watch mode internally. Mark cache stale here so the button remounts with
        // stale data visible while the background re-fetch completes.
        (0, $957d07ec48bc7f6c$export$5ea316be7514c402)();
        prevModeRef.current = mode;
    }, [
        mode
    ]);
    const onAISmartButtonClick = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useCallback((e)=>{
        // Set timestamp immediately on click
        setButtonClickedTimestamp(Date.now()); // Plain button opens the default (suggestions) view — ensure a prior pill
        // click can never leak its open-with-chat-history intent into this open.
        setOpenWithChatHistory?.(false);
        setTargetConversationId?.(null);
        toggleConversationAssistantUIMode({
            targetMode: (0, $dPoYT.ConversationAssistantUIModes).MINI_MODAL,
            sidebarApi: sidebarApi
        });
        const selectionAttributes = {};
        if ((0, $iDrrr.fg)('platform_editor_ai_aifc_streaming')) {
            const counts = (0, $866eb0b9d9cb8ffa$export$f18468c773f95821)(e.currentTarget);
            if (counts != null) {
                selectionAttributes.totalSelectedWords = counts.words;
                selectionAttributes.totalSelectedChars = counts.chars;
            }
        }
        fireRovoButtonUIEvent({
            source: productPage,
            action: 'clicked',
            actionSubject: 'rovoButton',
            actionSubjectId: 'aiRovoSmartButton',
            attributes: {
                product: product,
                productPage: productPage,
                ...analyticsAttributes,
                ...contextualPromptAttributes,
                ...selectionAttributes,
                version: 'refresh'
            },
            product: product
        });
    }, [
        product,
        productPage,
        analyticsAttributes,
        contextualPromptAttributes,
        fireRovoButtonUIEvent,
        toggleConversationAssistantUIMode,
        sidebarApi,
        setButtonClickedTimestamp,
        setOpenWithChatHistory,
        setTargetConversationId
    ]);
    const onQuickInputSubmit = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useCallback((prompt)=>{
        // A quick-input submission always starts a new conversation. Clear any navigation
        // intent retained from an earlier history or unread-conversation interaction first.
        // The payload also resets the persistent menu and selects an optimistic empty
        // conversation before sending, so the opening panel does not show stale content
        // while it waits for the backend conversation.
        setOpenWithChatHistory?.(false);
        setTargetConversationId?.(null);
        publishRovo({
            type: 'chat-new',
            source: 'rovo-button-quick-input',
            openChat: true,
            openChatMode: (0, $dPoYT.ConversationAssistantUIModes).MINI_MODAL,
            data: {
                dialogues: [],
                mode: {
                    useCurrentPageContext: true
                },
                prompt: prompt,
                resetActiveMenu: true,
                skipCreatingSeededConversation: true
            }
        });
    }, [
        publishRovo,
        setOpenWithChatHistory,
        setTargetConversationId
    ]);
    const onQuickInputContinueInChat = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useCallback((prompt)=>{
        if (!prompt) return;
        setOpenWithChatHistory?.(false);
        setTargetConversationId?.(null);
        publishRovo({
            type: 'chat-new',
            source: 'rovo-button-quick-input',
            openChat: true,
            openChatMode: (0, $dPoYT.ConversationAssistantUIModes).MINI_MODAL,
            data: {
                dialogues: [],
                prompt: prompt,
                overrideAutoSend: true,
                resetActiveMenu: true,
                skipCreatingSeededConversation: true
            }
        });
    }, [
        publishRovo,
        setOpenWithChatHistory,
        setTargetConversationId
    ]);
    const onChatHistoryClick = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useCallback(()=>{
        setOpenWithChatHistory?.(true);
        openConversationAssistantUIMode({
            targetMode: (0, $dPoYT.ConversationAssistantUIModes).MINI_MODAL,
            sidebarApi: sidebarApi
        });
        fireRovoButtonUIEvent({
            source: productPage,
            action: 'clicked',
            actionSubject: 'rovoButton',
            actionSubjectId: 'aiRovoSmartButton',
            attributes: {
                product: product,
                productPage: productPage,
                ...analyticsAttributes,
                ...contextualPromptAttributes,
                version: 'refresh',
                openedWithChatHistory: true
            },
            product: product
        });
    }, [
        product,
        productPage,
        analyticsAttributes,
        fireRovoButtonUIEvent,
        openConversationAssistantUIMode,
        sidebarApi,
        setOpenWithChatHistory,
        contextualPromptAttributes
    ]);
    const onUnreadConversationClick = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useCallback((conversationId)=>{
        // A deep-link must not inherit a sticky chat-history intent from a prior
        // open, otherwise the modal shows the conversation list instead of the
        // target chat. (mirror of onAISmartButtonClick's reset)
        setOpenWithChatHistory?.(false);
        setTargetConversationId?.(conversationId);
        openConversationAssistantUIMode({
            targetMode: (0, $dPoYT.ConversationAssistantUIModes).MINI_MODAL,
            sidebarApi: sidebarApi
        });
        fireRovoButtonUIEvent({
            source: productPage,
            action: 'clicked',
            actionSubject: 'rovoButton',
            actionSubjectId: 'aiRovoSmartButton',
            attributes: {
                product: product,
                productPage: productPage,
                ...analyticsAttributes,
                ...contextualPromptAttributes,
                version: 'refresh',
                openedToConversation: true
            },
            product: product
        });
    }, [
        product,
        productPage,
        analyticsAttributes,
        fireRovoButtonUIEvent,
        openConversationAssistantUIMode,
        sidebarApi,
        setTargetConversationId,
        setOpenWithChatHistory,
        contextualPromptAttributes
    ]);
    const onAISmartButtonEnter = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useCallback(()=>{
        hoverTimerRef.current = setTimeout(()=>{
            fireRovoButtonUIEvent({
                source: productPage,
                action: 'hovered',
                actionSubject: 'rovoButton',
                actionSubjectId: 'aiSmartButton',
                attributes: {
                    product: product,
                    productPage: productPage,
                    ...analyticsAttributes,
                    ...contextualPromptAttributes,
                    version: 'refresh'
                },
                product: product
            });
        }, 1000);
    }, [
        fireRovoButtonUIEvent,
        product,
        productPage,
        analyticsAttributes,
        contextualPromptAttributes
    ]);
    const onAISmartButtonLeave = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useCallback(()=>{
        if (hoverTimerRef.current) {
            clearTimeout(hoverTimerRef.current);
            hoverTimerRef.current = null;
        }
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $61R7O.AISmartButtonProvider), contextProps, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $5760501401d54ef0$var$styles.wrapper,
        ref: proximityWrapperRef
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: (0, $w6R6I.cx)($5760501401d54ef0$var$styles.animatedMiniModalBefore, mode === (0, $dPoYT.ConversationAssistantUIModes).MINI_MODAL && $5760501401d54ef0$var$styles.animatedMiniModalAfter)
    }, !sidebarApi.isSidebarOpen() && !rovoButtonCanRender && !isFullScreenModalExperience && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3bba9b7c8f6d5693$export$f36d8da28b18d2c1), null)), !sidebarApi.isSidebarOpen() && rovoButtonCanRender && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $c391f500d982e61a$export$21695acdb18697b9), {
        ref: forwardedRef,
        onClick: onAISmartButtonClick,
        onChatHistoryClick: onChatHistoryClick,
        onQuickInputContinueInChat: onQuickInputContinueInChat,
        onQuickInputSubmit: onQuickInputSubmit,
        onUnreadConversationClick: onUnreadConversationClick,
        isDisabled: isDisabled,
        onMouseEnter: onAISmartButtonEnter,
        onMouseLeave: onAISmartButtonLeave,
        proximityAnimationKey: proximityAnimationKey
    })), !sidebarApi.isSidebarOpen() && isFullScreenModalExperience && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $16eeddbb409c6f7d$export$6b0f0aea468bfe6e), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6f3dd9bd3fd569ef$export$20c376cddbc7272c), {
        product: product
    }));
});






var $6m3nS = parcelRequire("6m3nS");


var $6mKj3 = parcelRequire("6mKj3");


var $9wGTI = parcelRequire("9wGTI");


var $jMyy4 = parcelRequire("jMyy4");


var $7mpOv = parcelRequire("7mpOv");


var $efvKr = parcelRequire("efvKr");


var $bQm3c = parcelRequire("bQm3c");


var $3IBnw = parcelRequire("3IBnw");


var $4PPzL = parcelRequire("4PPzL");


var $7Sm4c = parcelRequire("7Sm4c");


var $zCcSI = parcelRequire("zCcSI");


var $1I9Gw = parcelRequire("1I9Gw");


var $8nle6 = parcelRequire("8nle6");


var $JCGnt = parcelRequire("JCGnt");

const $b95365b81ba40784$export$7c843038c233ff0d = 14;
const $b95365b81ba40784$export$d8f631fafd9710f1 = ({ currentUserPersonalSpaceKey: currentUserPersonalSpaceKey, isFoundingAdmin: isFoundingAdmin, isFoundingAdminLoading: isFoundingAdminLoading, isCurrentSpacePersonal: isCurrentSpacePersonal, isNewUser: isNewUser, isNewUserLoading: isNewUserLoading, spaceKey: spaceKey, shouldSkipEligibilityCheck: shouldSkipEligibilityCheck })=>{
    if (shouldSkipEligibilityCheck || isFoundingAdmin === true) return {
        isEligible: false,
        loading: false
    };
    if (isFoundingAdminLoading) return {
        isEligible: false,
        loading: true
    };
    if (isCurrentSpacePersonal) {
        if (currentUserPersonalSpaceKey === undefined) return {
            isEligible: false,
            loading: true
        };
        if (currentUserPersonalSpaceKey === null || !spaceKey || spaceKey === currentUserPersonalSpaceKey) return {
            isEligible: false,
            loading: false
        };
    }
    // Treat undefined loading as unresolved until useIsNewUser returns a definitive state.
    if (isNewUserLoading !== false) return isNewUser === false ? {
        isEligible: false,
        loading: false
    } : {
        isEligible: false,
        loading: true
    };
    if (isNewUser !== true) return {
        isEligible: false,
        loading: false
    };
    return {
        isEligible: true,
        loading: false
    };
};








var $f92eb96399d796dc$exports = {};
$f92eb96399d796dc$exports = new URL("rovo-greeting-icon.515b1e1f.svg", import.meta.url).toString();


const $31a693770d204997$var$i18n = (0, $kSwu1.defineMessages)({
    rovoLogoAltText: {
        id: "experiment-welcome-from-rovo.greeting.logo.alt-text",
        defaultMessage: "Rovo logo"
    },
    greetingTitle: {
        id: "experiment-welcome-from-rovo.greeting.title",
        defaultMessage: "Hi, I\u2019m Rovo"
    },
    greetingDescription: {
        id: "experiment-welcome-from-rovo.greeting.description",
        defaultMessage: "I can help you find answers and act on your team\u2019s knowledge. Try the prompt below to see how I work!"
    },
    promptPrefill: {
        id: "experiment-welcome-from-rovo.prompt.prefill",
        defaultMessage: "Summarize what this space is about"
    }
});
const $31a693770d204997$export$9e96f92df036fbcc = ()=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    return (0, $cozmU.useMemo)(()=>({
            customGreeting: {
                iconSrc: (0, (/*@__PURE__*/$parcel$interopDefault($f92eb96399d796dc$exports))),
                title: formatMessage($31a693770d204997$var$i18n.greetingTitle),
                subtitle: formatMessage($31a693770d204997$var$i18n.greetingDescription),
                titleSize: 'large',
                testId: 'welcome-from-rovo',
                imageHeight: 48
            },
            initialPromptText: formatMessage($31a693770d204997$var$i18n.promptPrefill),
            shouldSeedInitialPromptText: true
        }), [
        formatMessage
    ]);
};



var $dBcar = parcelRequire("dBcar");


var $8Z78B = parcelRequire("8Z78B");


var $ivb8S = parcelRequire("ivb8S");


var $5ruin = parcelRequire("5ruin");


var $2bR8c = parcelRequire("2bR8c");


var $jz8lo = parcelRequire("jz8lo");

const $293253fb36609c97$var$styles = {
    smartButtonWrapperStyles: "_1mT5xdWVPG _42Yu6BFIQA _4ApkO2dnbC _0Bm75GdnbC"
}; // Keep in sync with the Rovo Chat memory settings Post Office message template.
const $293253fb36609c97$var$MEMORY_SETTINGS_SPOTLIGHT_SUPPRESSION_TRIGGER_ID = 'welcome-from-rovo-memory-settings-spotlight-suppression';
function $293253fb36609c97$export$f7d346730580e70({ contentId: contentId, contentType: contentType, pageMode: pageMode, isDisabled: isDisabled = false, spaceKey: spaceKey, isSidebarAvailable: isSidebarAvailable }) {
    const isLiveDoc = pageMode === 'live';
    const [{ isViewMode: isLiveViewMode }] = (0, $efvKr.useLivePageMode)(); // Only pass isLiveViewMode when on a live doc — avoids threading irrelevant state to downstream components
    const liveViewMode = isLiveDoc ? isLiveViewMode : undefined;
    const { cloudId: cloudId, orgId: orgId } = (0, $bQm3c.useSessionData)();
    const { isAIEnabledForContent: isAIEnabledForContent, isRovoEnabledForContent: isRovoEnabledForContent } = (0, $7mpOv.useIsAIEnabledForContent)({
        contentId: contentId
    });
    const sidebarApi = (0, $2bR8c.useCreateRovoExperienceSidebarController)();
    const getActions = (0, $5ruin.useRovoConfigGetActions)();
    const tags = (0, $5ruin.useRovoConfigTags)();
    const customGreeting = (0, $5ruin.useRovoConfigCustomGreeting)();
    const shouldShowGreeting = (0, $5ruin.useRovoConfigShouldShowGreeting)();
    const prioritizeCustomActionResults = (0, $5ruin.useRovoConfigPrioritizeCustomActionResults)();
    const numStartersToShow = (0, $5ruin.useRovoConfigNumStartersToShow)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const { mode: mode, isMiniModalAvailable: isMiniModalAvailable } = (0, $93Gae.useRovoExperienceAPIStore)();
    const publishRovo = (0, $hdBxM.usePublish)('ai-mate');
    const hasAutoOpenedWelcomeFromRovoChatRef = (0, $cozmU.useRef)(false);
    const hasShownWelcomeFromRovoChatUiRef = (0, $cozmU.useRef)(false);
    const [{ isWaitingForWelcomeFromRovoSpotlightAnchor: isWaitingForWelcomeFromRovoSpotlightAnchor, shouldUseWelcomeFromRovoChatUi: shouldUseWelcomeFromRovoChatUi }, setWelcomeFromRovoChatUiState] = (0, $cozmU.useState)({
        isWaitingForWelcomeFromRovoSpotlightAnchor: false,
        shouldUseWelcomeFromRovoChatUi: false
    });
    const welcomeFromRovoChatUiConfig = (0, $31a693770d204997$export$9e96f92df036fbcc)();
    const { fireTrigger: fireWelcomeFromRovoSpotlightTrigger } = (0, $6m3nS.useFirePostOfficeTrigger)({
        triggerId: 'welcome-from-rovo-spotlight-trigger'
    });
    const { fireTrigger: fireMemorySettingsSpotlightSuppressionTrigger } = (0, $6m3nS.useFirePostOfficeTrigger)({
        triggerId: $293253fb36609c97$var$MEMORY_SETTINGS_SPOTLIGHT_SUPPRESSION_TRIGGER_ID
    }); // environment-aware enablement via feature encoding
    const isAIEnvEnabled = (0, $3ricL.isFeatureEnabled)('confluence', 'confluence-ai');
    const isEnabled = isAIEnvEnabled && isAIEnabledForContent && isRovoEnabledForContent;
    const isCurrentSpacePersonal = Boolean(spaceKey) && (0, $1I9Gw.isPersonalSpace)(spaceKey);
    const shouldSkipPersonalSpaceDetailsQuery = !isEnabled || !isCurrentSpacePersonal || !(0, $6mKj3.expVal)('cc_ai_growth_welcome_from_rovo_eligibility', 'isEnabled', false);
    const { data: personalSpaceDetailsData, loading: personalSpaceDetailsLoading, error: personalSpaceDetailsError } = (0, $jMyy4.useQueryInterop)((0, $8nle6.preloadPersonalSpaceDetailsQuery), {
        skip: shouldSkipPersonalSpaceDetailsQuery,
        __callerPackage__: "ai-rovo-button"
    });
    const currentUserPersonalSpaceKey = personalSpaceDetailsLoading ? undefined : personalSpaceDetailsData?.user?.confluence?.space?.key ?? null;
    const shouldSkipWelcomeFromRovoChatEligibilityCheck = !isEnabled || !spaceKey || !(0, $6mKj3.expVal)('cc_ai_growth_welcome_from_rovo_eligibility', 'isEnabled', false);
    const { isNewUser: isNewUser, loading: isNewUserLoading } = (0, $JCGnt.useIsNewUser)({
        activeDaysThreshold: (0, $b95365b81ba40784$export$7c843038c233ff0d)
    }, shouldSkipWelcomeFromRovoChatEligibilityCheck);
    const shouldSkipWelcomeFromRovoChatOnboardingStateQuery = shouldSkipWelcomeFromRovoChatEligibilityCheck || !isNewUser;
    const { data: onboardingStateData, loading: onboardingStateLoading, error: onboardingStateError } = (0, $jMyy4.useQueryInterop)((0, $8Z78B.default), {
        variables: {
            key: [
                (0, $dBcar.WELCOME_FROM_ROVO_CHAT).CHAT_AUTO_OPENED,
                (0, $dBcar.ONBOARDING_EXPERIENCES).IS_FOUNDING_ADMIN
            ]
        },
        skip: shouldSkipWelcomeFromRovoChatOnboardingStateQuery,
        __callerPackage__: "ai-rovo-button"
    });
    const { isFoundingAdmin: isFoundingAdmin, chatAutoOpened: hasPreviouslyAutoOpenedWelcomeFromRovoChat } = (0, $ivb8S.deserializeState)(onboardingStateData);
    const isWelcomeFromRovoChatEligibilityLoading = isNewUserLoading || isCurrentSpacePersonal && personalSpaceDetailsLoading;
    const hasPersonalSpaceDetailsError = isCurrentSpacePersonal && Boolean(personalSpaceDetailsError);
    (0, $cozmU.useEffect)(()=>{
        if (hasPersonalSpaceDetailsError) (0, $7Sm4c.markErrorAsHandled)(personalSpaceDetailsError);
    }, [
        hasPersonalSpaceDetailsError,
        personalSpaceDetailsError
    ]);
    const welcomeFromRovoChatEligibility = (0, $b95365b81ba40784$export$d8f631fafd9710f1)({
        currentUserPersonalSpaceKey: currentUserPersonalSpaceKey,
        isFoundingAdmin: isFoundingAdmin,
        isFoundingAdminLoading: onboardingStateLoading,
        isCurrentSpacePersonal: isCurrentSpacePersonal,
        isNewUser: isNewUser,
        isNewUserLoading: isWelcomeFromRovoChatEligibilityLoading,
        spaceKey: spaceKey,
        shouldSkipEligibilityCheck: shouldSkipWelcomeFromRovoChatEligibilityCheck || hasPersonalSpaceDetailsError || Boolean(onboardingStateError)
    });
    const { setOnboardingState: setOnboardingState } = (0, $ivb8S.useSetOnboardingState)();
    (0, $cozmU.useEffect)(()=>{
        const shouldSkipAutoOpen = !welcomeFromRovoChatEligibility.isEligible || onboardingStateLoading || onboardingStateError || hasPreviouslyAutoOpenedWelcomeFromRovoChat || hasAutoOpenedWelcomeFromRovoChatRef.current || !isMiniModalAvailable || isDisabled;
        if (shouldSkipAutoOpen) return;
        if (!(0, $6mKj3.expVal)('cc_ai_growth_welcome_from_rovo', 'isEnabled', false)) return;
        if (mode !== undefined) {
            hasAutoOpenedWelcomeFromRovoChatRef.current = true;
            setOnboardingState({
                key: (0, $dBcar.WELCOME_FROM_ROVO_CHAT).CHAT_AUTO_OPENED,
                value: 'true'
            });
            return;
        }
        const frameId = requestAnimationFrame(()=>{
            if (hasAutoOpenedWelcomeFromRovoChatRef.current) return;
            hasAutoOpenedWelcomeFromRovoChatRef.current = true;
            fireMemorySettingsSpotlightSuppressionTrigger({
                isActive: true
            });
            setWelcomeFromRovoChatUiState({
                isWaitingForWelcomeFromRovoSpotlightAnchor: false,
                shouldUseWelcomeFromRovoChatUi: true
            });
            publishRovo({
                type: 'chat-new',
                source: 'welcome-from-rovo-chat',
                interactionSource: 'welcomeFromRovoChat',
                openChat: true,
                openChatMode: 'mini-modal',
                data: {
                    dialogues: []
                }
            });
            createAnalyticsEvent({
                type: 'sendTrackEvent',
                data: {
                    action: 'autoOpened',
                    actionSubject: 'rovoMiniModal',
                    actionSubjectId: 'welcomeFromRovoChat',
                    source: 'welcomeFromRovoChat',
                    attributes: {
                        pageMode: pageMode,
                        contentType: contentType
                    }
                }
            }).fire();
            setOnboardingState({
                key: (0, $dBcar.WELCOME_FROM_ROVO_CHAT).CHAT_AUTO_OPENED,
                value: 'true'
            });
        });
        return ()=>cancelAnimationFrame(frameId);
    }, [
        hasPreviouslyAutoOpenedWelcomeFromRovoChat,
        isDisabled,
        isMiniModalAvailable,
        mode,
        createAnalyticsEvent,
        pageMode,
        contentType,
        fireMemorySettingsSpotlightSuppressionTrigger,
        publishRovo,
        setOnboardingState,
        welcomeFromRovoChatEligibility.isEligible,
        onboardingStateError,
        onboardingStateLoading
    ]);
    (0, $cozmU.useEffect)(()=>{
        if (mode === 'mini-modal' && shouldUseWelcomeFromRovoChatUi) {
            hasShownWelcomeFromRovoChatUiRef.current = true;
            createAnalyticsEvent({
                type: 'sendUIEvent',
                data: {
                    action: 'shown',
                    actionSubject: 'rovoMiniModalWelcomeUi',
                    actionSubjectId: 'welcomeFromRovoChat',
                    source: 'welcomeFromRovoChat',
                    attributes: {
                        pageMode: pageMode,
                        contentType: contentType
                    }
                }
            }).fire();
        }
    }, [
        contentType,
        createAnalyticsEvent,
        mode,
        pageMode,
        shouldUseWelcomeFromRovoChatUi
    ]);
    (0, $cozmU.useEffect)(()=>{
        if (mode !== 'mini-modal' && hasShownWelcomeFromRovoChatUiRef.current) {
            if (mode === undefined) createAnalyticsEvent({
                type: 'sendUIEvent',
                data: {
                    action: 'closed',
                    actionSubject: 'rovoMiniModal',
                    actionSubjectId: 'welcomeFromRovoChat',
                    source: 'welcomeFromRovoChat',
                    attributes: {
                        pageMode: pageMode,
                        contentType: contentType
                    }
                }
            }).fire();
            hasShownWelcomeFromRovoChatUiRef.current = false;
            setWelcomeFromRovoChatUiState({
                isWaitingForWelcomeFromRovoSpotlightAnchor: mode === undefined && shouldUseWelcomeFromRovoChatUi,
                shouldUseWelcomeFromRovoChatUi: false
            });
        }
    }, [
        contentType,
        createAnalyticsEvent,
        mode,
        pageMode,
        shouldUseWelcomeFromRovoChatUi
    ]);
    (0, $cozmU.useEffect)(()=>()=>{
            if (!hasAutoOpenedWelcomeFromRovoChatRef.current) return;
            fireMemorySettingsSpotlightSuppressionTrigger({
                isActive: false
            });
        }, // Keep suppression for the lifetime of the current page. Including contentId makes this
    // cleanup run for Confluence SPA navigation as well as a full component unmount.
    [
        contentId,
        fireMemorySettingsSpotlightSuppressionTrigger
    ]); // 48px = nav header height, 8px = object sidebar bottom padding, 16px = AI smart button bottom margin, 8px = extra margin so it doesn't align with nav header
    const navbarOffset = 80; // From confluence/next/packages/content-types-header/src/ContentTypesHeader.tsx
    const OBJECT_HEADER_CONTAINER_HEIGHT = 56; // From platform/packages/editor/editor-shared-styles/src/consts/consts.ts
    const FULL_PAGE_EDITOR_TOOLBAR_HEIGHT = 40; // Calculate total vertical offset based on the maximum header height (occurs in edit mode)
    const totalOffset = FULL_PAGE_EDITOR_TOOLBAR_HEIGHT + OBJECT_HEADER_CONTAINER_HEIGHT + navbarOffset; // Memoize analytics attributes to prevent unnecessary re-renders
    const analyticsAttributes = (0, $cozmU.useMemo)(()=>({
            pageMode: pageMode
        }), [
        pageMode
    ]);
    const baseUiConfig = (0, $cozmU.useMemo)(()=>({
            ...customGreeting ? {
                customGreeting: customGreeting
            } : {},
            elements: {
                voiceDictationButton: true,
                ...shouldShowGreeting !== undefined ? {
                    shouldShowGreeting: shouldShowGreeting
                } : {}
            }
        }), [
        customGreeting,
        shouldShowGreeting
    ]);
    const shouldShowWelcomeFromRovoChatUi = shouldUseWelcomeFromRovoChatUi && mode === 'mini-modal';
    const welcomeInitialPromptText = shouldShowWelcomeFromRovoChatUi && (0, $9wGTI.fg)('cc_ai_growth_welcome_from_rovo_gate') ? welcomeFromRovoChatUiConfig.initialPromptText : undefined;
    const uiConfig = (0, $cozmU.useMemo)(()=>{
        if (!shouldShowWelcomeFromRovoChatUi) return baseUiConfig;
        return {
            ...baseUiConfig,
            enableAutoSuggest: false,
            enableMiniModalResize: !(0, $9wGTI.fg)('cc_ai_growth_welcome_from_rovo_gate'),
            customGreeting: welcomeFromRovoChatUiConfig.customGreeting,
            elements: {
                ...baseUiConfig.elements,
                shouldShowGreeting: true,
                shouldShowConversationActions: false,
                shouldShowContextBanner: false
            },
            initialPromptText: welcomeInitialPromptText,
            shouldSeedInitialPromptText: Boolean(welcomeInitialPromptText && welcomeFromRovoChatUiConfig.shouldSeedInitialPromptText)
        };
    }, [
        baseUiConfig,
        shouldShowWelcomeFromRovoChatUi,
        welcomeFromRovoChatUiConfig,
        welcomeInitialPromptText
    ]);
    const overrideMiniModalWrapper = (0, $cozmU.useMemo)(()=>(children)=>{
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
                xcss: $293253fb36609c97$var$styles.smartButtonWrapperStyles
            }, children);
        }, []);
    const fireWelcomeFromRovoSpotlightWhenAnchorReady = (0, $cozmU.useCallback)((elementId)=>{
        const shouldSkipSpotlightTrigger = !isWaitingForWelcomeFromRovoSpotlightAnchor || elementId !== 'rovo-button-onboarding-spotlight' && elementId !== 'rovo-button-onboarding-spotlight-live-or-edit';
        if (shouldSkipSpotlightTrigger) return;
        setWelcomeFromRovoChatUiState((currentState)=>({
                ...currentState,
                isWaitingForWelcomeFromRovoSpotlightAnchor: false
            }));
        if ((0, $6mKj3.expVal)('cc_ai_growth_welcome_from_rovo', 'isEnabled', false)) fireWelcomeFromRovoSpotlightTrigger({
            isActive: true
        });
    }, [
        fireWelcomeFromRovoSpotlightTrigger,
        isWaitingForWelcomeFromRovoSpotlightAnchor
    ]);
    const conversationAssistantConfig = (0, $zCcSI.useConversationAssistantConfig)({
        assistanceServiceConfigHeaders: {
            'x-issynthetic-traffic': 'false'
        },
        preventAbortRequestsOnStagingModalClose: true,
        preventAbortRequestsOnStandaloneChatClose: true
    });
    if (!isEnabled) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4PPzL.ErrorBoundary), {
        attribution: (0, $3IBnw.Attribution).AI_MATE
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jz8lo.RovoRemixActionLauncher), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5760501401d54ef0$export$2b989c5e58d6ba9), {
        product: "confluence",
        cloudId: cloudId,
        orgId: orgId,
        isNav4Enabled: true,
        sidebarApi: sidebarApi,
        productPage: contentType,
        pageMode: pageMode,
        isLiveViewMode: liveViewMode,
        analyticsAttributes: analyticsAttributes,
        isDisabled: isDisabled,
        isSidebarAvailable: isSidebarAvailable,
        topOffset: totalOffset,
        conversationAssistantConfig: conversationAssistantConfig,
        overrideMiniModalWrapper: overrideMiniModalWrapper,
        getActions: getActions,
        prioritizeCustomActionResults: prioritizeCustomActionResults,
        numStartersToShow: numStartersToShow,
        tags: tags,
        uiConfig: uiConfig,
        onAnchorElementReady: fireWelcomeFromRovoSpotlightWhenAnchorReady
    })));
}
module.exports["AISmartButtonWrapper"] = $293253fb36609c97$export$f7d346730580e70;

});

parcelRegister("61R7O", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

const $ed0c4a5f24219ae1$var$AISmartButtonContext = /*#__PURE__*/ (0, $cozmU.createContext)(undefined);
const $ed0c4a5f24219ae1$export$f3b20af08af21b9b = ({ children: children, ...props })=>{
    // We have to use Object.values to compare prop values instead of the props object reference,
    // which changes on every render due to the rest operator. Otherwise, the useMemo would be ineffective
    // since it compares object references, not their contents.
    const contextValue = (0, $cozmU.useMemo)(()=>props, // eslint-disable-next-line react-hooks/exhaustive-deps
    Object.values(props));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($ed0c4a5f24219ae1$var$AISmartButtonContext.Provider, {
        value: contextValue
    }, children);
};
const $ed0c4a5f24219ae1$export$9b0f174637261634 = ()=>{
    const context = (0, $cozmU.useContext)($ed0c4a5f24219ae1$var$AISmartButtonContext);
    if (!context) throw new Error('useAISmartButtonContext must be used within an AISmartButtonProvider');
    return context;
};
module.exports["AISmartButtonProvider"] = $ed0c4a5f24219ae1$export$f3b20af08af21b9b;
module.exports["useAISmartButtonContext"] = $ed0c4a5f24219ae1$export$9b0f174637261634;

});

parcelRegister("eM9tg", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $iTJtk = parcelRequire("iTJtk");


var $9DHhW = parcelRequire("9DHhW");

const $e604e319860047a6$var$ANALYTICS_CHANNEL = (0, $iTJtk.FabricChannel).aiMate;
const $e604e319860047a6$export$8a94e432ef80d839 = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const fireEventWithOptionalChannel = (0, $cozmU.useCallback)((event, product)=>{
        const analyticsEvent = createAnalyticsEvent(event);
        if (product === 'confluence') {
            analyticsEvent.fire();
            return;
        }
        // it goes thru the aiMate analytics listener to avoid validation per product listener
        // https://bitbucket.org/atlassian/atlassian-frontend-mirror/src/f904f690cf57ef84acad6c7bf1b5bd90ad9cada2/analytics/analytics-listeners/src/atlaskit/process-event.ts#lines-58
        analyticsEvent.fire($e604e319860047a6$var$ANALYTICS_CHANNEL);
    }, [
        createAnalyticsEvent
    ]);
    const createEventPayload = (0, $cozmU.useCallback)((payload)=>{
        if (payload.product === 'confluence') // confluence event validation frontend logic
        // https://bitbucket.org/atlassian/atlassian-frontend-monorepo/src/f8bf8ba8c7b54c6e2764d85551b3f989b69d28d8/confluence/next/packages/analytics/src/analyticsListener.tsx#lines-53
        return {
            type: 'sendUIEvent',
            data: payload
        };
        if (payload.product === 'jira') // jira event validation frontend logic
        // https://bitbucket.org/atlassian/atlassian-frontend-monorepo/src/f8bf8ba8c7b54c6e2764d85551b3f989b69d28d8/jira/src/packages/platform/observability/product-analytics-bridge/src/utils/extract-data-from-event.tsx#lines-164
        // it requires to use no more than 4 properties on the top level of event shape for custom event fire.
        return {
            actionSubject: payload.actionSubject,
            action: payload.action,
            actionSubjectId: payload.actionSubjectId,
            attributes: payload.attributes
        };
        // for any other product type we should use the default event shape
        // also if there is a custom event channel, we also should use the default event shape
        return {
            eventType: 'ui',
            ...payload
        };
    }, []);
    const fireRovoButtonUIEvent = (0, $cozmU.useCallback)((eventData)=>{
        // Only fire the event if product is defined
        if (!eventData.product) return;
        const event = createEventPayload(eventData);
        fireEventWithOptionalChannel(event, eventData.product);
    }, [
        fireEventWithOptionalChannel,
        createEventPayload
    ]);
    return {
        fireRovoButtonUIEvent: fireRovoButtonUIEvent
    };
};
module.exports["useRovoButtonEventsInstrumentation"] = $e604e319860047a6$export$8a94e432ef80d839;

});

parcelRegister("fJkiR", function(module, exports) {

let $b73aceca7119722a$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $b73aceca7119722a$var$load("fEWss"),
    $b73aceca7119722a$var$load("ceGPg"),
    $b73aceca7119722a$var$load("ajDCL"),
    $b73aceca7119722a$var$load("6wr18"),
    $b73aceca7119722a$var$load("6HJKX"),
    $b73aceca7119722a$var$load("4XoWv"),
    $b73aceca7119722a$var$load("7yHIY"),
    $b73aceca7119722a$var$load("ffEVr"),
    $b73aceca7119722a$var$load("Wowvf"),
    $b73aceca7119722a$var$load("6vqGz"),
    $b73aceca7119722a$var$load("if60r"),
    $b73aceca7119722a$var$load("abJi5"),
    $b73aceca7119722a$var$load("hhss7"),
    $b73aceca7119722a$var$load("7EorR"),
    $b73aceca7119722a$var$load("ce05o"),
    $b73aceca7119722a$var$load("5novS")
]).then(()=>parcelRequire('eQLS6'));

});

parcelRegister("6dFT0", function(module, exports) {
"use strict";


let $487472ade577be65$var$load = (maxShards)=>(id)=>{
        // eslint-disable-next-line no-undef
        return import((parcelRequire("clX3F")).shardUrl((parcelRequire("1hiTA")).resolve(id), maxShards));
    };
module.exports = $487472ade577be65$var$load;

});

parcelRegister("clX3F", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.applyShardToDomain = $8fe541edd234eb0b$var$applyShardToDomain;
module.exports.domainShardingKey = void 0;
module.exports.getDomainShardIndex = $8fe541edd234eb0b$var$getDomainShardIndex;
module.exports.shardUrl = $8fe541edd234eb0b$var$shardUrl;
module.exports.shardUrlUnchecked = $8fe541edd234eb0b$var$shardUrlUnchecked;
const $8fe541edd234eb0b$var$globalKeyName = '__ATLASPACK_ENABLE_DOMAIN_SHARDS';
/**
 * Extracts the file name from a static asset path.
 * Will throw if the path doesn't have segments or ends in a trailing slash.
 */ function $8fe541edd234eb0b$var$getFilenameFromUrlPath(pathname) {
    const lastSlashIdx = pathname.lastIndexOf('/');
    if (lastSlashIdx === -1 || lastSlashIdx === pathname.length - 1) throw new Error(`Expected an absolute URL with a file name, unable to apply sharding.`);
    // Add 1 to skip over the / itself
    return pathname.slice(lastSlashIdx + 1);
}
/**
 * Generates a bounded numeric hash in [0, maxShards)
 */ function $8fe541edd234eb0b$var$getDomainShardIndex(str, maxShards) {
    // As we include the base domain as a shard option then we add 1 to maxShards
    // to account for that.
    const totalShards = maxShards + 1;
    let shard = str.split('').reduce((a, b)=>{
        const n = (a << totalShards) - a + b.charCodeAt(0);
        // The value returned by << is 64 bit, the & operator coerces to 32,
        // prevents overflow as we iterate.
        return n & n;
    }, 0);
    shard = shard % totalShards;
    // Make number positive
    if (shard < 0) shard += totalShards;
    return shard;
}
const $8fe541edd234eb0b$var$trailingShardRegex = /-\d+$/;
/**
 * Removes trailing shard number from subdomain
 */ function $8fe541edd234eb0b$var$removeTrailingShard(subdomain) {
    if (!$8fe541edd234eb0b$var$trailingShardRegex.test(subdomain)) return subdomain;
    const shardIdx = subdomain.lastIndexOf('-');
    return subdomain.slice(0, shardIdx);
}
/**
 * Given a shard number, inserts that shard in the expected pattern within the
 * domain
 */ function $8fe541edd234eb0b$var$applyShardToDomain(domain, shard) {
    const i = domain.indexOf('.');
    // If the shard is 0, then just use the base domain.
    // If the shard is > 0, then remove 1 as the shards domains index from 0
    const shardSuffix = shard === 0 ? '' : `-${shard - 1}`;
    // Domains like localhost have no . separators
    if (i === -1) return `${$8fe541edd234eb0b$var$removeTrailingShard(domain)}${shardSuffix}`;
    // If this domain already has a shard number in it, strip it
    // out before adding the new one
    const firstSubdomain = $8fe541edd234eb0b$var$removeTrailingShard(domain.slice(0, i));
    return `${firstSubdomain}${shardSuffix}${domain.slice(i)}`;
}
/**
 * Takes an absolute URL and applies a shard to the top level subdomain.
 * The shard number is based on a hash of the file name, which is
 * the content after the last / in the URL.
 *
 * Unlike `shardUrl`, this function will always apply sharding, without any
 * conditional logic.
 */ function $8fe541edd234eb0b$var$shardUrlUnchecked(url, maxShards) {
    const parsedUrl = new URL(url);
    const fileName = $8fe541edd234eb0b$var$getFilenameFromUrlPath(parsedUrl.pathname);
    const shardNumber = $8fe541edd234eb0b$var$getDomainShardIndex(fileName, maxShards);
    parsedUrl.hostname = $8fe541edd234eb0b$var$applyShardToDomain(parsedUrl.hostname, shardNumber);
    return parsedUrl.toString();
}
/**
 * Takes an absolute URL and applies a shard to the top level subdomain.
 * The shard number is based on a hash of the file name, which is
 * the content after the last / in the URL.
 *
 * This function only applies the sharding if the
 * __ATLASPACK_ENABLE_DOMAIN_SHARDS global variable has been set to true
 */ function $8fe541edd234eb0b$var$shardUrl(url, maxShards) {
    // Global variable is set by SSR servers when HTTP1.1 traffic is detected
    if (!globalThis[$8fe541edd234eb0b$var$globalKeyName]) return url;
    return $8fe541edd234eb0b$var$shardUrlUnchecked(url, maxShards);
}
const $8fe541edd234eb0b$var$domainShardingKey = module.exports.domainShardingKey = $8fe541edd234eb0b$var$globalKeyName;

});

parcelRegister("1hiTA", function(module, exports) {
$parcel$export(module.exports, "register", () => $0ee60939fdb4dc28$export$6503ec6e8aabbaf, (v) => $0ee60939fdb4dc28$export$6503ec6e8aabbaf = v);
$parcel$export(module.exports, "resolve", () => $0ee60939fdb4dc28$export$f7ad0328861e2f03, (v) => $0ee60939fdb4dc28$export$f7ad0328861e2f03 = v);
var $0ee60939fdb4dc28$export$6503ec6e8aabbaf;
var $0ee60939fdb4dc28$export$f7ad0328861e2f03;
"use strict";
var $0ee60939fdb4dc28$var$mapping = new Map();
function $0ee60939fdb4dc28$var$register(/** @type {string} */ baseUrl, /** @type {Array<string>} */ manifest // ['id', 'path', 'id2', 'path2']
) {
    for(var i = 0; i < manifest.length - 1; i += 2)$0ee60939fdb4dc28$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $0ee60939fdb4dc28$var$resolve(id) {
    var resolved = $0ee60939fdb4dc28$var$mapping.get(id);
    if (resolved == null) throw new Error('Could not resolve bundle with id ' + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$0ee60939fdb4dc28$export$6503ec6e8aabbaf = $0ee60939fdb4dc28$var$register;
$0ee60939fdb4dc28$export$f7ad0328861e2f03 = $0ee60939fdb4dc28$var$resolve;

});

parcelRegister("dmmOX", function(module, exports) {

let $9b9f082db48dafa2$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $9b9f082db48dafa2$var$load("fEWss"),
    $9b9f082db48dafa2$var$load("ceGPg"),
    $9b9f082db48dafa2$var$load("ajDCL"),
    $9b9f082db48dafa2$var$load("6wr18"),
    $9b9f082db48dafa2$var$load("6HJKX"),
    $9b9f082db48dafa2$var$load("4XoWv"),
    $9b9f082db48dafa2$var$load("7yHIY"),
    $9b9f082db48dafa2$var$load("ffEVr"),
    $9b9f082db48dafa2$var$load("Wowvf"),
    $9b9f082db48dafa2$var$load("6vqGz"),
    $9b9f082db48dafa2$var$load("if60r"),
    $9b9f082db48dafa2$var$load("abJi5"),
    $9b9f082db48dafa2$var$load("hhss7"),
    $9b9f082db48dafa2$var$load("7EorR"),
    $9b9f082db48dafa2$var$load("ce05o"),
    $9b9f082db48dafa2$var$load("aZXJh")
]).then(()=>parcelRequire('12J06'));

});

parcelRegister("kAp8y", function(module, exports) {

let $efcaab1f55716f85$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $efcaab1f55716f85$var$load("fb4GQ").then(()=>parcelRequire('hunmL'));

});

parcelRegister("ExetK", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $fodiz = parcelRequire("fodiz");


var $iMnC5 = parcelRequire("iMnC5");

var $hBYtq = parcelRequire("hBYtq");


var $IQ4Dz = parcelRequire("IQ4Dz");


var $9GVkD = parcelRequire("9GVkD");

/* eslint-disable @atlaskit/design-system/ensure-design-token-usage -- Brand asset colors are intentionally static and not sourced from theme tokens. */ /**
 * Rovo animated logo (TREX-1527).
 *
 * Plays a 2.5s SMIL color-cycle animation on mount and freezes at the canonical
 * "rest" layout (saffron top-right, blue top-left). To re-trigger the animation,
 * give the component a new React `key` at the call site — browsers restart SMIL
 * when the SVG is re-inserted into the DOM:
 *
 *   <RovoAnimatedLogo key={proximityAnimationKey} colorMode={...} />
 *
 * The mouse-proximity handler in `AISmartButton` bumps the key counter each time
 * the cursor enters the proximity radius, which replays the animation cycle.
 *
 * Asset source: `rovo-animation-{light,dark}.svg`, generated from
 * `client/src/components/icons/RovoGlyph.tsx` (variant="full").
 *
 * Note on palette mapping: the LIGHT / DARK constants below are theme-keyed
 * (i.e. LIGHT is used in light mode, DARK is used in dark mode), and the
 * hex values are intentionally kept in sync with the existing static
 * `RovoColorLogo` component. Keeping the two components on the same
 * palette is important — when the proximity animation starts and React
 * swaps `RovoColorLogo` out for `RovoAnimatedLogo`, any mismatch would
 * appear as a one-frame color flash to the user.
 */ 



var $cbY7C = parcelRequire("cbY7C");

/* eslint-disable @atlaskit/design-system/ensure-design-token-usage -- Brand asset colors are intentionally static and not sourced from theme tokens. */ 


const $e660bf13ffeae8d6$var$COLORS = {
    light: {
        blue: '#357DE8',
        green: '#82B536',
        purple: '#BF63F3',
        yellow: '#FCA700'
    },
    dark: {
        blue: '#1868DB',
        green: '#6A9A23',
        purple: '#AF59E0',
        yellow: '#FCA700'
    }
};
const $e660bf13ffeae8d6$export$a6319ea655f8cd28 = ({ colorMode: colorMode })=>{
    const colors = $e660bf13ffeae8d6$var$COLORS[colorMode] ?? $e660bf13ffeae8d6$var$COLORS.light;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true",
        focusable: "false"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M11.2961 15.6713L4.10278 19.8244L2.66999 18.9977C1.82857 18.5126 1.30786 17.6127 1.30786 16.6431V7.36597C1.30786 6.39257 1.82552 5.49654 2.66944 5.01169L8.71294 1.5249C8.69954 1.56253 8.68676 1.60042 8.67462 1.63854C8.56274 1.9857 8.50344 2.35249 8.50344 2.7274V12.0045C8.50344 13.2789 9.18226 14.4544 10.2885 15.0902L11.2961 15.6713Z",
        fill: colors.blue
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M11.2961 15.6714L4.10278 19.8244L10.7097 23.6363C11.5361 24.1127 12.553 24.1212 13.3861 23.6616C13.4012 23.6499 13.4173 23.6391 13.4343 23.6293C14.0279 23.2871 14.462 22.7382 14.6662 22.1042C14.7492 21.8421 14.7932 21.5652 14.7932 21.2817V17.6881L11.2961 15.6714Z",
        fill: colors.green
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M21.4773 5.0024L19.9362 4.11328L12.7429 8.26635L13.8592 8.9101C14.9656 9.54588 15.644 10.7212 15.644 11.9956V21.2728C15.644 21.6482 15.5845 22.0155 15.4723 22.3631C15.4603 22.4007 15.4477 22.4381 15.4345 22.4753L21.478 18.9885C22.3219 18.5036 22.8395 17.6076 22.8395 16.6342V7.35706C22.8395 6.3875 22.3187 5.4875 21.4773 5.0024Z",
        fill: colors.purple
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M12.7406 8.26623L9.35181 6.31195V2.71837C9.35181 2.43521 9.39561 2.15859 9.47851 1.89674C9.68231 1.26299 10.1158 0.714353 10.7088 0.371866L10.7106 0.370829C10.7276 0.361021 10.7438 0.350143 10.7588 0.338447C11.592 -0.121106 12.6089 -0.112663 13.4353 0.363774L19.9339 4.11316L12.7406 8.26623Z",
        fill: colors.yellow
    }));
};


/**
 * Returns true if the user has requested reduced motion via their OS / browser
 * settings (CSS `prefers-reduced-motion: reduce`). Subscribes to live changes
 * so a user flipping the setting mid-session sees the update.
 *
 * The proximity-trigger code in `AISmartButton` already guards against
 * `prefers-reduced-motion` before bumping the React key. This hook is a
 * defense-in-depth check so that any other call site that mounts
 * `RovoAnimatedLogo` directly (tests, Storybook, future reuse) also respects
 * the user's preference.
 */ const $59e0f0cb4a4f2ff1$var$useReducedMotion = ()=>{
    const [reduced, setReduced] = (0, $cozmU.useState)(()=>{
        if (typeof window === 'undefined' || typeof window.matchMedia !== 'function') return false;
        return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    });
    (0, $cozmU.useEffect)(()=>{
        if (typeof window === 'undefined' || typeof window.matchMedia !== 'function') return;
        const mq = window.matchMedia('(prefers-reduced-motion: reduce)');
        const unbind = (0, $cbY7C.bind)(mq, {
            type: 'change',
            listener: (e)=>setReduced(e.matches)
        });
        return unbind;
    }, []);
    return reduced;
};
const $59e0f0cb4a4f2ff1$var$SVG_SIZE = 24;
// Light-mode palette — kept in sync with RovoColorLogo's `light` entry.
const $59e0f0cb4a4f2ff1$var$LIGHT = {
    blue: '#357DE8',
    green: '#82B536',
    purple: '#BF63F3',
    yellow: '#FCA700'
};
// Dark-mode palette — kept in sync with RovoColorLogo's `dark` entry.
const $59e0f0cb4a4f2ff1$var$DARK = {
    blue: '#1868DB',
    green: '#6A9A23',
    purple: '#AF59E0',
    yellow: '#FCA700'
};
const $59e0f0cb4a4f2ff1$export$268fd18f9ecce2c4 = ({ colorMode: colorMode })=>{
    // Hook calls — must all run in the same order every render (Rules of
    // Hooks). Any conditional bailout below MUST come AFTER all hooks.
    const prefersReducedMotion = $59e0f0cb4a4f2ff1$var$useReducedMotion();
    // useId() guarantees per-instance unique SVG <defs> IDs so multiple
    // concurrent renders of this component don't cross-reference each other's
    // masks / gradients (which would silently mis-render).
    const uid = (0, $cozmU.useId)();
    // WCAG 2.3.3: never render the SMIL color-cycle animation for users who
    // have requested reduced motion. Fall back to the existing static
    // RovoColorLogo, which matches the look of the animation's frozen "rest"
    // frame. This is intentionally a defense-in-depth check; the
    // proximity-trigger code in AISmartButton already guards too.
    if (prefersReducedMotion) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $e660bf13ffeae8d6$export$a6319ea655f8cd28), {
        colorMode: colorMode
    });
    // Theme-keyed palette selection. Stay in sync with RovoColorLogo so the
    // two components show identical colors at rest (no flash on swap).
    const c = colorMode === 'dark' ? $59e0f0cb4a4f2ff1$var$DARK : $59e0f0cb4a4f2ff1$var$LIGHT;
    const ID_CLIP = `rg-clip-${uid}`;
    const ID_MASK_LEFT = `rg-mask-left-${uid}`;
    const ID_MASK_RIGHT = `rg-mask-right-${uid}`;
    const ID_GRAD_LEFT = `rg-grad-left-${uid}`;
    const ID_GRAD_RIGHT = `rg-grad-right-${uid}`;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: $59e0f0cb4a4f2ff1$var$SVG_SIZE,
        height: $59e0f0cb4a4f2ff1$var$SVG_SIZE,
        viewBox: "0 0 16 16",
        fill: "none",
        "aria-hidden": "true",
        focusable: "false"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("clipPath", {
        id: ID_CLIP
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("rect", {
        width: "16",
        height: "16"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("mask", {
        id: ID_MASK_LEFT,
        maskUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("rect", {
        width: "16",
        height: "16",
        fill: "black"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        fill: "white",
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M7.53088 10.4476L2.73535 13.2163L1.78016 12.6651C1.21921 12.3417 0.87207 11.7418 0.87207 11.0954V4.91065C0.87207 4.26171 1.21717 3.66436 1.77979 3.34113L5.80879 1.0166C5.79985 1.04169 5.79134 1.06695 5.78324 1.09236C5.70866 1.3238 5.66912 1.56833 5.66912 1.81827V8.00303C5.66912 8.85259 6.12167 9.63627 6.85915 10.0601L7.53088 10.4476Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        fill: "white",
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M7.53088 10.4475L2.73535 13.2162L7.13997 15.7575C7.69088 16.075 8.36884 16.0807 8.92424 15.7743C8.9343 15.7665 8.945 15.7593 8.95634 15.7528C9.35211 15.5246 9.64153 15.1587 9.77761 14.7361C9.83299 14.5613 9.86226 14.3767 9.86226 14.1877V11.792L7.53088 10.4475Z"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("mask", {
        id: ID_MASK_RIGHT,
        maskUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("rect", {
        width: "16",
        height: "16",
        fill: "black"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        fill: "white",
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M14.318 3.33493L13.2907 2.74219L8.49512 5.5109L9.23931 5.94007C9.97691 6.36392 10.4291 7.14744 10.4291 7.99708V14.1818C10.4291 14.4321 10.3895 14.677 10.3147 14.9087C10.3067 14.9338 10.2983 14.9587 10.2895 14.9835L14.3185 12.659C14.8811 12.3357 15.2262 11.7384 15.2262 11.0895V4.90471C15.2262 4.25833 14.879 3.65833 14.318 3.33493Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        fill: "white",
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M8.49356 5.51082L6.23438 4.20796V1.81225C6.23438 1.62347 6.26358 1.43906 6.31885 1.26449C6.45471 0.841993 6.74369 0.476235 7.13903 0.247911L7.14023 0.247219C7.15156 0.240681 7.16234 0.233429 7.1724 0.225631C7.72783 -0.0807372 8.40575 -0.0751089 8.95668 0.242516L13.2891 2.74211L8.49356 5.51082Z"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("linearGradient", {
        id: ID_GRAD_LEFT,
        x1: "0",
        y1: "-33.19",
        x2: "27.7",
        y2: "14.81",
        gradientUnits: "userSpaceOnUse",
        spreadMethod: "repeat"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("stop", {
        offset: "0%",
        stopColor: c.purple
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("stop", {
        offset: "24.999%",
        stopColor: c.purple
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("stop", {
        offset: "25%",
        stopColor: c.yellow
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("stop", {
        offset: "49.999%",
        stopColor: c.yellow
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("stop", {
        offset: "50%",
        stopColor: c.blue
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("stop", {
        offset: "74.999%",
        stopColor: c.blue
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("stop", {
        offset: "75%",
        stopColor: c.green
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("stop", {
        offset: "99.999%",
        stopColor: c.green
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("linearGradient", {
        id: ID_GRAD_RIGHT,
        x1: "0",
        y1: "-37.57",
        x2: "27.7",
        y2: "10.43",
        gradientUnits: "userSpaceOnUse",
        spreadMethod: "repeat"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("stop", {
        offset: "0%",
        stopColor: c.green
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("stop", {
        offset: "24.999%",
        stopColor: c.green
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("stop", {
        offset: "25%",
        stopColor: c.blue
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("stop", {
        offset: "49.999%",
        stopColor: c.blue
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("stop", {
        offset: "50%",
        stopColor: c.yellow
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("stop", {
        offset: "74.999%",
        stopColor: c.yellow
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("stop", {
        offset: "75%",
        stopColor: c.purple
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("stop", {
        offset: "99.999%",
        stopColor: c.purple
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("g", {
        clipPath: `url(#${ID_CLIP})`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("g", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("g", {
        mask: `url(#${ID_MASK_LEFT})`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("g", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("rect", {
        x: "0",
        y: "-63.985208333",
        width: "16",
        height: "191.955625",
        fill: `url(#${ID_GRAD_LEFT})`
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("animateTransform", {
        attributeName: "transform",
        type: "translate",
        values: "0 0; 0 -63.985208333",
        keyTimes: "0; 1",
        keySplines: "0.4 0 0 1",
        calcMode: "spline",
        dur: "2.5s",
        begin: "0s",
        repeatCount: "1",
        fill: "freeze"
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("g", {
        mask: `url(#${ID_MASK_RIGHT})`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("g", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("rect", {
        x: "0",
        y: "-63.985208333",
        width: "16",
        height: "191.955625",
        fill: `url(#${ID_GRAD_RIGHT})`
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("animateTransform", {
        attributeName: "transform",
        type: "translate",
        values: "0 0; 0 63.985208333",
        keyTimes: "0; 1",
        keySplines: "0.4 0 0 1",
        calcMode: "spline",
        dur: "2.5s",
        begin: "0s",
        repeatCount: "1",
        fill: "freeze"
    }))))));
};






const $a23fed72b8123c37$var$message = (0, $kSwu1.defineMessages)({
    rovoButton: {
        id: "ai-smart-button.ai-button.button-label",
        defaultMessage: "Open Rovo Chat"
    }
});
var $a23fed72b8123c37$export$2e2bcd8739ae039 = $a23fed72b8123c37$var$message;


const $778eff67e6919211$var$atlaskitCssStyles = {
    pressableStyles: "_0bjKvDuMRm _3iDTPbQ4SZ _0hPCNLDIqT _37wbyuDIqT _1mT5xdRAKS _0jFU0VpJKa _39xV02pJKa _0KLXrujOvk",
    boxStyles: "_0bjKvDuMRm _23rrnHaO0L _39xV02pJKa _0jFU0VpJKa _3YEZNOdnbC _1mT5xdRAKS _0KLXrugozt _2OUyjtH3uR _1sLQ8qC67X _1B4rbISf8K _3NJLv81VUY _0ReiIH7zJH _46ILVR8W5u",
    boxStyleNoHovers: "_0bjKvDuMRm _23rrnHaO0L _39xV02pJKa _0jFU0VpJKa _3YEZNOdnbC _1mT5xdRAKS _0KLXrugozt _1sLQ8qC67X",
    logoWrapper: "_3iDTPbQ4SZ _0hPCNLDIqT _37wbyuDIqT",
    unreadDot: "_0bjKvDS5Zs _30huDKrh89 _1mT5xdWVPG _2IhTong1xE _4ApkO28HPE _39xV02g1xE _0jFU0Vg1xE _0KLXru9SWg _1pp6NdYbGa",
    awaitingInputIcon: "_0bjKvDS5Zs _30huDKrh89 _3iDTPbQ4SZ _0hPCNLDIqT _37wbyuDIqT _1mT5xdWVPG _2IhTonulbJ _4ApkO2g1xE _39xV02IZbP _0jFU0VIZbP _0KLXrugozt _1pp6NdYbGa"
};
const $778eff67e6919211$export$a51986b9c6d9ac89 = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ onClick: onClick, isDisabled: isDisabled, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, hasUnread: hasUnread, isAwaitingInput: isAwaitingInput, proximityAnimationKey: proximityAnimationKey, isExpandable: isExpandable }, ref)=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const { colorMode: colorMode } = (0, $IQ4Dz.default)();
    return /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        xcss: isExpandable ? $778eff67e6919211$var$atlaskitCssStyles.boxStyleNoHovers : $778eff67e6919211$var$atlaskitCssStyles.boxStyles,
        "data-spotlight-target": "rovo-ai-button"
    }, /*#__PURE__*/ $cozmU.createElement((0, $hBYtq.Pressable), {
        testId: "platform-ai-button",
        xcss: $778eff67e6919211$var$atlaskitCssStyles.pressableStyles,
        onClick: onClick,
        isDisabled: isDisabled,
        onMouseEnter: onMouseEnter,
        onMouseLeave: onMouseLeave,
        onFocus: onMouseEnter,
        onBlur: onMouseLeave,
        ref: ref,
        interactionName: "rovo-button-click"
    }, /*#__PURE__*/ $cozmU.createElement((0, $9GVkD.default), null, formatMessage((0, $a23fed72b8123c37$export$2e2bcd8739ae039).rovoButton)), /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        xcss: $778eff67e6919211$var$atlaskitCssStyles.logoWrapper
    }, proximityAnimationKey !== undefined ? // `key` on the call site is the idiomatic React way to trigger
    // the SMIL animation replay: changing the key remounts the SVG,
    // browsers restart SMIL on insertion. RovoAnimatedLogo doesn't
    // need to know about this mechanism.
    /*#__PURE__*/ $cozmU.createElement((0, $59e0f0cb4a4f2ff1$export$268fd18f9ecce2c4), {
        key: proximityAnimationKey,
        colorMode: colorMode === 'dark' ? 'dark' : 'light'
    }) : /*#__PURE__*/ $cozmU.createElement((0, $e660bf13ffeae8d6$export$a6319ea655f8cd28), {
        colorMode: colorMode === 'dark' ? 'dark' : 'light'
    }))), isAwaitingInput ? /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        xcss: $778eff67e6919211$var$atlaskitCssStyles.awaitingInputIcon,
        testId: "ai-button-awaiting-input-dot",
        "aria-hidden": "true"
    }, /*#__PURE__*/ $cozmU.createElement((0, (/*@__PURE__*/$parcel$interopDefault($fodiz))), {
        label: "",
        color: "var(--ds-icon-information, #357DE8)",
        size: "small",
        testId: "ai-button-awaiting-input-icon"
    })) : hasUnread && /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        xcss: $778eff67e6919211$var$atlaskitCssStyles.unreadDot,
        testId: "ai-button-unread-dot",
        "aria-hidden": "true"
    }));
});
module.exports["AIButton"] = $778eff67e6919211$export$a51986b9c6d9ac89;

});

parcelRegister("4lg64", function(module, exports) {

var $02lCe = parcelRequire("02lCe");

const $eff9935f8aa1e42e$export$aaaa1dfd99a5fa76 = new Set([
    (0, $02lCe.DAILY_BRIEF_NUDGE_ID),
    (0, $02lCe.CONVO_STARTER_ID),
    (0, $02lCe.AUDIO_BRIEFING_ID)
]);
const $eff9935f8aa1e42e$export$a85e93c9055442da = (id, suppressionKey, allowlist = $eff9935f8aa1e42e$export$aaaa1dfd99a5fa76)=>{
    if (!allowlist.has(id)) return null;
    return suppressionKey ? `${id}:${suppressionKey}` : id;
};
module.exports["SUPPRESSION_ALLOWLIST"] = $eff9935f8aa1e42e$export$aaaa1dfd99a5fa76;
module.exports["getSuppressionKey"] = $eff9935f8aa1e42e$export$a85e93c9055442da;

});

parcelRegister("02lCe", function(module, exports) {
const $4e9551ae0b71de55$export$9ccb14fef330e4ca = 'convo-starter';
const $4e9551ae0b71de55$export$117ec3655363b13c = 'summarize-changes-ai-action';
const $4e9551ae0b71de55$export$560e3a8567843c82 = 'daily-brief-nudge';
const $4e9551ae0b71de55$export$7728198680150ac4 = 'jira-board-catch-up-rovo-nudge';
const $4e9551ae0b71de55$export$1ef7a1ab75cdd715 = 'similar-work-items-nudge';
const $4e9551ae0b71de55$export$5aed500badbb741e = 'audio-briefing-ai-action';
const $4e9551ae0b71de55$export$6ca839f71899d7e4 = 'ai-rovo.ai-space-creation-nudge';
const $4e9551ae0b71de55$export$f504b0b55c2bc409 = 'rovo-insights-nudge';
const $4e9551ae0b71de55$export$a0e6743ad4a2d6a8 = 'action-items-nudge-ai-action';
const $4e9551ae0b71de55$export$2f71d683d556ec71 = 'rovo-collab-teammates-fomo-nudge';
module.exports["CONVO_STARTER_ID"] = $4e9551ae0b71de55$export$9ccb14fef330e4ca;
module.exports["SUMMARIZE_CHANGES_ID"] = $4e9551ae0b71de55$export$117ec3655363b13c;
module.exports["DAILY_BRIEF_NUDGE_ID"] = $4e9551ae0b71de55$export$560e3a8567843c82;
module.exports["JIRA_BOARD_CATCH_UP_ID"] = $4e9551ae0b71de55$export$7728198680150ac4;
module.exports["SIMILAR_WORK_ITEMS_ID"] = $4e9551ae0b71de55$export$1ef7a1ab75cdd715;
module.exports["AUDIO_BRIEFING_ID"] = $4e9551ae0b71de55$export$5aed500badbb741e;
module.exports["AI_SPACE_CREATION_NUDGE_ID"] = $4e9551ae0b71de55$export$6ca839f71899d7e4;
module.exports["INSIGHTS_NUDGE_ID"] = $4e9551ae0b71de55$export$f504b0b55c2bc409;
module.exports["ACTION_ITEMS_NUDGE_ID"] = $4e9551ae0b71de55$export$a0e6743ad4a2d6a8;
module.exports["FOMO_NUDGE_ID"] = $4e9551ae0b71de55$export$2f71d683d556ec71;

});

parcelRegister("1j4Hw", function(module, exports) {

let $0f3b364f696cae63$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $0f3b364f696cae63$var$load("lcGTU").then(()=>parcelRequire('9d5IE'));

});

parcelRegister("b5CWo", function(module, exports) {

let $812e5e273eab8296$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $812e5e273eab8296$var$load("6s3kH").then(()=>parcelRequire('5qO2k'));

});


//# sourceMappingURL=ObjectSidebarControl.e02da92d.js.map
